/*
 * Organized alphabetically by file name
 * First is the file name and then the class/component inside the file
 */

import { APP_EMAIL } from '../config';
import { iqcLocaleData } from '../containers/IQCLanding/iqcLocaleData';
import { consultantLandingLocaleData } from '../containers/ConsultantLanding/consultantLandingLocaleData';

export const localeData: any = {
  'zh-tw': {
    ...iqcLocaleData['zh-tw'],

    'account.emailAddress': '電子郵件',
    'password.label': '密碼',
    'password.new.label': '新密碼',

    'field.required': '此欄位為必填',
    'field.email.invalid': '此電子郵件無效',

    'step1.password.strength.veryWeak': '非常弱',
    'step1.password.strength.weak': '弱',
    'step1.password.strength.strong': '強',
    'step1.password.strength.veryStrong': '非常強',

    'step1.password.guidelines.mustHave': '您的密碼必須:',
    'step1.password.guidelines.minimumLength': '至少有8個字元',
    'step1.password.guidelines.notOnlyNumbers': '包含非數字字元',
    'step1.password.guidelines.similarToEmail': '不同於您的電子郵件',
    'step1.password.guidelines.commonPassword': '非常見密碼',

    'field.password.minimumLength': '密碼必須包含至少8個字元',
    'field.password.onlyNumeric': '密碼不能全是數字',
    'field.password.commonPassword': '密碼不能是常用密碼',
    'field.password.similarUserAttributes.email': '密碼不能與您的電子郵件太相似',

    'step5.iHerebyAgree':
      '我在此同意中涉及的個人訊息由WorldQuant及其附屬公司（包括位於美國的公司）按照<PrivacyPolicy>step5.privacy</PrivacyPolicy>中描述的處理目的和方法進行收集和處理。',
    'step5.privacy': '隱私政策',

    'alphathon.already.have.account': '已有帳號? 請<alphathonLinkToSignIn>登入.</alphathonLinkToSignIn>',

    ...consultantLandingLocaleData['zh-tw'],
  },
  'zh-cn': {
    test: 'test zh cn',
    ...iqcLocaleData['zh-cn'],

    'account.emailAddress': '邮箱',
    'password.label': '密码',
    'password.new.label': '新密码',

    'field.required': '必填',
    'field.email.invalid': '此电子邮件无效',

    'step1.password.strength.veryWeak': '非常弱',
    'step1.password.strength.weak': '弱',
    'step1.password.strength.strong': '强',
    'step1.password.strength.veryStrong': '非常强',

    'step1.password.guidelines.mustHave': '密码要求:',
    'step1.password.guidelines.minimumLength': '最少8位',
    'step1.password.guidelines.notOnlyNumbers': '包含非数字',
    'step1.password.guidelines.similarToEmail': '与邮箱不同',
    'step1.password.guidelines.commonPassword': '非常见密码',

    'field.password.minimumLength': '密码必须包含最少8个字符',
    'field.password.onlyNumeric': '密码不得为纯数字',
    'field.password.commonPassword': '请勿使用过于简单和常用的密码',
    'field.password.similarUserAttributes.email': '密码与邮箱过于相似',

    'step5.iHerebyAgree':
      '我特此同意由WorldQuant及其关联公司（包括位于美国的公司）收集和处理本<PrivacyPolicy>step5.privacy</PrivacyPolicy>涉及的个人信息。',
    'step5.privacy': '隐私政策',

    'alphathon.already.have.account': '已经有账户了吗？请在此处<alphathonLinkToSignIn>登录</alphathonLinkToSignIn>',

    ...consultantLandingLocaleData['zh-cn'],
  },
  vi: {
    test: 'test zh vi',
    ...iqcLocaleData['vi'],

    'account.emailAddress': 'Địa chỉ Email',
    'password.label': 'Mật khẩu',
    'password.new.label': 'Mật khẩu mới',

    'field.required': 'Thông tin không được bỏ trống',
    'field.email.invalid': 'Địa chỉ email không hợp lệ',

    'step1.password.strength.veryWeak': 'Rất yếu',
    'step1.password.strength.weak': 'Yếu',
    'step1.password.strength.strong': 'Mạnh',
    'step1.password.strength.veryStrong': 'Rất mạnh',

    'step1.password.guidelines.mustHave': 'Mật khẩu bắt buộc:',
    'step1.password.guidelines.minimumLength': 'Có tối thiểu 8 ký tự',
    'step1.password.guidelines.notOnlyNumbers': 'Bao gồm các ký tự không phải số',
    'step1.password.guidelines.similarToEmail': 'Không giống với địa chỉ email',
    'step1.password.guidelines.commonPassword': 'Không phải mật khẩu phổ biến',

    'field.password.minimumLength': 'Mật khẩu phải có tối thiểu 8 ký tự',
    'field.password.onlyNumeric': 'Mật khẩu không được chứa mỗi số',
    'field.password.commonPassword': 'Mật khẩu không được là mật khẩu phổ biến',
    'field.password.similarUserAttributes.email': 'Mật khẩu không được tương đồng với địa chỉ email',

    'step5.iHerebyAgree':
      'Tôi đồng ý rằng thông tin cá nhân của tôi sẽ được WorldQuant và các công ty liên kết (bao gồm cả những công ty ở Hoa Kỳ) thu thập và xử lý theo mục đích và phương pháp xử lý được mô tả trong <PrivacyPolicy>step5.privacy.2</PrivacyPolicy>',
    'step5.privacy': 'Chính sách quyền riêng tư',
    'step5.privacy.2': 'Chính sách quyền riêng tư.',

    'alphathon.already.have.account': 'Bạn đã có tài khoản? Đăng nhập <alphathonLinkToSignIn>tại đây.</alphathonLinkToSignIn>',

    ...consultantLandingLocaleData['vi'],
  },
  ko: {
    test: 'test zh ko',
    ...iqcLocaleData['ko'],

    'alphathon.openCompetition': '참가신청',
    'alphathon.emailLabel': '이메일',
    'alphathon.passwordLabel': '비밀번호',
    'alphathon.subtitle2': 'WorldQuant BRAIN이 주최하는 2023 {competitionName}에 참가해 퀀트 투자의 세계로 입문해 보세요!',
    'alphathon.timeline': '해당 대회는 <u>{startDate}</u> ~ <u>{endDate}</u> 에 진행됩니다.',
    'alphathon.enrollment.ended': '참가신청은 {signUpEndDate}에 마감됩니다.',
    'alphathon.enrollment.not.started': '참가신청은 {signUpStartDate}에 시작됩니다.',
    'alphathon.competition.ended': '대회는 {endDate}에 종료됩니다.',
    'alphathon.already.have.account':
      '이미 BRAIN 플랫폼 계정이 있으신가요? 그럼 여기서 <alphathonLinkToSignIn>로그인 하세요</alphathonLinkToSignIn>.',

    'account.emailAddress': '이메일 주소',
    'password.label': '패스워드',
    'password.new.label': '새 패스워드',

    'field.required': '필수 입력 항목입니다',
    'field.email.invalid': '유효하지 않은 이메일입니다',

    'step1.password.strength.veryWeak': '매우 약함',
    'step1.password.strength.weak': '약함',
    'step1.password.strength.strong': '강력함',
    'step1.password.strength.veryStrong': '매우 강력함',

    'step1.password.guidelines.mustHave': '패스워드는 다음 규정을 따라야 합니다:',
    'step1.password.guidelines.minimumLength': '최소 8개 글자',
    'step1.password.guidelines.notOnlyNumbers': '숫자가 아닌 글자 포함',
    'step1.password.guidelines.similarToEmail': '가입한 이메일 주소와 달라야 합니다',
    'step1.password.guidelines.commonPassword': '흔한 패스워드는 피해 주세요',

    'field.password.minimumLength': '패스워드는 최소 8자리여야 합니다',
    'field.password.onlyNumeric': '패스워드는 숫자만으로 이루어질 수 없습니다',
    'field.password.commonPassword': '흔하게 쓰이는 패스워드를 사용하지 마십시오',
    'field.password.similarUserAttributes.email': '이메일 계정과 비슷한 패스워드를 사용하지 마십시오',

    'step5.iHerebyAgree':
      '저는 본인의 개인정보가 개인정보 처리방침에 기재된 처리 목적 및 방법에 따라 WorldQuant 및 그 계열사(미국에 소재한 계열사를 포함함)에 의해 수집·처리되는<PrivacyPolicy>step5.privacy</PrivacyPolicy>.',
    'step5.privacy': '것에 동의합니다',

    ...consultantLandingLocaleData['ko'],
  },
  en: {
    test: 'test EN',
    'app.true': 'True',
    'app.ok': 'OK',
    'app.at': 'at',
    'app.score': 'Score',
    'app.alphas': 'Alphas',
    'app.none': 'None',
    'app.rank': 'Rank',
    'app.level': 'Level',
    'app.submit': 'Submit',
    'app.false': 'False',
    'app.yes': 'Yes',
    'app.no': 'No',
    'app.events': 'events',
    'app.accept.join': 'Accept & Join',
    'app.cancel': 'Cancel',
    'app.continue': 'Continue',
    'app.selectAn': 'Select an',
    'app.search': 'Search',
    'alpha.summary': 'Summary',
    'alpha.period': 'Period',
    'testing.status': 'Testing Status',
    'Widgets.widget1.header': 'Creative header EN',
    'app.welcome': 'welcome {name} !',
    'app.counting': 'You have {count, number} {count, plural, one {car} other {cars}}',
    'current.email': 'Current Email',
    'notifications.error.get.last.messages': 'Unable to get the last messages. Please try again later ',
    'notifications.error.get.messages': 'Unable to fetch messages. Please try again later ',
    'notifications.error.get.messages.summary': 'Unable to get message summary. ',
    'notifications.error.mark.messages': 'Unable to mark message as read. Please try again later.',
    'notifications.error.mark.all.messages': 'Unable to mark all message summary.',
    'team.active': 'Active Team',
    'team.past': 'Past Team',
    'team.invites': 'Team Invitations {number}',
    'team.declined': 'Decline',
    'team.user.status.active': 'Active',
    'team.user.status.PENDING': 'Pending',
    'team.user.status.ACCEPTED': 'Accepted',
    'team.user.status.REJECTED': 'Declined',
    'team.member.max.members': '(Max: {maxMembers} members)',
    'team.member.total.members': 'Members ({totalMembers})',
    'flash.message.auth.not-verified':
      'Your account has not been verified yet. ' +
      'You can resend the verification link if you missed the email. ' +
      'Contact support in case of problems.',
    'flash.message.auth.not-verified-link': 'resend the verification link',
    'learn.title': 'Learn',
    'support-link': 'support',
    'flash.message.auth.no-credentials': 'Please enter your email address and password.',
    'flash.message.auth.invalid-credentials':
      'Incorrect email address or password. ' +
      'To protect your security your account will be locked if you enter incorrect information too many times.',
    'flash.message.auth.not-approved': 'Your account has not been approved. Please contact support for further assistance.',
    'flash.message.auth.inactive': 'Your account is locked, due to inactivity. Please contact support for further assistance.',
    'flash.message.auth.disabled': 'Your account is locked, it was disabled by support. Please contact support for further assistance.',
    'flash.message.auth.locked': 'Your account is locked. Please contact support for further assistance.',
    'flash.message.auth.deactivated': 'Your account has been deactivated. Please contact support for further assistance.',
    'flash.message.auth.verificationIncomplete': 'Verification incomplete.',
    'flash.message.auth.recertification-failed':
      'Your account is locked, due to recertification failure. Please contact support for further assistance.',
    'flash.message.auth.consultant-country-change':
      'Your account is locked, due to change of country / region. Please contact support for further assistance.',
    'flash.message.auth.alpha-seller':
      'Your account is locked, it is an alpha seller account. Please contact support for further assistance.',
    'flash.message.auth.throttled': 'Too many sign in attempts. Please try again later.',
    'flash.message.auth.agreement-expired':
      'Your account is locked, due to agreement expiry. Please contact support for further assistance.',
    'flash.message.auth.later': 'Something went wrong, try again later',
    'flash.message.auth.persona.tooManyLogins':
      'You may have exceeded the number of sign-ins allowed today. Please try again tomorrow (UTC timezone) to access your account.',

    'acceptInvitationConfirmModal.title': 'Are you sure you want to accept this invitation?',
    'acceptInvitationConfirmModal.content':
      'You are currently in another team. ' +
      'By accepting this invitation, you will leave your current team and join the new team. ' +
      "If you are the only member in your current team, your current team's Alphas will be merged with the new team. " +
      'If there are other members remaining in your current team, the current team will retain your Alphas that you have created so far, ' +
      'for the scoring of the {competitionName}.',
    'acceptInvitationConfirmModal.accept': 'Accept Invitation',
    'acceptInvitationConfirmModal.cancel': 'Cancel',

    'api.error.brain.unavailable': 'WorldQuant BRAIN is currently down for maintenance. Sign in is disabled. Please check back later.',
    'api.error.brain.experiencing': 'WorldQuant BRAIN is experiencing some difficulties. Please contact support if this problem persists.',

    'api.error.brain.experiencing.link': 'support',
    'api.error.brain.signUpConflict':
      "This email is already registered with WorldQuant BRAIN. If you've forgotten your password, please use forgot password",
    'api.error.brain.signUpConflict.link': 'forgot password',
    'api.error.simulation-post-403': "Can't run multi-simulations",
    'api.error.simulation-post-429':
      'You have reached the limit of concurrent simulations. Please wait for previous simulations to finish.',
    'api.error.simulation-post-429-daily': 'Daily simulation limit reached. Please try tomorrow (EST time zone).',
    'api.error.simulation-post-429.link': 'limit of concurrent simulations',
    'api.error.simulation-post-429-daily.link': 'Daily simulation limit',
    'api.error.simulation-post-503': 'Simulations are currently unavailable. Please contact support if this problem persists.',
    'api.error.simulation-post-503-link': 'support',
    'api.error.simulation-alpha': 'An unknown error has occurred. Please contact support if this problem persists.',
    'api.error.json-parameters-invalid': 'Parameters Invalid from the json',
    'api.error.simulation-later': 'An unknown error has occurred. Please contact support if this problem persists.',
    'api.error.simulation-invalid-settings': 'Some Fields in Settings are invalid',
    'api.error.simulation-python-loops':
      'Simulation timed out. If you are using for loops in Python simulation, consider using numpy instead.',
    'EmailVerifiedAuth401.1': 'The email verification link is not valid, has expired or you might ',
    'EmailVerifiedAuth401.2': 'have already verified your email.',
    'EmailVerifiedAuth401.3': 'Return to your ',
    'EmailVerifiedAuth401.4': 'account',
    'EmailVerifiedAuth401.5': ' to resend the verification email.',
    'alphasAddToList.addAlphaToAList': 'Add Alpha to a List',
    'alphasAddToList.addAlphaToList': 'Add Alpha to List',
    'alphasAddToList.addAlphaToListAndViewList': 'Add Alpha and View List',
    'alphasAddToList.buttonAddtoList': 'Add to List',
    'alphasAddToList.AddAlphaToNewList': 'Add Alpha to New List',
    'alphasAddToList.AddAlphaToNewListAndViewList': 'Add Alpha and View New List',
    'alphasAddToList.description': 'Select from the existing alpha lists or type in a new name to create a new alpha list.',
    'alphasAddToList.createNewList': 'Create a new list',
    'alphasAddToList.selectAnExistingList': 'Select an existing list',
    'alphasAddtoList.placeHolderListName': 'List name',
    'recertify.back.form': 'Back to',
    'step1.change.password': 'Change Password',
    'registrationMain.save': 'Save',
    'step1.download': 'Download',
    'step1.files.upload.accepted': 'Accepted formats: .jpg, .jpeg, .png.',
    'step1.file.upload.size': 'Max file size: 5MB',
    'step1.last-updated': 'Last Updated at ',
    'account.basic.details': 'Sign Up',
    'account.emailAddress': 'Email Address',
    'account.email': 'Email',
    'account.telephone': 'Phone Number',
    'account.countryPhoneMismatch': 'I confirm that I currently reside in {country} and don’t have a valid phone number in {country}',
    'account.presently.employed': 'As an employee, full time consultant or contractor',
    'account.brokerage.employed': 'e.g. insurance brokerage, mutual funds',
    'session.expire.message': 'Your session has expired. Please sign in again.',
    'account.titles.basic.details': 'Recertification - Basic Details',
    'account.titles.location': 'Recertification - Location',
    'account.titles.education': 'Recertification - Education',
    'account.titles.recruitment': 'Recertification - Recruitment',
    'account.titles.employment': 'Recertification - Employment',
    'account.titles.recertify.account': 'Recertification - Recertify Account',
    'account.step.titles.basic.details': 'Basic Details',
    'account.step.titles.location': 'Location',
    'account.step.titles.education': 'Education',
    'account.step.titles.recruitment': 'Recruitment',
    'account.step.titles.employment': 'Employment',
    'account.step.titles.recertify.account': 'Confirm',
    'account.step.titles.access-token': 'Access Token',
    'account.form.back': 'Back',
    'account.form.profile': 'Profile',
    'account.form.account': 'Account',
    'account.form.continue': 'Continue',
    'account.form.recertify.account': 'Recertify Account',
    'account.form.recertify': 'Recertify',
    'account.field.label.country': 'Country / Region of Residence',
    'account.field.message.country': 'The Country / Region you currently live in.',
    'account.field.placeholder.country': 'Select country / region',
    'account.field.label.city': 'City',
    'account.field.label.state': 'State / Province',
    'account.field.label.university': 'University / College / Institution',
    'account.field.info.university': 'If inapplicable, type "Not applicable"',
    'account.field.placeholder.university': 'Select your university',
    'account.field.label.degree': 'Degree',
    'account.field.placeholder.degree': 'Select degree',
    'account.field.label.graduationYear': 'Graduation year',
    'account.field.placeholder.graduationYear': 'Select year',
    'account.field.label.major': 'Major',
    'account.field.label.gpa': 'GPA',
    'account.field.label.maxGPA': 'Max GPA',
    'account.field.label.stem': 'Is your degree considered part of STEM?',
    'account.access-token.button': 'Generate Access Token',
    'account.access-token.new.info':
      'Click the token to copy it to the clipboard. ' +
      'This token will not be accessible again, so please save it somewhere secure. ' +
      'You always have the option to generate a new access token.',
    'account.access-token.new.header': 'New Access Token',
    'account.access-token.info.password':
      'To protect your account, we must verify your identity. Please enter your password to generate a new access token.',
    'account.access-token.info.first':
      'Use an access token to authenticate when using the WorldQuant BRAIN ' +
      "API. The access token improves security for your account since you don't need to record " +
      'your username and password in your scripts.',
    'account.access-token.info.second':
      'You may only have one active access token at a time; generating a new access token will delete any pre-existing access token.',
    'account.recertify.info': 'Please review that all required information is correct.',
    'account.recertify.info-recruitment':
      'This section is optional. Please review that all required information is correct. Updated information can also help us consider you for potential full-time roles.',
    'account.recertify.info-employment':
      'In order to assist us in evaluating your WorldQuant BRAIN application, please provide the following additional information.',
    'account.recertify.info-confirm':
      'By agreeing to the WorldQuant BRAIN terms and conditions, you will be representing ' +
      'that your responses to these questions are accurate. If you have any questions, ' +
      `please contact <linkMailToSupport>${APP_EMAIL}</linkMailToSupport>.`,
    'account.additionalFees':
      'Additional fees may apply. Please contact your wireless provider for information ' +
      'about your messaging rates and plan details. You can opt out of receiving these ' +
      'SMS messages at any time by updating this radio button in your account page. Please ' +
      'note it may take several days for this to take effect.',
    'account.scienceTechnology': 'Science, Technology, Engineering and Mathematics',
    'account.field.label.presently_employed':
      'Are you presently employed, or engaged as a consultant or contractor by a firm (other than WorldQuant LLC)?',
    'account.field.label.employer': '1. What is the name of your employer?',
    'account.field.label.business': '2. What is your employer’s primary business?',
    'account.field.label.title': '3. What is your job title?',
    'account.field.label.description': '4. Please provide a description of your role.',
    'account.field.label.participationPermitted':
      '5. Is your participation in WorldQuant BRAIN (including submission of alphas) ' +
      "permissible under the terms of your employment and your employer's policies and procedures?",
    'account.field.label.nonPublicInformation':
      '6. In your role, do you have access to non-public information of or related to publicly traded companies?',
    'account.field.info.nonPublicInformation':
      'Inside Information is material, non-public information about a security. Non-public ' +
      'means the information has not been disseminated through a recognized channel or distribution. Material means any reasonable ' +
      'shareholder would consider the information important in making an investment decision regarding the security. If you have access ' +
      'to such potentially material, non-public information due to your current position in your firm or company, you must answer "yes" ' +
      'to this item.',
    'account.field.label.finance': '7. Is your employer in the financial service industry?',
    'account.field.info.finance': 'E.g. an asset manager, broker-dealer, bank or other firm engaged in investment-related activities',
    'account.field.label.investmentAdvisory': '7a. Does your employer provide/engage in investment advisory/asset management?',
    'account.field.label.investmentAdvisoryWizard': '7(a) Does your employer provide/engage in investment advisory/asset management?',
    'account.field.label.brokerage': '7b. Does your employer engage in brokerage?',
    'account.field.label.brokerageWizard': '7(b) Does your employer engage in brokerage?',
    'account.field.label.fundamentalResearch': '7c. Does your employer engage in fundamental research?',
    'account.field.label.fundamentalResearchWizard': '7(c) Does your employer engage in fundamental research?',
    'account.field.label.proprietaryTrading': '7d. Does your employer engage in proprietary trading?',
    'account.field.label.proprietaryTradingWizard': '7(d) Does your employer engage in proprietary trading?',
    'account.field.info.serviceEngagement':
      'If Yes, please indicate which such services your employer provides. e.g. sales of ' +
      'financial datasets, or N/A if not applicable.',
    'account.field.info.serviceEngagementWizard':
      'Please indicate which such services your employer provides. e.g. sales of financial datasets, or N/A if not applicable.',
    'account.field.label.serviceEngagement':
      '8. Does your employer engage in algorithmic, computer-based or similar trading or ' +
      'related services (e.g. algo design, trading infrastructure support, etc.)?',
    'account.field.label.exposureStatus':
      '9. If you answered yes to any item in question 7 or 8 above, is your role (or have you ' +
      'in the past had a role) related to the service or activity you indicated, or do you have (or have you in the past had) access to ' +
      'information related to such services/activities?',
    'account.field.info.exposureStatus': 'If Yes, please provide an explanation. Type N/A if not applicable.',
    'account.field.info.exposureDetailsWizard': 'Please provide an explanation. Type N/A if not applicable.',
    'account.field.info.exposureStatusWizard':
      '9. Is your role (or have you in the past had a role) related to the service or activity you indicated above, or do you have (or have you in the past had) access to information related to such services/activities?',
    'account.field.label.englishProficiency': 'Rate your English proficiency',
    'account.field.info.englishProficiency': 'Rate your English proficiency',
    'account.proficiencyLevel.high': 'High',
    'account.proficiencyLevel.medium': 'Medium',
    'account.proficiencyLevel.low': 'Low',

    'account.field.label.codingProficiency': 'Rate your coding proficiency',
    'account.field.info.codingProficiency': 'Rate your coding proficiency',
    'account.field.label.roles': 'Which roles interest you? (Select all that apply)',
    'account.field.info.roles': 'Which roles interest you? (Select all that apply)',
    'account.roles.research': 'Research',
    'account.roles.business': 'Business',
    'account.roles.technology': 'Technology',

    'account.field.label.resume': 'Upload your up-to-date CV in English',
    'account.field.info.resume': 'Accepted formats: PDF, DOC, DOCX.',
    'account.GetMetadada.sign-up': "At the moment isn't possible to sign up.",
    'account.GetMetadada.sign-edit': "At the moment isn't possible to edit your account.",
    'account.GetMetadada.recertify': 'Accepted formats: PDF, DOC, DOCX.',
    'account.referrer.message':
      'Optional field. Enter the User ID of the person who referred you to WorldQuant BRAIN. E.g. AB12345. Or else leave it blank',
    'account.referrer.messageWizard':
      'Enter the User ID of the person who referred you to WorldQuant BRAIN. E.g. AB12345. Or else leave it blank',
    'account.referrer': 'User ID of Referrer',
    'account.referrerToggle': 'I have Referral User ID',
    'account.photo': 'Profile photo',
    'account.photo.current': 'Current photo',
    'account.photo.new': 'New photo',
    'account.photo.no': 'No photo uploaded',
    'account.photo.remove': 'Remove',

    'account.photo.public': 'Do you agree to show your photo in public pages?',

    'account.crop': 'Crop',
    'account.crop.header': 'Crop photo',
    'account.crop.zoom': 'Zoom:',
    'account.crop.close': 'Close',

    'referrer.modal.title': 'Were you referred to WorldQuant BRAIN by a friend or colleague?',
    'referrer.modal.text': 'If so, please enter the email of the person who referred you to WorldQuant BRAIN.',
    'referrer.modal.btn.not.referred': 'I was not referred',
    'referrer.add.success': 'Referrer added with success',
    'event.you.time': 'Your Time',
    'event.local.time': 'Local Time',
    'event.hours': '{hours} {hours, plural, one {Hr. } other {Hrs. }}',
    'event.minutes': '{minutes} {minutes, plural, one {Min. } other {Mins. }}',
    'event.error.info': ' cannot display event info',
    'password.confirm.label': 'Confirm Password',
    'password.label': 'Password',
    'password.new.label': 'New Password',
    'password.show': 'Show password',
    'password.hide': 'Hide password',
    'field.maxgpa.greater.gpa': 'Max GPA should be greater than or equal to GPA',
    'field.match.password.failure': "Password doesn't match.",
    'field.email.invalid': 'The email is invalid',
    'field.userid.invalid': 'The user id is invalid',
    'field.required': 'This field is mandatory',
    'field.required.100.characters': 'Ensure this field has at least 100 characters.',
    'field.required.powerPool': 'Ensure the description is following the provided template.',
    'field.match.current.email': 'New email must be different from current email.',
    'field.phone.required': 'Please enter your phone number.',
    'field.phone.wrong.number': 'Invalid phone number. Please include country / region code (e.g. +1-XXX-XXX-XXXX)',
    'field.alphabetic.error': 'Only alphabetic characters, -, ., and , are allowed',
    'field.addressValidation.error': 'Only alphanumeric characters, -, ., and , are allowed',
    'field.password.minimumLength': 'Password must contain at least 8 characters',
    'field.password.onlyNumeric': 'Password cannot be entirely numeric',
    'field.password.commonPassword': 'Password cannot be a commonly used password',
    'field.password.similarUserAttributes.email': 'Password cannot be too similar to your email',
    'field.password.similarUserAttributes.lastName': 'Password cannot be too similar to your last name',
    'field.password.similarUserAttributes.firstName': 'Password cannot be too similar to your first name',
    'field.firstName.similarToPassword': 'Password cannot be too similar to your first name, please {changePassword}',
    'field.lastName.similarToPassword': 'Password cannot be too similar to your first name, please {changePassword}',

    'input.search.main.placeholder': 'Search Topics, concepts, questions, courses',
    'api.learn.invalid.term': 'Searched term is invalid, is empty',

    'authentication.email.field.error': 'Email field empty',
    'authentication.email.field.invalid': 'Invalid Email',
    'authentication.password.field.error': 'Password field empty',
    'authentication.password.capsLockOn': 'Alert: CAPS LOCK IS ON!',
    'authentication.password.confirmation.field.error': 'Password confirmation empty',
    'authentication.password.confirmation.not.equal.field.error': "Password and Password confirmation don't match",

    'enrolled.with.success': 'You are now enrolled in {competitionName}',

    'alphasCode.code': 'Code',
    'alphasCode.cloneAlpha': 'Clone Alpha',
    'alphasCode.simulationSettings': 'Simulation Settings',
    'simulation.settings.saved.default.settings.message': 'Successfully Saved Default Settings',
    'simulation.get.settings': "It wasn't possible to get the required configuration data, try again later",
    'app.anonymous': 'anonymous',
    'app.current': 'current',
    'alphasComparisonMain.comparisonChart': 'Comparison Chart',
    'alphasComparisonMain.innerCorrelation': 'Inner Correlation',
    'alphasComparisonMain.needHelp': 'Need help reading this chart?',
    'alphasComparisonMain.renameList.submitNewName': 'Submit New Name',
    'alphasComparisonMain.tableTitle.deleteList': 'Delete List',
    'alphasComparisonMain.tableTitle.renameList': 'Rename List ',
    'edit.password.success': 'Your password has been changed.',
    'edit.password.failure.required': 'Field Required.',
    'edit.password.current.error': 'The current password is invalid.',
    'api.password.invalid': 'The password is invalid.',
    'edit.password.failure.match': "Password doesn't match.",
    'edit.password.not.match': 'Current password must be different from new password',
    'edit.password.failure': "It wasn't possible to change your the password. Try again later.",

    'alphasDetails.openAlphaDetails': 'Open alpha details in new tab',
    'alphasDetails.headerAlphasDetails.addToList': 'Add to List',
    'alphasDetails.headerAlphasDetails.created': 'Created',
    'alphasDetails.footerAlphasDetails.checkSubmission': 'Check Submission',
    'alphasDetails.footerAlphasDetails.submitAlpha': 'Submit Alpha',
    'alphasDetails.stage.os': 'OS',
    'alphasDetails.stage.is': 'IS',
    'alphasDetails.settings.code': 'Code',
    'alphasDetails.settings.selectedAlphas': 'Selected Alphas',
    'alphasDetails.settings.summary': 'Summary',
    'alphasDetails.settings.correlation': 'Correlation',
    'alphasDetails.settings.performanceComparison': 'Performance Comparison',
    'alphasDetails.title.selected.alphas': 'Selected Alphas',
    'alphasDetails.title.num.selected.alphas': '<b>{numAlphasSelected}</b> Alphas have been selected',
    'alphasDetails.title.view.all': 'View all',
    'alphasDetails.status.decommissioned': 'DECM',
    'alphasDetails.status.active': 'ACTV',
    'alphasDetails.status.submitted': 'SUB',
    'alphasDetails.status.unsubmitted': 'UNSUB',
    'alphaDetails.revealTestPeriod': 'Show test period',
    'alphaDetails.hideTestPeriod': 'Hide test period',
    'alphaDetails.testPeriodExplanation': 'Test period and overall stats are hidden by default when test period is specified.',

    'is.performance.comparison': 'IS Performance After Submission ({partitions} alphas)',
    'is.performance.comparison.subtitle':
      'Combined performance data is shown for all {partitions} alphas.' +
      ' Submitting this alpha will not effect the combined performance of your other alphas.',
    'is.performance.comparison.pnl': 'PnL',

    'alphasDetails.title.performance-comparison': 'Performance Comparison',
    'alphasDetails.performance-comparison.score.title': 'Delay-{delay} Score',
    'alphasDetails.performance-comparison.datafieldsScore.title': 'Delay-{delay} Data Fields Score',
    'alphasDetails.performance-comparison.weeklyScore.title': 'Delay-{delay} Weekly Score',
    'alphasDetails.performance-comparison.robustnessScore.title': 'Delay-{delay} Robustness Score',
    'alphasDetails.team.score': ' ',

    'alphas.details.run': 'Chart',

    'no.selected.alphas': 'No alphas selected',

    'alphasDetails.settings.chart': 'Chart',
    'alphasDetails.settings.testingStatus': 'Testing Status',
    'alphasDetails.settings.properties': 'Properties',
    'alphasDetails.settings.reset': 'Reset',
    'alphasDetails.settings.apply': 'Apply',
    'alphasDetails.settings.title': 'Customize Alpha Details Menu',
    'alphasDetails.settings.subtitle': 'Drag the containers to rearrange the Alpha details menu.',
    'alphasList.selectColumns': 'Select Columns',
    'alphasMain.alphaListButons.compareAlphas': 'Compare Alphas',
    'alphasMain.cardRightElemHeader.deleteList': 'Delete List',
    'alphasMain.cardRightElemHeader.renameList': 'Rename List',
    'alphasMain.renameList.placeHolderNameNewList': 'Name new list',
    'alphasMain.renameList.submiteNewName': 'Submit New Name',

    'alphasMain.created.list': 'Alphas List created with success',
    'alphasMain.updating.list': 'Alphas List updated with success',
    'alphasMain.updating.list.error': 'Some error occurred updating User List, please try again later.',
    'alphasMain.adding.list.error': "It wasn't possible adding alpha to the list.",
    'alphasMain.already.exists': 'Alpha already exists in this list try in another',

    'alphasMenu.alphaListsSubMenu.alphaLists': 'Alpha Lists',
    'alphasMenu.alphaListsSubMenu.alphaDistribution': 'Alpha Distribution',
    'alphasMenu.optionsSubMenu.none': 'None',
    'alphasMenu.optionsSubMenu.placeHolderSetColor': 'Set Color',
    'alphasMenu.title.alphas': ' Alphas',
    'alphasMenu.title.selected.alphas': ' Selected Alphas',
    'alphasMenu.title.is': 'IS:',
    'alphasMenu.title.os': 'OS:',
    'alphasMenu.title.unsubmitted': 'Unsubmitted:',
    'alphasMenu.title.active': 'Active:',
    'alphasMenu.title.decommissioned': 'Decommissioned:',
    'alphasMenu.title.total': 'Total:',

    'alphas.performance.before': 'Before Submission',
    'alphas.performance.after': 'After Submission',
    'alphas.performance.change': 'Change',

    'alphas.last.run': 'Last Run',

    'alphas.table.error': "The size of the table isn't valid, please try a value between 1 and {count, number}",

    'alphas.title.list': 'List {tableName}',
    'alphas.title.super.alpha': 'SuperAlpha {tableName}',

    'alphaPage.alphaHeader.addToList': 'Add to List',
    'alphaPage.alphaHeader.created': 'Created',
    'aplhaPage.alphaHeader.is': 'IS',
    'alphaPage.noResults': 'Alpha with this ID does not exist or belongs to another user.',

    'alphaTags.show': 'Showing',
    'alphaTags.user.lists.error': 'There was an error retreiving the user lists.',
    'alphaTags.user.list.error': 'There was an error retreiving the list of tags.',
    'alphaTags.create.error': 'There was an error creating the alphas list.',
    'alphaTags.delete.error': 'There was an error deleting the alphas list.',

    'alphas.invalid.filters': 'There is an invalid filter.',

    'alpha.example.title': 'Example Alpha',
    'alpha.example.clone': 'Clone Example Alpha',

    'learn.cloneAlpha': 'Open example alpha in Simulate',
    'learn.invalid.faq': 'Invalid Faq please try another',
    Name: 'Name',
    Universe: 'Universe',
    Sharpe: 'Sharpe',
    Turnover: 'Turnover',
    Fitness: 'Fitness',
    Returns: 'Returns',
    Drawdown: 'Drawdown',
    Margin: 'Margin',

    'alpha.code.region': 'Region',
    'alpha.code.universe': 'Universe',
    'alpha.code.universeOverride': 'Universe Override',
    'alpha.code.language': 'Language',
    'alpha.code.decay': 'Decay',
    'alpha.code.delay': 'Delay',
    'alpha.code.truncation': 'Truncation',
    'alpha.code.neutralization': 'Neutralization',
    'alpha.code.instrumentType': 'Instrument Type',
    'alpha.code.pasteurization': 'Pasteurization',
    'alpha.code.nanHandling': 'NaN Handling',
    'alpha.code.unitHandling': 'Unit Handling',
    'alpha.code.lookback': 'Lookback',
    'alpha.code.maxTrade': 'Max Trade',
    'alpha.code.maxPosition': 'Max Position',
    'alpha.code.name': 'Name',
    'alpha.code.sharpe': 'Sharpe',
    'alpha.code.turnover': 'Turnover',
    'alpha.code.returns': 'Returns',
    'alpha.code.fitness': 'Fitness',
    'alpha.code.margin': 'Margin',
    'alpha.code.componentActivation': 'Component Activation',

    'authenticationMain.email': 'Email',
    'authenticationMain.forgotPassword': 'Forgot password',
    'authenticationMain.password': 'Password',
    'authenticationMain.signIn': 'Sign In',
    'authenticationMain.biometric.registration': 'Biometric Sign-In',
    'authenticationMain.biometric.explanation': 'In order to ensure your security we require you to take a selfie.',
    'authenticationMain.biometric.faceInCircle': 'Please take a photo with your face inside the circle.',
    'authenticationMain.biometric.usage': 'WorldQuant only uses these photos for authentication purposes.',
    'authenticationMain.biometric.takePhoto': 'Take Photo',
    'authenticationMain.biometric.retakePhoto': 'Retake Photo',
    'authenticationMain.biometric.incorrectPhoto':
      'Could not verify photo. Please make sure your face is in in the photo and no other faces are visible.',
    'authenticationMain.biometric.cancelled': `Please go through photo identification. If you have any questions,\
        please contact <linkMailToSupport>${APP_EMAIL}</linkMailToSupport>`,
    'authenticationMain.biometric.register': 'Register biometric',
    'authenticationMain.biometric.authentication': 'Biometric Authentication',
    'authenticationMain.biometric.authenticationExplanation':
      'In order to ensure your security we require you to sign-in using biometric authentication',
    'authenticationMain.biometric.authenticationSignIn': 'Sign-in with biometric key',
    'authenticationMain.biometric.needWebcam': 'We need a webcam to authenticate you during sign-in.',
    'authenticationMain.biometric.learnHow': 'To learn how to do it, follow ',
    'authenticationMain.biometric.thisLink': 'this link',
    'authenticationMain.biometric.dot': '.',
    'authenticationMain.biometric.reloadPage': 'Reload the page once webcam is enabled.',

    'authenticationMain.without.account': 'Don’t have an account?',
    'authenticationMain.signUp': 'Sign up here.',
    'authenticationMain.havingTroubles': 'Having trouble signing in?',
    'authenticationMain.contactUs': 'Contact support',

    'competitionsGuidelinesModal.guidelinesTag': 'Guidelines',
    'competitionsGuidelinesModal.consultantGuidelinesTag': 'Consultant',
    'competitionsGuidelinesModal.globalCompetitionGuidelines': 'Global Competition Guidelines',
    'competitionsGuidelinesModal.forBetterCompetion': 'For better competition experience, please keep your ',
    'competitionsGuidelinesModal.account': 'Account',
    'competitionsGuidelinesModal.informationUpdated': ' information (like University, City, Country) updated.',
    'competitionsGuidelinesModal.agreeToPaticipate': 'I agree to participate in the competition pursuant to the above guidelines',
    'competitionsGuidelinesModal.iAgree': 'I agree',

    'competitionsMain.selectColumns': 'Select Columns',
    'competitions.me': ' (Me)',
    'competitions.me.row': '{user} (Me)',
    'competitions.users.modal.table': '{filter}s from {value}',
    'competitions.users.modal.table.no.value': '{filter}s By Country / Region',
    'competitions.consultant': 'Consultant Leaderboard',
    'competitions.consultant-leaderboard': 'Consultant Leaderboard',
    'competitions.consultant.researcher': 'Consultant (BRAIN Researcher)',
    'competitionsMain.modalAggregation.usersFrom': '{filter}s from',

    'competitions.table.interim': 'Interim',

    'competitionMenu.filterMenu.apply': 'Apply',
    'competitionMenu.filterMenu.reset': 'Reset',
    'competitionMenu.menuFooter.aggregateBy': 'Aggregate by:',
    'competitionMenu.menuFooter.filter': 'Filter',
    'competitionMenu.optionsSubMenu.info': 'Info',
    'competitionMenu.menuFooter.filterBy': 'Filter By',
    'competitionMenu.table.ongoing': 'Ongoing',
    'competitionMenu.filterMenu.team': 'Team',
    'competitionMenu.filterMenu.user': 'User',
    'competitionMenu.filterMenu.noResults': 'No results',
    'competitionMenu.filterMenu.shortQuery': 'Type more to see options',

    'competitionMenu.table.competition': 'Competition',
    'competitionMenu.table.status': 'Status',
    'competitionMenu.table.rank': 'Rank',
    'competitionMenu.table.startDate': 'Start Date',
    'competitionMenu.table.endDate': 'End Date',
    'competitionMenu.boardName': 'Board Name:',

    'competitionsAll.all': 'All',
    'competitionsAll.active': 'Active',
    'competitionsAll.concluded': 'Concluded',

    'competitions.enroll': 'Enroll',
    'competitions.currentLevel': 'Level',
    'competitions.points': 'pt',
    'competitions.remaining': 'pt until next level',
    'competitions.score': 'Score',
    'competitions.nextLevel': 'Next Level',

    'competitions.consultant.challenge.lock': 'Your level and score are locked',
    'competitions.consultant.score.lock': 'Your score is locked',
    'competitions.consultant.challenge.cannot-participate': 'Consultants cannot participate',
    'competitions.researcher.challenge.lock': 'Your level and score are locked',
    'competitions.researcher.score.lock': 'Your score is locked',
    'competitions.researcher.challenge.cannot-participate': 'Researchers cannot participate',
    'competitions.message.date': 'Competition {count, plural, one {starts} other {started}} on {startDate}',
    'competitions.message.dateEnd': 'Competition {count, plural, one {ends} other {ended}} on {startDate}',
    'competitions.message.ended': 'Competition ended on {startDate}',
    'competitions.message.ended.nextStage':
      'Competition ended on {startDate}. <linkComponent>Go to stage {nextStage} leaderboard</linkComponent>',
    'competitions.message.ended.nextStage.result':
      'Competition ended on {startDate}. The <linkComponent>results</linkComponent> have been announced.',
    'competitions.message.ended.nextStage.not.ready':
      'Competition ended on {startDate}. Stage {nextStage} will start on {nextStageStartDate}.',
    'competitions.message.ended.nextStage.leaderboard.not.ready':
      'Competition ended on {startDate}. Stage {nextStage} leaderboard will be published on {nextStageStartDate}.',
    'competitions.message.restricted': 'You are restricted from this competition',
    'competitions.message.missed.enrollment': 'You missed the enrollment period.',
    'competitions.message.concluded': 'This competition has concluded',
    'competitions.message.concluded.nextStage':
      'This competition has concluded. <linkComponent>Go to stage {nextStage} leaderboard</linkComponent>',
    'competitions.message.concluded.nextStage.result':
      'This competition has concluded. The <linkComponent>results</linkComponent> have been announced.',
    'competitions.message.concluded.nextStage.not.ready':
      'This competition has concluded. Stage {nextStage} will start on {nextStageStartDate}.',
    'competitions.message.concluded.nextStage.leaderboard.not.ready':
      'This competition has concluded. Stage {nextStage} leaderboard will be published on {nextStageStartDate}.',
    'competitions.message.enroll': 'You are enrolled',
    'competitions.message.not.enroll': 'You were not enrolled',
    'competitions.message.consultant.restricted': 'Consultants are restricted from this competition',
    'competitions.message.researcher.restricted': 'Researchers are restricted from this competition',

    'enrollment.not.started': 'Enrollment for {competition} has not started.',
    'enrollment.ended': 'Enrollment for {competition} has ended.',

    'competitions.banner.date': 'This competition starts on {startDate} at {startHour} and ends on {endDate} at {endHour}.',
    'competitions.banner.enroll.open.competition.not.started':
      'This competition starts on {startDate} at {startHour} and ends on {endDate} at {endHour}.' +
      ' The enrollment period ends on {signUpEndDate} at {signUpEndHour}. Enroll here.',
    'competitions.banner.enroll.closed.competition.not.started':
      'This competition starts on {startDate} at {startHour} and ends on {endDate} at {endHour}. The enrollment period has ended.',
    'competitions.banner.enroll.not.started.competition.not.started':
      'This competition starts on {startDate} at {startHour} and ends on {endDate} at {endHour}.' +
      ' The enrollment period has not started.',
    'competitions.banner.enroll.open.competition.started':
      'This competition started on {startDate} at {startHour} and ends on {endDate} at {endHour}.' +
      ' The enrollment period ends on {signUpEndDate} at {signUpEndHour}. Enroll here.',
    'competitions.banner.enroll.closed.competition.closed':
      'This competition started on {startDate} at {startHour} and ended on {endDate} at {endHour}.',
    'competitions.banner.enroll.closed.competition.closed.nextStage':
      'This competition started on {startDate} at {startHour} and ended on {endDate} at {endHour}. ' +
      '<linkComponent>Go to stage {nextStage}</linkComponent>',
    'competitions.banner.enroll.closed.competition.closed.nextStage.result':
      'This competition started on {startDate} at {startHour} and ended on {endDate} at {endHour}. ' +
      'The <linkComponent>results</linkComponent> have been announced.',
    'competitions.banner.enroll.closed.competition.started':
      'This competition started on {startDate} at {startHour} and ends on {endDate} at {endHour}.',

    'competitions.banner.enrolled.competition.not.started':
      'This competition starts on {startDate} at {startHour} and ends on {endDate} at {endHour}.' +
      ' The enrollment period ends on {signUpEndDate} at {signUpEndHour}.',
    'competitions.banner.enrolled.closed.competition.not.started':
      'This competition starts on {startDate} at {startHour} and ends on {endDate} at {endHour}.',
    'competitions.banner.enrolled.open.competition.started':
      'This competition started on {startDate} at {startHour} and ends on {endDate} at {endHour}.',
    'competitions.banner.enroll.open.competition.started.restricted':
      'This competition started on {startDate} at {startHour} and ends on {endDate} at {endHour}.' +
      ' The enrollment period ends on {signUpEndDate} at {signUpEndHour}',
    'competitions.banner.enrolled.closed.competition.started':
      'This competition started on {startDate} at {startHour} and ends on {endDate} at {endHour}.',
    'competitions.banner.startDate': 'Start Date',
    'competitions.banner.endDate': 'End Date',

    'competitions.interval.time.banner.enroll.button': 'Enroll here',
    'competitions.honor.rookie': 'Rookie',
    'competitions.honor.experienced': 'Experienced',
    'competitions.prize': 'Weekly Prizes',
    'competitions.leaderboard': 'Leaderboard',
    'competitions.leaderboard.alt': 'Team Leaderboard',
    'competitions.leaderboard.notAvailable': 'N/A',
    'competitions.university': 'University Leaderboard',
    'competitions.submissions': 'Submissions',
    'competitions.guideLines': 'Guidelines',
    'competitions.referrals': 'Referral Leaderboard',
    'competitions.powerPool': 'Power Pool Leaderboard',
    'competitions.spcLeaderboard': 'Systematic Predictions Challenge',
    'competitions.spcLeaderboard.promptSubmissionsLink': 'Prompt Submissions',
    'competitions.faq': 'FAQ',
    'competitions.pythonGuide': 'Python Guide',
    'allCompetitions.leaderboards.title': 'Consultant Leaderboards',

    'chart.1': 'Chart',
    'chart.2': 'Need help reading this chart?',
    'chart.noResults.alphas': 'Chart not available, please clone this alpha and re-simulate.',
    'chart.noResults': 'No data available.',

    'summary.noResults.alphas': 'Summary not available, please clone this alpha and re-simulate.',
    'summary.noYearlyResults.alphas': 'Yearly summary not available, please clone this alpha and re-simulate.',
    'summary.noYearlyResults': 'Yearly summary not available.',

    'codeEditor.cloneThisAlpha': 'Clone this Alpha in a new tab',
    'codeEditor.cloneThisAlpha.mobile': 'Clone',
    'codeEditorActionBar.allTabs': 'All Tabs',
    'codeEditorActionBar.example': 'Example',
    'codeEditorActionBar.simulate': 'Simulate',
    'codeEditorActionBar.single': 'Single',
    'codeEditorActionBar.verify': 'Verify',

    'codeEditor.multi.simulation.disabled.1': 'Multi-simulations are not available on mobile devices.',
    'codeEditor.multi.simulation.disabled.2': 'Please use a device with a bigger screen to use this feature. ',

    'correlation.1': 'Correlation',
    'correlation.no.options': "Alphas options aren't available please try again later",
    'correlation.self.noResults': 'There are no self-correlated alphas.',
    'correlation.prod.noResults': 'There are no prod-correlated alphas.',
    'correlation.self.invalidPnl': 'Invalid alpha PnL.',
    'correlation.prod.invalidPnl': 'Invalid alpha PnL.',

    'correlation.correlationMain.maxCorrelation': 'Maximum',
    'correlation.correlationMain.minCorrelation': 'Minimum',
    'correlation.correlationMain.2': 'Current Alpha',

    'correlation.getConfig.config.1': 'Nº Prod Alphas',
    'correlation.getConfig.series.1': 'Alphas',

    'tooltip.correlation.highest.label': 'Highest Correlation',
    'tooltip.powerPool.correlation.max.label': 'Power Pool Correlation',
    'tooltip.powerPool.correlation.max.content':
      'Maximum Pearson correlation coefficient from comparing a given alpha to all other power pool alphas submitted by the same user',

    'tooltip.powerPool.correlation.min.label': 'Power Pool Correlation',
    'tooltip.powerPool.correlation.min.content':
      'Minimum Pearson correlation coefficient from comparing a given alpha to all other power pool alphas submitted by the same user',
    'tooltip.self.correlation.max.label': 'Self Correlation',
    'tooltip.self.correlation.max.content':
      'Maximum Pearson correlation coefficient from comparing a given alpha to all other alphas submitted by the same user',

    'tooltip.self.correlation.min.label': 'Self Correlation',
    'tooltip.self.correlation.min.content':
      'Minimum Pearson correlation coefficient from comparing a given alpha to all other alphas submitted by the same user',

    'tooltip.prod.correlation.max.label': 'Prod correlation',
    'tooltip.prod.correlation.max.content':
      'Maximum Pearson correlation coefficient from comparing a given alpha ' +
      'to all other alphas submitted by all WorldQuant BRAIN users',

    'tooltip.prod.correlation.min.label': 'Prod correlation',
    'tooltip.prod.correlation.min.content':
      'Minimum Pearson correlation coefficient from comparing a given alpha ' +
      'to all other alphas submitted by all WorldQuant BRAIN users',

    'tooltip.turnover.label': 'Turnover',
    'tooltip.turnover.content': 'Average measure of daily trading activity; Turnover = Value Traded / Value Held',

    'tooltip.returns.label': 'Returns',
    'tooltip.returns.content':
      'Annualized average gain or loss as a fraction of the invested amount. ' +
      'In WorldQuant BRAIN the invested amount is equal to half the book size	',

    'tooltip.margin.label': 'Margin',
    'tooltip.margin.content':
      '	Average gain or loss per dollar traded; calculated as PnL divided by total dollars traded in a given time period',

    'tooltip.pnl.label': 'PnL',
    'tooltip.pnl.content':
      'Profit and Loss, the money that alpha generates, expressed in dollars (the amount of money alpha lost or made during the year)',

    'tooltip.fitness.label': 'Fitness',
    'tooltip.fitness.content':
      'Hybrid metric that indicates overall performance. Higher values indicate better ' +
      'performance. Fitness = Sharpe * Sqrt( Abs( Returns ) / Max( Turnover, 0.125 ) ) ',

    'tooltip.edit.properties.label': 'Edit Properties',
    'tooltip.edit.properties.content':
      'After the simulation, you can name your Alpha, assign a category and color code, and add user-defined tags to them',

    'tooltip.editor.selection.expression.label': 'Selection Expression',
    'tooltip.editor.combo.expression.label': 'Combo Expression',

    'tooltip.editor.selection.expression.content': 'Choose which alphas to include in your SuperAlpha',
    'tooltip.editor.combo.expression.content': 'Define the algorithm to combine the selected alphas',

    'tooltip.sharpe.label': 'Sharpe',
    'tooltip.sharpe.content':
      'Average measure of risk-adjusted returns; Sharpe = Avg. Annualized Returns /  Annualized Std. Dev. of Returns',

    'tooltip.startDate.label': 'Start Date',
    'tooltip.startDate.content': 'Date on which the alpha passes all the mandatory internal tests along with the OS ladder test',

    'tooltip.birthDate.label': 'Birth Date',
    'tooltip.birthDate.content': 'Date on which the alpha is created',

    'tooltip.simulationDate.label': 'Simulation Date',
    'tooltip.simulationDate.content': 'Date on which the alpha was first simulated',

    'tooltip.score.before.label': 'Before Submission',
    'tooltip.score.before.content': 'Your team’s current delay score.',

    'tooltip.score.after.label': 'After Submission',
    'tooltip.score.after.content': 'Expected team’s delay score after submitting this alpha.',

    'tooltip.score.change.label': 'Change',
    'tooltip.score.change.content': 'Change in your team’s delay score if this alpha is submitted.',

    'tooltip.datafieldsScore.before.label': 'Before Submission',
    'tooltip.datafieldsScore.before.content': 'Your current data fields score.',

    'tooltip.datafieldsScore.after.label': 'After Submission',
    'tooltip.datafieldsScore.after.content': 'Expected data fields score after submitting this alpha.',

    'tooltip.datafieldsScore.change.label': 'Change',
    'tooltip.datafieldsScore.change.content': 'Change in your data fields score if this alpha is submitted.',

    'tooltip.robustnessScore.before.label': 'Before Submission',
    'tooltip.robustnessScore.before.content': 'Your current robustness score.',

    'tooltip.robustnessScore.after.label': 'After Submission',
    'tooltip.robustnessScore.after.content': ' Expected robustness score after submitting this alpha.',

    'tooltip.robustnessScore.change.label': 'Change',
    'tooltip.robustnessScore.change.content': 'Change in your robustness score if this alpha is submitted.',

    'tooltip.weeklyScore.before.label': 'Before Submission',
    'tooltip.weeklyScore.before.content': 'Your current weekly score.',

    'tooltip.weeklyScore.after.label': 'After Submission',
    'tooltip.weeklyScore.after.content': 'Expected weekly score after submitting this alpha.',

    'tooltip.weeklyScore.change.label': 'Change',
    'tooltip.weeklyScore.change.content': 'Change in your weekly score if this alpha is submitted.',

    'tooltip.drawdown.label': 'Drawdown',
    'tooltip.drawdown.content': 'Drawdown is the largest reduction in PnL during a given period, expressed as a percentage.',

    'input.file.none': 'No file selected',

    'courseLesson.1': 'About the Lesson',
    'courseLesson.2': '25% Completed',
    'courseLesson.3': 'Example Alphas',
    'courseLesson.4': 'Lesson 1-4',
    'courseLesson.5': 'Lesson 6',
    'courseLesson.6': 'Related Links',
    'courseLesson.7': 'Tutorial: Run an Example Alpha',
    'courseLesson.8': 'Investopedia: Alpha',
    'courseLesson.9': 'Transcript',

    'coursesDetails.1': 'Start Course',
    'coursesDetails.2': 'About the Course',
    'coursesDetails.3': '25% Completed',
    'coursesDetails.4': 'Lesson 1-4',
    'coursesDetails.5': 'Lesson 6',
    'coursesDetails.6': 'Related Links',
    'coursesDetails.7': 'Tutorial: Run an Example Alpha',
    'coursesDetails.8': 'Investopedia: Alpha',
    'coursesDetails.9': 'More Courses',
    'coursesDetails.10': 'Example Alphas',
    'coursesDetails.videos': 'Videos',
    'coursesDetails.lessons': 'Lessons',
    'courseLesson.failed.video': "The current video doesn't exist please try another",
    'courseLesson.no-transcript': 'Transcript not available',
    'courseLesson.no-description': 'Description not available',

    'daterangepicker.today': 'Today',
    'daterangepicker.yesterday': 'Yesterday',
    'daterangepicker.last7d': 'Last 7 Days',
    'daterangepicker.last30d': 'Last 30 Days',
    'daterangepicker.month': 'This Month',
    'daterangepicker.last.month': 'Last Month',
    'daterangepicker.last3Months': 'Last 3 Months',
    'daterangepicker.last6Months': 'Last 6 Months',
    'daterangepicker.lastYear': 'Last Year',
    'daterangepicker.cancel': 'Cancel',
    'daterangepicker.apply': 'Apply',
    'daterangepicker.custom.range': 'Custom Range',
    'save.current.filters.label': 'Save Current Filters',
    'alphas.filters.reset': 'Reset',
    'alphas.filters.apply': 'Apply',
    'alphas.filters.name.the.filter': 'Name of filter set',
    'alphas.filters.save': 'Save Filters',
    'profile.change.password': 'Change Password',
    'profile.workday': 'Workday',
    'customFilters.less': '< (Less Than)',
    'customFilters.equal': '= (Equal To)',
    'customFilters.greater': '> (Greater Than)',
    'customFilters.lessEqual': '≤ (Less Than Or Equal To)',
    'customFilters.greaterEqual': '≥ (Greater Than Or Equal To)',
    'customFilters.notEqual': '≠ (Not Equal)',
    'filters.operator.placeholder': 'Select an operator',
    'filters.name': 'Name',
    'change.email.profile': 'Change',
    'filters.competitions': 'Competition',
    'filters.stage': 'Stage',
    'filters.language': 'Language',
    'filters.dateCreated': 'Date Created (EST)',
    'filters.region': 'Region',
    'filters.universe': 'Universe',
    'filters.delay': 'Delay',
    'filters.decay': 'Decay',
    'filters.neutralization': 'Neutralization',
    'filters.truncation': 'Truncation',
    'filters.sharpe': 'Sharpe',
    'filters.returns': 'Returns',
    'filters.pnl': 'PnL',
    'filters.type': 'Type',
    'filters.turnover': 'Turnover',
    'filters.actualWeight': 'Actual Weight',
    'filters.drawdown': 'Drawdown',
    'filters.margin': 'Margin',
    'filters.fitness': 'Fitness',
    'filters.category': 'Category',
    'filters.correlation': 'Self Corr',
    'filters.status': 'Status',
    'filters.instrumentType': 'Instrument Type',
    'filters.color': 'Color',
    'filters.selectionLimit': 'Selection Limit',
    'filters.selectionHandling': 'Selection Handling',
    'filters.favorite': 'Favorite',
    'filters.osmosisPoints': 'Osmosis Points',
    'filters.hidden': 'Hidden',
    'filters.dateSubmitted': 'Submission Date',
    'filters.simulationDate': 'Simulation Date',
    'filters.birthDate': 'Birth Date',
    'filters.preCloseSharpe': 'Pre-Close Sharpe',
    'filters.osISSharpeRatio': 'OS/IS Ratio',
    'filters.longCount': 'Long Count',
    'filters.shortCount': 'Short Count',
    'filters.bookSize': 'Book Size',
    'filters.tags': 'Tag',

    'combo.settings.subtitle': 'Combo settings',

    'filters.prodCorrelation': 'Prod-Correlation',
    'filters.selfCorrelation': 'Self-Correlation',
    'filters.preCloseSharpeRatio': 'Pre-Close Ratio',
    'filters.startDate': 'Start Date',

    'filters.sharpe125': 'Sharpe 125',
    'filters.sharpe250': 'Sharpe 250',
    'filters.sharpe500': 'Sharpe 500',
    'filters.sharpe60': 'Sharpe 60',

    'filters.unitHandling': 'Unit Handling',
    'filters.nanHandling': 'NaN Handling',
    'filters.lookback': 'Lookback',
    'filters.pasteurization': 'Pasteurization',
    'filters.maxTrade': 'Max Trade',
    'filters.maxPosition': 'Max Position',
    'filters.save.filter': 'Save Current Filters',
    'filters.name.filter': 'Name of filter set',
    'filters.save': 'Save Filters',
    'filters.exist.error': 'Already there is a filter with that name',

    'filters.weight': 'Selected Weight',

    'dashboardMain.dashboardBottomRow.achievements': 'Achievements',
    'dashboardMain.dashboardBottomRow.bronze': 'Bronze',
    'dashboardMain.dashboardBottomRow.gold': 'Gold',
    'dashboardMain.dashboardBottomRow.performance': 'Performance',
    'dashboardMain.dashboardBottomRow.silver': 'Silver',
    'dashboardMain.dashboardBottomRow.viewAchievements': 'View Achievements',
    'dashboardMain.dashboardBottomRow.yourLevel': 'Your Level',
    'dashboardMain.dashboardBottomRow.yourRank': 'Your Rank',
    'dashboardMain.dashboardBottomRow.yourScore': 'Your Score',
    'dashboardMain.dashboardBottomRow.webSimActivity': 'WorldQuant BRAIN Activity',
    'dashboardMain.dashboardMiddleBottomRow.events': 'Events',
    'dashboardMain.dashboardMiddleBottomRow.learn': 'Learn',
    'dashboardMain.dashboardMiddleBottomRow.seeMore': 'See more',
    'dashboardMain.dashboardMiddleBottomRow.upcoming': 'Upcoming',
    'dashboardMain.dashboardMiddleBottomRow.viewCalendar': 'View calendar',
    'dashboardMain.dashboardMiddleUpperRow.alpha': ' Alphas',
    'dashboardMain.announcements': 'Announcements',
    'dashboardMain.totalAlphasUnsubmitted': 'Total Unsubmitted Alphas ',
    'dashboardMain.totalAlphasActive': 'Total Active Alphas',
    'dashboardMain.totalAlphasDecommissioned': 'Total Decommissioned Alphas',
    'dashboardMain.totalAlphas': 'Total Alphas',
    'dashboardMain.vrcPnl': 'BRAIN PnL',
    'dashboardMain.yourTier': 'Your Tier',
    'dashboardMain.totalBonus': 'Total Bonus',
    'dashboardMain.dashboardMiddleUpperRow.bronze': 'Bronze',
    'dashboardMain.dashboardMiddleUpperRow.competition': 'Competition',
    'dashboardMain.dashboardMiddleUpperRow.gold': 'Gold',
    'dashboardMain.dashboardMiddleUpperRow.mostRecent': 'Most Recent',
    'dashboardMain.dashboardMiddleUpperRow.status': 'Status',
    'dashboardMain.dashboardMiddleUpperRow.seeAll': 'See all',
    'dashboardMain.dashboardMiddleUpperRow.silver': 'Silver',
    'dashboardMain.dashboardMiddleUpperRow.stats': 'Stats',
    'dashboardMain.dashboardMiddleUpperRow.yourLevel': 'Your Level',
    'dashboardMain.dashboardMiddleUpperRow.yourRank': 'Your Rank',
    'dashboardMain.dashboardMiddleUpperRow.yourScore': 'Your Score',
    'dashboardMain.dashboardMiddleUpperRow.leaderboard': 'Leaderboard',
    'dashboardMain.dashboardUpperRow.mostRecent': 'Most Recent',
    'dashboardMain.dashboardUpperRow.notifications': 'Notifications',
    'dashboardMain.dashboardUpperRow.seeAll': 'See all',
    'dashboardMain.notifications.no.results': "At the moment, there aren't any notifications.",
    'dashboardMain.dashboardUpperRow.startBuildingFirstAlpha': 'Start building your first alpha',
    'dashboardMain.title': 'Welcome to WorldQuant BRAIN!',
    'dashboardMain.info':
      'By participating in the WorldQuant Challenge, you will compete with ' +
      'applicants from around the world on our simulation platform, WorldQuant BRAIN. ' +
      'This will give you an opportunity to compete and if you achieve ' +
      'outstanding scores you will have a chance to become a Research ' +
      'Consultant with WorldQuant.',
    'dashboardMain.onboarding': 'Onboarding',
    'dashboardMain.onboarding.applicationStatus': 'Status of your consultant application',
    'dashboardMain.onboarding.note': '<strong>Note:</strong> Please allow 2 working days for a status update.',
    'dashboardMain.onboarding.invite':
      'You have been invited to apply for a BRAIN consultant opportunity. Please recertify your ' +
      '<linkProfileAccountBasicDetails>account details</linkProfileAccountBasicDetails> are accurate.',
    'dashboardMain.onboarding.inviteApproved':
      'Apply now for the Research Consultant role! Sign in to <linkProfileAccountWorkday>Workday</linkProfileAccountWorkday> to submit the documentation ' +
      'related to the consulting opportunity.',
    'dashboardMain.onboarding.countryUnavailable':
      'We regret to inform you that the BRAIN consultant opportunity is not available in your country. ' +
      'We will notify you when your country is eligible for the opportunity. ' +
      'Meanwhile you can use WorldQuant BRAIN as a user, and learn about quantitative finance.',
    'dashboardMain.onboarding.questionnaireReceived':
      'We have received the questionnaire. It is under review.' +
      '{br}{br}' +
      '<strong>Note</strong>: A status update may take longer depending on the inputs.',
    'dashboardMain.onboarding.questionnaireApproved':
      'Your questionnaire is approved. Your next step: review two additional ' +
      'documents in your <linkProfileAccountWorkday>Workday inbox</linkProfileAccountWorkday>: the recertification letter and consulting agreement.',
    'dashboardMain.onboarding.questionnaireApproved.ru':
      'Your questionnaire is approved. Please check your email in 1-2 days for next steps.',
    'dashboardMain.onboarding.formsReceived':
      'We have received the documents. They are under review.' +
      '{br}{br}' +
      '<strong>Note</strong>: Please allow 2 working days for a status update.',
    'dashboardMain.onboarding.formsApproved':
      'Congratulations! You are now a Conditional consultant. Your alphas can now start ' +
      'accruing fees. Check your email for more details.' +
      '{br}{br}' +
      '<strong>Note</strong>: Please allow 16 working days for a status update.',
    'dashboardMain.onboarding.backgroundCheckApproved':
      'Your background check is now approved. Please verify ' +
      'your bank account details in <linkProfileAccountWorkday>Workday</linkProfileAccountWorkday>.',
    'dashboardMain.onboarding.consultantApproved':
      'Congratulations! You are now a fully approved Research Consultant with WorldQuant BRAIN!',

    'submissionsCompetition.title': 'Alpha Creation Engine Competition',
    'submissionsCompetition.submissions': 'Your submissions',
    'submissionsCompetition.newSubmission': 'New Submission',
    'submissionsCompetition.description': 'Description',
    'submissionsCompetition.descriptionHint': `Is there anything we should know about this code? 
How is it different from other submissions?`,
    'submissionsCompetition.descriptionEmptyError': 'Description must be filled to upload files',
    'submissionsCompetition.dragAndDrop': 'Drag and drop files to upload',
    'submissionsCompetition.dropFiles': 'Drop your files anywhere',
    'submissionsCompetition.selectFile': 'Select file',
    'submissionsCompetition.unexpectedUploadError': 'There was an error when uploading file',
    'submissionsCompetition.unexpectedUploadMultipleFiles': 'Cannot upload multiple files',
    'submissionsCompetition.unexpectedFileExtension': 'File type not allowed',

    'promptSubmissions.backToCompetition': 'Back to Competition',
    'promptSubmissions.pageTitle': 'Prompt Submission',
    'promptSubmissions.pageSubtitle': 'Systematic Predictions Challenge (SPC)',
    'promptSubmissions.guidelinesLink': 'Read prompt submission guidelines',
    'promptSubmissions.form.newSubmissionTitle': 'New Submission',
    'promptSubmissions.form.newSubmissionSubtitle': 'Create a new prompt submission',
    'promptSubmissions.form.warningBanner': 'Ensure that the prompt is tested on the lowest temperature or equivalent settings.',
    'promptSubmissions.form.allFieldsRequired': 'All fields are required.',
    'promptSubmissions.yourSubmissions': 'Your Prompt Submissions',
    'promptSubmissions.empty': 'You have not submitted any prompts yet.',
    'promptSubmissions.loadError': 'Failed to load prompt submissions.',
    'promptSubmissions.form.name': 'Prompt Name',
    'promptSubmissions.form.namePlaceholder': 'e.g., Momentum Alpha',
    'promptSubmissions.form.prompt': 'Prompt',
    'promptSubmissions.form.promptPlaceholder': 'Enter your prompt here',
    'promptSubmissions.form.promptCount': '{count} / 10000 characters',
    'promptSubmissions.form.promptHelper1': 'Output must be a vector of instruments with associated confidence scores.',
    'promptSubmissions.form.promptHelper2':
      'Positive confidence scores represent long positions; negative confidence scores represent short positions.',
    'promptSubmissions.form.sampleOutput': 'Sample Prompt Output',
    'promptSubmissions.form.sampleOutputPlaceholder':
      "'{'\n  '<'isin1|mic1> : confidence_score1,\n  '<'isin2|mic2> : confidence_score2,\n  ...\n'}'",
    'promptSubmissions.form.sampleOutputHelper1': 'Paste the instrument and confidence score pairs generated by your prompt.',
    'promptSubmissions.form.sampleOutputHelper2': 'Output should be a JSON object.',
    'promptSubmissions.form.sampleOutputHelper3': 'Instruments should be provided using ISIN or MIC identifiers.',
    'promptSubmissions.form.sampleOutputHelper4':
      'Positive confidence scores represent long positions; negative confidence scores represent short positions.',
    'promptSubmissions.form.model': 'Model',
    'promptSubmissions.form.modelPlaceholder': 'Select model',
    'promptSubmissions.form.modelVersion': 'Model Version',
    'promptSubmissions.form.modelVersionPlaceholder': 'e.g. 4.8',
    'promptSubmissions.form.updateFrequency': 'Update Frequency',
    'promptSubmissions.form.updateFrequencyPlaceholder': 'Select frequency',
    'promptSubmissions.form.weight': 'Prompt Weight',
    'promptSubmissions.form.weightPlaceholder': 'e.g., 0.25',
    'promptSubmissions.form.weightHelper': 'Weight must be a number between 0 and 1. Up to 2 decimal places are allowed.',
    'promptSubmissions.form.submit': 'Submit Prompt',
    'promptSubmissions.form.cancel': 'Cancel',
    'promptSubmissions.form.submitSuccess': 'Prompt submitted successfully.',
    'promptSubmissions.form.submitError': 'Failed to submit prompt. Please try again.',
    'promptSubmissions.form.dailySubmissionLimitError': 'Daily Prompt submissions limited to 50',
    'promptSubmissions.form.activeSubmissionLimitError': 'Active Prompt submissions limited to 50',
    'promptSubmissions.validation.required': 'This field is required.',
    'promptSubmissions.validation.promptTooLong': 'Prompt must be at most 10000 characters.',
    'promptSubmissions.validation.modelVersionTooLong': 'Model Version must be at most 100 characters.',
    'promptSubmissions.validation.weightRange': 'Weight must be between 0 and 1, with at most 2 decimal places.',
    'promptSubmissions.table.name': 'Prompt Name',
    'promptSubmissions.table.model': 'Model',
    'promptSubmissions.table.weight': 'Weight',
    'promptSubmissions.table.frequency': 'Update Frequency',
    'promptSubmissions.table.status': 'Status',
    'promptSubmissions.table.lastUpdated': 'Last Updated',
    'promptSubmissions.table.actions': 'Actions',
    'promptSubmissions.actions.view': 'View',
    'promptSubmissions.actions.editWeight': 'Edit Weight',
    'promptSubmissions.actions.save': 'Save',
    'promptSubmissions.actions.cancel': 'Cancel',
    'promptSubmissions.status.active': 'Active',
    'promptSubmissions.status.failed': 'Failed Validation',
    'promptSubmissions.status.unknown': '—',
    'promptSubmissions.weightUpdateError': 'Failed to update weight. Please try again.',
    'promptSubmissions.details.title': 'Prompt Details',
    'promptSubmissions.details.prompt': 'Prompt',
    'promptSubmissions.details.weightHistory': 'Weight History',
    'promptSubmissions.details.historyDate': 'Date',
    'promptSubmissions.details.historyWeight': 'Weight',
    'promptSubmissions.details.historyEmpty': 'No weight history yet.',
    'promptSubmissions.details.close': 'Close',

    'editorBottomBarLeft.multiSimulate': 'Multi-Simulate',
    'editorBottomBarLeft.multiTest': 'Multi-Test',
    'editorBottomBarLeft.example': 'Example',
    'editorBottomBarLeft.simulate': 'Simulate',
    'editorBottomBarLeft.test': 'Test',
    'editorBottomBarLeft.visualization': 'Visualization',
    'editoBottomBarLeft.bluePopUp.learnMore': 'Learn more >',
    'editoBottomBarLeft.bluePopUp.toolTip': 'Calculates additional, advanced metrics about alpha performance; increases simulation time',
    'editoBottomBarLeft.bluePopUp.visualization': 'Visualization',
    'editorBottomBarLeft.EditorBottomBarLeftIsFetching.multiSimulate': 'Multi-Simulate',
    'editorBottomBarLeft.EditorBottomBarLeftIsFetching.multiTest': 'Multi-Test',
    'editorBottomBarLeft.EditorBottomBarLeftIsFetching.example': 'Example',
    'editorBottomBarLeft.EditorBottomBarLeftIsFetching.simulate': 'Simulate',
    'editorBottomBarLeft.EditorBottomBarLeftIsFetching.test': 'Test',
    'editorBottomBarLeft.EditorBottomBarLeftIsFetching.visualization': 'Visualization',

    'editorBottomBarRight.checkSubmission': 'Check Submission',
    'editorBottomBarRight.editProperties': 'Edit Properties',
    'editorBottomBarRight.openAlphaDetails': 'Open alpha details in new tab',
    'editorBottomBarRight.submitAlpha': 'Submit Alpha',

    'editorMain.contextMenuWithOptions.blue': 'Blue',
    'editorMain.contextMenuWithOptions.deleteAlpha': 'Delete Alpha',
    'editorMain.contextMenuWithOptions.duplicateAlpha': 'Clone Alpha in new tab',
    'editorMain.contextMenuWithOptions.green': 'Green',
    'editorMain.contextMenuWithOptions.noColor': 'No Color',
    'editorMain.contextMenuWithOptions.purple': 'Purple',
    'editorMain.contextMenuWithOptions.rename': 'Rename',
    'editorMain.contextMenuWithOptions.red': 'Red',
    'editorMain.contextMenuWithOptions.simulateAlpha': 'Simulate Alpha',
    'editorMain.contextMenuWithOptions.yellow': 'Yellow',

    'editorMain.closeTabModal.title': 'Are you sure you want to close this tab?',
    'editorCloseTabModal.closeTabModal.firstParagraph':
      'The code in this tab has not been simulated yet or has been modified since it was last simulated.',
    'editorCloseTabModal.closeTabModal.secondParagraph': 'You will lose any progress if you close out of this tab.',
    'editorCloseTabModal.closeTabModal.button.cancel': 'Cancel',
    'editorCloseTabModal.closeTabModal.button.close': 'Close Tab',

    'editorMain.changeCodeModal.title': 'Are you sure you want to change the code?',
    'editorCloseTabModal.changeCodeModal.firstParagraph':
      'The code in this tab has not been simulated yet or has been modified since it was last simulated.',
    'editorCloseTabModal.changeCodeModal.secondParagraph': 'You will lose any progress if you change the example.',
    'editorCloseTabModal.changeCodeModal.button.cancel': 'Cancel',
    'editorCloseTabModal.changeCodeModal.button.close': 'Change Example',

    'editorMain.cloneSimulation.title': 'Are you sure you want to change the code?',
    'editorCloseTabModal.cloneSimulation.firstParagraph':
      'The code in this tab has not been simulated yet or has been modified since it was last simulated.',
    'editorCloseTabModal.cloneSimulation.secondParagraph': 'You will lose any progress if you change the example.',
    'editorCloseTabModal.cloneSimulation.button.cancel': 'Cancel',
    'editorCloseTabModal.cloneSimulation.button.close': 'Change Code',

    'closeAlphaProperties.title': 'Do you want to save your changes to the alpha properties?',
    'closeAlphaProperties.content':
      'The changes to the alpha properties have not been saved yet. You will lose any progress if you Don’t Save.',
    'closeAlphaProperties.button.cancel': 'Cancel',
    'closeAlphaProperties.button.not.save': "Don't Save",
    'closeAlphaProperties.button.close': 'Save',
    'alphaList.already.exists.msg': 'Alpha already exists in this list try in another',
    'invalid.alphaList': 'Invalid Alpha',
    'editor.simulation': 'Simulation ',
    'editor.multi-simulation': 'Multi-Simulation ',
    'editor.super-simulation': 'Super Simulation ',
    'editorNewTab.new': 'New',
    'editorNewTab.newSingleSimulation': 'New Single Simulation',
    'editorNewTab.newMultiSimulation': 'New Multi-Simulation',
    'editorNewTab.super.alpha': 'New Super Simulation',
    'editorSettings.error.message': "Settings aren't available at the moment. Please try again later",
    'editorSettingsForm.labelDecay': 'Decay',
    'editorSettingsForm.nameDecay': 'decay',
    'editorSettingsForm.labelDelay': 'Delay',
    'editorSettingsForm.nameDelay': 'delay',
    'editorSettingsForm.expression': 'Expression',
    'editorSettingsForm.labelTruncation': 'Truncation',
    'editorSettingsForm.nameTruncation': 'truncation',
    'editorSettingsForm.labelNeutralization': 'Neutralization',
    'editorSettingsForm.nameNeutralization': 'neutralization',
    'editorSettingsForm.python': 'Python',
    'editorSettingsForm.labelRegion': 'Region',
    'editorSettingsForm.nameRegion': 'region',
    'editorSettingsForm.labelInstrumentType': 'Instrument Type',
    'editorSettingsForm.nameInstrumentType': 'instrumentType',
    'editorSettingsForm.saveSettings': 'Save as Default',
    'editorSettingsForm.labelUniverse': 'Universe',
    'editorSettingsForm.nameUniverse': 'universe',
    'editorSettingsForm.labelUniverseOverride': 'Universe override',
    'editorSettingsForm.nameUniverseOverride': 'universe override',
    'editorSettingsForm.labelPasteurization': 'Pasteurization',
    'editorSettingsForm.namePasteurization': 'pasteurization',
    'editorSettingsForm.labelUnitHandling': 'Unit Handling',
    'editorSettingsForm.nameUnitHandling': 'unitHandling',
    'editorSettingsForm.labelNanHandling': 'Nan Handling',
    'editorSettingsForm.nameNanHandling': 'nanHandling',
    'editorSettingsForm.testPeriod': 'Test period',
    'editorSettingsForm.testPeriod.year': 'Years',
    'editorSettingsForm.testPeriod.month': 'Months',
    'editorSettingsForm.testPeriod.day': 'Days',
    'editorSettingsForm.MsgTestPeriod':
      'Allows subset of PnL to be hidden as a validation period. This PnL can still be viewed by clicking the "Show test period" button',
    'editorSettingsForm.maxTrade': 'Max Trade',
    'editorSettingsForm.MsgMaxTrade': 'Applies trade constraints based on fraction of adv20',
    'editorSettingsForm.maxPosition': 'Max Position',
    'editorSettingsForm.MsgMaxPosition': 'Applies position constraints based on fraction of dollar volume',
    'editorSettingsForm.labelLookback': 'Lookback',
    'editorSettingsForm.MsgLookback': 'Number of lookback days used for Python simulation calculations',
    'editorSettingsForm.labelSelectionLimit': 'Selection Limit',
    'editorSettingsForm.labelSelectionHandling': 'Selection Handling',
    'editorSettingsForm.truncation': 'The settings truncation is set to',
    'editorSettingsForm.labelComponentActivation': 'Component Activation',
    'editorSettingsForm.MsgComponentActivation':
      'Activate component Alphas in SuperAlpha:          \n' +
      '• IS: From the start of their In-Sample period.      \n' +
      '• OS: From the start of their Out-of-Sample period.',
    'editorSettingsForm.settings': 'Settings',
    'editorSettingsForm.apply': 'Apply',
    'editorSettingsForm.MsgLanguage': 'Coding language in which the alpha expression is written',
    'editorSettingsForm.MsgInstrumentType': 'Type of financial instrument traded',
    'editorSettingsForm.MsgRegion': 'Set of instruments based on common geography, trading hours, and other attributes',
    'editorSettingsForm.MsgUniverse': 'Subset of region based on liquidity; smaller universes are more liquid',
    'editorSettingsForm.MsgDelay':
      'Delay=1 alphas trade in the morning using data from yesterday; Delay=0 alphas trade in the evening using data from today',
    'editorSettingsForm.MsgNeutralization': 'Adjust alpha weights such that they sum to zero within each group of the selected type',

    'editorSettingsForm.MsgDecay':
      '	Sets input data equal to a linearly decreasing weighted average of that data over the past selected number of days',
    'editorSettingsForm.MsgTruncation': 'Maximum daily weight of each instrument',
    'editorSettingsForm.MsgPasteurization': 'Replaces operator input values with NaN for instruments not in the universe',
    'editorSettingsForm.MsgUnitHandling': 'Raises a warning when incompatible units are used in an operator',
    'editorSettingsForm.MsgNanHandling':
      'Allows aggregation operators to output numeric values when input values are NaN for a given instrument and date',
    'editorSettingsForm.MsgSelectionHandling':
      'Selects only alphas which evaluate to the selected type of value; e.g., "Positive" will exclude zero, negative values, and NaN',
    'editorSettingsForm.MsgSelectionLimit': 'Returns only the top n alphas, ranked descending by Selection Expression value',
    'editorSettingsForm.MsgUniverseOverride':
      'Ignores original universes and simulates all selected alphas using the universe given in the combo settings',

    'editorSettingsFormElement.learnMore': 'Learn more >',
    'editorSettingsForm.language': 'Language',

    'editorTopBarLeft.convertToMultiSimulation': 'Convert to Multi-Simulation',
    'editorTopBarLeft.expression': 'Expression',
    'editorTopBarLeft.python': 'Python',
    'editorTopBarLeft.settings': 'Settings',
    'editorBottomBarLeft.random': 'Sample',

    'editor.selection.expression': 'Selection Expression',
    'editor.combo.expression': 'Combo Expression',
    'editor.code.selection': 'Run Selection',

    'editorTopBarRight.addToAList': 'Add to a list',
    'editorTopBarRight.alphaLists': 'Alpha lists',
    'editorTopBarRight.code': 'Code',
    'editorTopBarRight.learn': 'Learn',
    'editorTopBarRight.dataExplorer': 'Data',
    'editorTopBarRight.tutorial': 'Tutorial',
    'editorTopBarRight.results': 'Results',
    'change.email.resend.verify':
      'A verification email has been sent to "{unverified}". Please check ' +
      'your email for further instructions. Resend verification email',
    'change.email.resend.verify.button': 'Resend verification email',
    'change.email': 'Change Email',
    'new.email': 'New Email',
    'account.password': 'Password',
    'change.email.info':
      'Since your email is used to sign in, additional security is required. Please enter your BRAIN password to change your email.',
    'change.email.return.profile': 'Return to Profile',
    'verification.link.email': 'Verification Link',
    'change.email.verify.text': 'Verification link has been sent. Please check your email for further instructions.',
    'change.email.verify.info':
      "Note: If you don't find it in your inbox, please check your junk/spam folder. If you " +
      "are still unable to find it, your mail server's filters may be blocking incoming messages sent from us. In that case, " +
      'kindly register with WorldQuant BRAIN again using a well-known web-based mail client such as Gmail, Yahoo, Hotmail, etc.',

    'workday.login': 'Sign in to Workday',
    'workday.info':
      'Since Workday is used to manage your payout, additional security is required. ' +
      'Please enter your BRAIN password to sign in to Workday.',

    'brainLabs.login': 'Sign in to BRAIN Labs',
    'brainLabs.info':
      'Since BRAIN Labs is another environment, additional security is required. ' +
      'Please enter your BRAIN password to sign in to BRAIN Labs.',

    'deactivation.menu.title': 'Deactivation',
    'deactivation.title': 'Deactivate',
    'deactivation.text':
      'Are you sure you want to deactivate your account? You will not be able to sign-in anymore if you click Deactivate below.',
    'deactivation.text.consultant':
      'If you decide to reactivate, your status will be reset to a general user and you will need to ' +
      're-certify to obtain consultant status again.',
    'deactivation.button.cancel': 'Cancel',
    'deactivation.button.deactivate': 'Deactivate',

    'forgotPasswordMain.anEmailWithPassword':
      "Check your email for a link to reset your password. If you don't find it in your inbox, please check your junk/spam folder.",
    'forgotPasswordMain.submitYourAccount': 'Enter your email address and we will send you a link to reset your password.',
    'forgotPasswordMain.email': 'Email',
    'forgotPasswordMain.retrievePassword': 'Send password reset email',
    'forgotPasswordMain.title': 'Forgot Password',

    'header.alphas': 'Alphas',
    'header.competitions': 'Competitions',
    'header.community': 'Community',
    'header.events': 'Events',
    'header.brainLabs': 'Labs',
    'header.consultant': 'Consultant program',
    'header.referrals': 'Refer a friend',
    'header.genius': 'Genius',
    'header.activeCompetitions': 'Active Competitions',
    'header.consultantExclusive': 'Consultant Exclusive',
    'header.spcLeaderboard': 'Systematic Predictions Challenge',
    'header.geniusLeaderboard': 'Genius Leaderboard',
    'header.learn': 'Learn',
    'header.data': 'Data',
    'header.simulate': 'Simulate',
    'header.team': 'Team',
    'header.rank': 'Rank',
    'header.rank.with.value': 'Rank: {rank}',
    'header.concluded': 'Concluded',
    'header.none': 'None',
    'header.noCompetitions': 'No competitions available',
    'header.support': 'Support',
    'header.iqc': 'IQC 2026',

    'header.rightMenu.profile': 'Profile',
    'header.rightMenu.performance': 'Performance',
    'header.rightMenu.account': 'Account',
    'header.rightMenu.language': 'Language',
    'header.rightMenu.achievements': 'Achievements',
    'language.modal.title': 'Language',
    'language.modal.languageNote': 'Some content may not be available in your selected language and will remain in English.',
    'language.modal.save': 'Save',
    'header.rightMenu.referrals': 'Referral Tracker',
    'header.rightMenu.agreements': 'Agreements',
    'header.rightMenu.privacyPolicy': 'Privacy Policy',
    'header.rightMenu.cookieSettings': 'Cookie Settings',
    'header.rightMenu.signIn': 'Sign In',
    'header.rightMenu.signOut': 'Sign Out',
    'header.rightMenu.viewAllNotifications': 'View All Messages',
    'header.rightMenu.helpCenter': 'Help center',

    'header.viewAllCompetitions': 'View All Competitions',

    'summaryMain.1': 'Aggregate Data',

    'summary.testingStatus.1': 'check',

    'summary.status.1': 'Need help figuring out why?',

    'title.agreements': 'Agreements',
    'title.terms.conditions': 'Terms and Conditions',
    'profile.warning.inavlid.fields': 'Your unsaved changes will be lost. Are you sure you want to navigate away from this section?',
    'profile.yesterday': 'Yesterday',
    'profile.current.period': 'Current period',
    'profile.previous.period': 'Previous period',
    'profile.total.payout': 'Total payout',
    'profile.vrc.pnl': 'BRAIN PnL',
    'profile.accrued.bonus': 'Accrued Bonus',
    'profile.estimated.bonus': 'Estimated Bonus Payout',
    'profile.total.bonus': 'Total Bonus',
    'profile.label.agreements': 'Agreements',
    'profile.info.agreements': 'Terms and Conditions',
    'profile.label.performance': 'Performance',
    'profile.info.performance': 'User Metrics',
    'profile.label.achievements': 'Achievements',
    'profile.info.achievements': '{totalAchievements} Achievements Unlocked',
    'profile.info.noAchievements': "At the moment you don't have any achievements",
    'profile.label.account': 'Account',
    'profile.info.account': 'User Details',
    'profile.label.referrals': 'Referral Tracker',
    'profile.info.referrals': 'Referred Users',
    'profile.ytd.label': 'YTD',
    'profile.performance.stats.vrc': 'BRAIN PnL (Year to Date):',
    'profile.performance.stats.total.payment': 'Total Payment (All Time):',
    'performance.activity.yesterday': 'Yesterday',
    'performance.activity.previous': 'Previous period',
    'performance.activity.current': 'Current period',
    'performance.activity.total': 'Total',
    'performance.activity.ytd': 'Year to date',
    'performance.activity.displayed.period': 'Displayed Period',
    'performance.activity.regular': 'Regular',
    'performance.activity.super': 'Super',
    'performance.activity.period': 'Period',
    'no.data.available': 'No data available',
    'agreements.description.agreement': 'General agreement',
    'agreements.description.team': 'Team agreement',
    'agreements.description.competition': 'Competition agreement',
    'agreements.status.accepted': 'Accepted',
    'agreements.status.rejected': 'Rejected',
    'agreements.status.pending': 'Pending',
    'agreements.status.required': 'Required',
    'agreements.button.label': 'View',

    'performance.partition.regular': 'Regular alpha',
    'performance.partition.super': 'Super alpha',
    'performance.partition.equity': 'Equity',
    'performance.partition.0': 'Delay-0',
    'performance.partition.1': 'Delay-1',

    'learnFaqsMain.faq': 'FAQ',
    'learnFaqsMain.questionTopics': 'Question Topics',
    'learnFaqsMain.placeHolderSearch': 'Search',

    'learnMain.1': '% Completed',
    'learnMain.2': 'What do you want to learn today?',

    'learnMainReferences.references': 'Operators',
    'learnMainReferences.viewAll': 'View All',
    'learnMainReferences.operators': 'Operator list',

    'learnMainTutorials.tutorials': 'Documentation',
    'learnMainTutorials.viewAll': 'View All',

    'learnMainVideo.videoCourses': 'Courses',
    'learnMainVideo.viewAll': 'View All',
    'learnMainVideo.progressInfo': '0% Completed',
    'learnMainVideo.runtime': 'Run Time: 45 mins',
    'learnMainVideo.lessons': 'Lessons',

    'learnMainFaqs.viewAll': 'View All',
    'learnMainFaqs.faqs': 'FAQ',
    'learn.search.filter.dropdown': 'Select Filter',
    'learn.search.filter.only.recommendedReading': 'Search Recommended Reading only',
    'learn.search.filter.only.reference': 'Search Reference only',
    'learn.search.filter.only.tutorial': 'Search Tutorial only',
    'learn.search.filter.only.videoCourse': 'Search Courses only',
    'learn.search.filter.only.faq': 'Search FAQ only',

    'learnSearchBar.placeHolderSearch': 'Search',

    'learnSideBar.favorites': 'Favorites',
    'learnSideBar.faq': 'FAQ',
    'learnSideBar.data': 'Data Explorer',
    'learnSideBar.community': 'Community',
    'learnSideBar.references': 'Operators',
    'learnSideBar.tutorials': 'Documentation',
    'learnSideBar.videoCourse': 'Courses',
    'learnSideBar.glossary': 'Glossary',

    'learnNotFound.title': 'Page not found',
    'learnNotFound.content.1': 'This page doesn’t exist.',
    'learnNotFound.content.2':
      'If this is a mistake, <linkInNewtabHelpCenterNewRequest>let us know</linkInNewtabHelpCenterNewRequest>, and we will try to fix it!',
    'learnNotFound.backToLearn': 'Back to Learn',

    'LearnTutorialsItem.1': 'View All',
    'learn.search.results.found': ' results found',
    'learn.search.no.results': "No search results found for ''{term}''",
    'learn.search.cannot.see.relevant':
      'If you cannot see a relevant search result below, search in the ' +
      `<linkInNewTabFAQSearchWithQuery>BRAIN support pages (FAQs / Community)</linkInNewTabFAQSearchWithQuery>`,
    'learn.search.article.from': 'Article from {cat} Results',
    'learn.search.faq': 'FAQ',
    'learn.search.video.course': 'Courses',
    'learn.search.tutorial': 'Documentation',
    'learn.search.reference': 'Operators',
    'learn.search.video.lesson': 'Lesson {lesson} ',
    'learn.search.of': 'of ',
    'learn.search.filters.courses': 'Courses',
    'learn.search.filters.tutorials': 'Documentation',
    'learn.search.filters.references': 'Operators',
    'learn.search.filters.faq': 'Faq ',
    'learn.search.filter.by': 'Filter by: ',
    'title.filter.by': 'Filter by',
    'title.public.profile': 'View my public profile',
    'title.profile': 'Profile',
    'title.profile.public.page': 'Public Profile',

    'dataExplorer.title': 'Data',
    'dataExplorer.searchHeader': 'What data do you want to find?',
    'dataExplorer.main.theme': 'Theme datasets',
    'dataExplorer.main.categoriesHeader': 'Categories',
    'dataExplorer.main.new': 'Newest datasets',
    'dataExplorer.main.delays': 'Delays:',
    'dataExplorer.main.regions': 'Regions:',
    'dataExplorer.main.browseDatasets': 'Browse all datasets',
    'dataExplorer.main.themeDatasets': 'Browse all theme datasets',
    'dataExplorer.main.browseFields': 'Browse all fields',
    'dataExplorer.main.browseCategories': 'Browse by category',
    'dataExplorer.main.seeAllThemes': 'See all theme datasets',
    'dataExplorer.main.seeAllPopular': 'See other introductory datasets',
    'dataExplorer.main.seeAllMultipliers': 'See all pyramid theme multipliers ',
    'dataExplorer.main.seeAllNewest': 'See other new datasets',
    'dataExplorer.showMore': 'Show all settings',
    'dataExplorer.showLess': 'Show current settings',
    'dataExplorer.fieldDataNotFound':
      'This field has no coverage for this region ({region}), delay ({delay}), universe: ({universe}){br}You can select another universe in the table below or <linkToAllDataFields>browse other fields.</linkToAllDataFields>',
    'dataExplorer.datasetDataNotFound':
      'This dataset has no coverage for this region ({region}), delay ({delay}), universe: ({universe}){br}You can select another universe in the table below or <linkToAllDatasets>browse other datasets.</linkToAllDatasets>',

    'profile.title.profile': 'Profile',
    'profile.title.performance': 'Performance',
    'profile.title.achievements': 'Achievements',
    'profile.title.agreements': 'Agreements',
    'profile.title.account': 'Account',
    'profile.title.referrals': 'Referral Tracker',
    'profile.title.verify-email': 'Verification Link',

    'menuFooter.show': 'Page size',
    'menuFooter.outOf': 'out of ',
    'menuFooter.filter': 'Filter',

    'notFound.404NotFound': '404: Page not found',

    'competition.pending': 'Not Participating',
    'competition.rejected': 'Not Participating',
    'competition.required': 'Required Agreement',
    'competition.excluded': 'Restricted',
    'competition.accepted': 'Participating',
    'competition.concluded': 'Concluded',

    'step1.additionalFees':
      'Additional fees may apply. Please contact your wireless provider for information ' +
      'about your messaging rates and plan details. You can opt out of receiving these ' +
      'SMS messages at any time by updating this radio button in your account page. Please ' +
      'note it may take several days for this to take effect.',
    'step1.doYouAgree': 'Do you agree to be contacted via text/SMS?',
    'step1.emailAdress': 'Email Address',
    'step1.fillIn': 'Fill in the following to create an account.',
    'step1.firstName': 'First Name',
    'step1.password': 'Password',
    'step1.password.guidelines.mustHave': 'Your password must:',
    'step1.password.guidelines.minimumLength': 'Have min. 8 characters',
    'step1.password.guidelines.notOnlyNumbers': 'Include non-numeric characters',
    'step1.password.guidelines.commonPassword': 'Not be common',
    'step1.password.guidelines.similarToUserAttributes': 'Differ from your name/email',
    'step1.password.guidelines.similarToEmail': 'Differ from your email',

    'step1.password.strength.veryWeak': 'Very Weak',
    'step1.password.strength.weak': 'Weak',
    'step1.password.strength.strong': 'Strong',
    'step1.password.strength.veryStrong': 'Very Strong',

    'step1.step1SecondColumn.confirmPassword': 'Confirm Password',
    'step1.step1SecondColumn.lastName': 'Last Name',
    'account.fullName': 'Official Full Legal Name',
    'account.fullName.message': 'Full legal name as stated in your national ID or passport.',
    'account.fullName.public': 'Do you agree to show your name in public pages?',
    'account.publicHint': 'Changes will be publically visible after moderation',
    'step1.step1SecondColumn.phoneNumber': 'Phone Number',

    'account.field.label.gender': 'Gender',
    'account.field.placeholder.gender': 'Select your gender',

    'step1.gender': 'Gender',
    'step1.placeHolderSelectYourGender': 'Select your gender',
    'account.gender.message':
      'WorldQuant does not discriminate on the basis of gender identity  or expression.' +
      ' The following question is intended to help us track the effectiveness of our recruiting efforts' +
      ' and ensure we consider the needs of all our users.',

    'step2.city': 'City',
    'step2.countryOfResidence': 'Country / Region of Residence',
    'step2.fillIn': 'Fill in the following to create an account.',
    'step2.placeHolderSelectYourCountry': 'Select your country / region',
    'step2.postCode': 'Post Code / Zip',
    'step2.streetAddress': 'Street Address',
    'step2.stateProvince': 'State / Province',

    'step3.step3DegreeForm.degree': 'Degree',
    'step3.step3DegreeForm.isDegreeStem': 'Is your degree considered part of STEM?',
    'step3.step3DegreeForm.major': 'Major',
    'step3.step3DegreeForm.scienceTechnology': 'Science, Technology, Engineering and Mathematics',
    'step3.step3DegreeForm.selectDegree': 'Select a Degree',

    'step3.step3Header.fillInTheFollowing': 'Fill in the following to create an account.',

    'step3.step3UniversityForm.gpa': 'GPA',
    'step3.step3UniversityForm.graduationYear': 'Graduation Year',
    'step3.step3UniversityForm.maxGpa': 'Max GPA',
    'step3.step3UniversityForm.placeHolderSelectUni': 'Select your university',
    'step3.step3UniversityForm.placeHolderSelectYear': 'Select a Year',
    'step3.step3UniversityForm.university': 'University',

    'step4.areYou': 'Are you presently employed, or engaged as a consultant or contractor by a firm (other than WorldQuant LLC)?',
    'step4.inOrder':
      'In order to assist us in evaluating your WorldQuant BRAIN application, please provide the following additional information.',

    'step4.finantialEmployerExplanationHeader': 'If Yes, please provide an explanation. Type N/A if not applicable.',

    'step4.finantialEmployerServicesInfo':
      'If Yes, please indicate which such services your employer provides. e.g. ' +
      'sales of financial datasets, or N/A if not applicable.',

    'step4.employerInfoSmall':
      'Inside Information is material, non-public information about a security. ' +
      'Non-public means the information has not been disseminated through a ' +
      'recognized channel or distribution. Material means any reasonable ' +
      'shareholder would consider the information important in making an investment ' +
      'decision regarding the security. If you have access to such potentially ' +
      'material, non-public information due to your current position in your firm ' +
      'or company, you must answer "yes" to this item.',

    'step4.employerInfo.1': '1. What is the name of your employer?',
    'step4.employerInfo.2': '2. What is your job title?',
    'step4.employerInfo.3': '3. What is your employer’s primary business?',
    'step4.employerInfo.4': '4. Please provide a description of your role.',
    'step4.employerInfo.5':
      '5. Is your participation in WorldQuant BRAIN (including submission of alphas) ' +
      "permissible under the terms of your employment and your employer's policies and procedures?",
    'step4.employerInfo.6': '6. In your role, do you have access to non-public information of or related to publicly traded companies?',
    'step4.employerInfo.7': '7. Is your employer in the financial service industry?',
    'step4.employerInfo.anAssetManager':
      'e.g. an asset manager, broker-dealer, bank or other firm engaged in investment-related activities',
    'step4.employerInfo.asAnEmployee': 'As an employee, full time consultant or contractor',

    'step4.radio.7a': '7a. Does your employer provide/engage in investment advisory/asset management?',
    'step4.radio.7b': '7b. Does your employer engage in brokerage?',
    'step4.radio.7c': '7c. Does your employer engage in fundamental research?',
    'step4.radio.7d': '7d. Does your employer engage in proprietary trading?',
    'step4.radio.8':
      '8. Does your employer engage in algorithmic, computer-based or similar trading ' +
      'or related services (e.g. algo design, trading infrastructure support, etc.)?',
    'step4.radio.9':
      '9. If you answered yes to any item in question 7 or 8 above, is your role ' +
      '(or have you in the past had a role) related to the service or activity you indicated, ' +
      'or do you have (or have you in the past had) access to information related to such services/activities?',

    'step5.andThe': 'and the',
    'step5.byAgreeing':
      'By agreeing to the WorldQuant BRAIN terms and conditions, you will be representing that your ' +
      'responses to these questions are accurate. If you have any questions, please contact',
    'step5.iHaveRead': 'I have read and hereby accept the ',
    'step5.iHerebyAgree':
      'I hereby agree that my personal information ' +
      'will be collected and processed by WorldQuant and its affiliates ' +
      '(including those located in the USA) in accordance with the processing purposes and ' +
      'methods described in the <PrivacyPolicy>step5.privacy.2</PrivacyPolicy>',
    'step5.privacy': 'Privacy Policy',
    'step5.privacy.2': 'Privacy Policy.',
    'step5.challenge': 'WorldQuant Challenge Guidelines',
    'step5.termsConditions': 'Terms and Conditions',
    'step5.ticket': `${APP_EMAIL}`,
    'step6.competition.terms': 'I am interested in participating in the {competition}. To learn more, please click ',
    'step6.competition.here': 'here.',
    'agreements.termsConditions': 'I have read and hereby accept the Terms and Conditions and the WorldQuant Challenge Guidelines.',
    'agreements.competition': 'I am interested in participating in the {competition}. I have read and hereby accept the {agreement}.',
    'announcements.none': "At the moment there aren't any announcements",
    'terms.account-details':
      'I hereby certify that all of the information provided is true, correct and ' +
      'complete to the best of my knowledge. If any of this information changes, I will promptly update my profile using these forms.',
    'terms.alphathon-update-account-details':
      'I understand that by updating my <strong>{fieldName}</strong> to <strong>{fieldValue}</strong> I will be ineligible for {invalidCompetitions}. ',
    'terms.close': 'Close',
    'terms.iAgree': 'I Agree',
    'agreements.close': 'Close',
    'agreements.back': 'Back',
    'agreements.showDocs': 'Show Agreement',
    'agreements.available': "At the moment there isn't an agreement available",
    'agreements.iAgree': 'I Agree',
    'agreements.iAgreeToRejectable':
      'I have fully understood the Company’s explanation on mandatory collection and use of general personal information and hereby consent thereto',
    'agreements.enroll.today': 'Enroll in {competitionName} today!',
    'terms.generic': 'I have carefully read, I understand and I agree to these terms.',
    'agreements.iAgreeAndEnroll': 'Agree and Enroll',
    'agreements.later': 'Remind Me Later',
    'agreements.no': 'No',
    'agreements.notNow': 'Not Now',
    'agreements.notInterested': 'Not interested in this competition',
    'agreements.reject': 'I do not consent',
    'terms.iHaveCarefullyRead':
      'I have carefully read, I understand and I agree to terms, ' +
      'representations, licenses and provisions of the WorldQuant BRAIN User Agreement.',
    'terms.iHaveFullRight':
      'I have full right, power and authority (a) post the code and other ' +
      'material that is to be posted under my user ID to BRAIN, and (b) ' +
      'grant and agree to the rights granted under the WorldQuant BRAIN User Agreement.',
    'terms.asProvided':
      'As provided in the WorldQuant BRAIN User Agreement, there is no obligation to provide ' +
      'any compensation to me, share with me any revenue, gain or profit from ' +
      'such use or offer any employment to me or any other relationship with ' +
      'me unless a consulting agreement that specifically overrides these ' +
      'terms is put in place.',

    'terms.termsParagraphHeader.1': 'This WorldQuant BRAIN User Agreement, together with any website terms of use posted herewith (this ',
    'terms.termsParagraphHeader.2': '"Agreement"',
    'terms.termsParagraphHeader.3':
      ') governs your access to and use of our ' +
      'WorldQuant BRAIN software, tool, service and website and any related documentation, as ' +
      'any of the foregoing may be changed from time to time (in part or in whole, ' +
      '"WorldQuant BRAIN").',
    'terms.termsParagraphHeader.4': 'WorldQuant BRAIN',
    'terms.termsParagraphHeader.5':
      'is made available by Virtual Research Center LLC (along with ' +
      'its affiliates from time to time, "Company" or "we" or "us" or possessives ' +
      'thereof). We may change this Agreement from time to time, by posting a ' +
      'revised Agreement. BY ACCESSING OR USING WorldQuant BRAIN, YOU ACCEPT AND AGREE TO ' +
      'THIS AGREEMENT AND YOUR CONTINUED ACCESS AND USE OF WorldQuant BRAIN, INDICATES YOUR ' +
      'AGREEMENT TO ANY CHANGES AND/OR AMENDMENTS TO THE AGREEMENT. If you do not ' +
      'agree to this Agreement or any changes and amendments thereto, you should ' +
      'not access or use WorldQuant BRAIN. THIS AGREEMENT IS SUBJECT TO MANDATORY ' +
      'ARBITRATION, SEE CLAUSE 20(i) BELOW.',
    'invalid.competition.agreement':
      'Only people {onlyExcludedCountry, select, true {not from\xa0} other {from\xa0}}' +
      '{errorMessageUniversities}' +
      '{invalidUniversityAndCountry, select, true {\xa0and from\xa0} other {}}{errorMessageCountries}' +
      '{excludedCountryPlusOneMoreInvalid, select, true {\xa0and not from\xa0} other {}}{errorMessageCountriesExcluded} ' +
      'can enroll in {competitionName}',
    'invalid.competition.country': 'Only people from {errorMessageCountries} can enroll in {competitionName}',
    'invalid.competition.country.IQC': 'Registrations for IQC 2026 will officially open at 0:00 ET, 17 March 2026',
    'invalid.competition.university': 'Only people from {errorMessageUniversities} can enroll in {competitionName}',
    'terms.termsParagraph1.1': '1.',
    'terms.termsParagraph1.2': 'Who You Are.',
    'terms.termsParagraph1.3': ' For purposes of this Agreement, the term',
    'terms.termsParagraph1.4': '"you"',
    'terms.termsParagraph1.5':
      'and possessives thereof mean you, the individual who registers for access to ' +
      'WorldQuant BRAIN or accesses or uses WorldQuant BRAIN.',

    'terms.termsParagraph2.1': '2.',
    'terms.termsParagraph2.2': 'License to WorldQuant BRAIN and Output.',
    'terms.termsParagraph2.3':
      ' In consideration of Your License, we ' +
      'hereby grant to you the following license: (a) a royalty-free, non-exclusive ' +
      'right and license to access and use WorldQuant BRAIN in those jurisdictions from which ' +
      'you initiate or we provide access to the WorldQuant BRAIN website for as long as you ' +
      'are a registered user of WorldQuant BRAIN, and (b) a royalty-free, worldwide, ' +
      'transferable, sublicenseable, irrevocable, non-exclusive, perpetual right ' +
      'and license to freely use, copy, distribute, exploit, and prepare derivative ' +
      'works based upon the output of the WorldQuant BRAIN application resulting from your ' +
      'use (',
    'terms.termsParagraph2.4': '"Output"',
    'terms.termsParagraph2.5':
      'and/or to incorporate any and all of Output into other ' +
      'works in any form, media, or technology now known or later developed (such ' +
      'license in clauses (a) and (b), collectively hereinafter referred to as',
    'terms.termsParagraph2.6': '"Our License"',
    'terms.termsParagraph2.7': ').',

    'terms.termsParagraph3.1': '3.',
    'terms.termsParagraph3.2': 'License to Input.',
    'terms.termsParagraph3.3':
      ' In consideration of Our License, you hereby ' +
      'grant to us a royalty-free, worldwide, fully transferable, sublicenseable, ' +
      'irrevocable, non-exclusive, perpetual right and license to freely use, copy, ' +
      'distribute, make available to the public by any means, modify, adapt, ' +
      'translate, exploit, perform, display, make, sell, offer for sale, import, ' +
      'export and prepare derivative works based upon any and all code, algorithms, ' +
      'ideas, comments, recommendations, methods, designs, plans, techniques, ' +
      'processes, calculations, analyses, or other feedback, data or information ' +
      '(other than personal data or information) that you input into or provide at ' +
      'WorldQuant BRAIN or otherwise provide to us or that is incorporated into or reflected ' +
      'or effectuated by any of the foregoing (in whole or part) (any of the ' +
      'foregoing, individually or collectively,',
    'terms.termsParagraph3.4': '"Input"',
    'terms.termsParagraph3.5':
      'and/or to ' +
      'incorporate any and all of Input into other works in any form, media, or ' +
      'technology now known or later developed (such right and license, ' +
      'collectively hereinafter referred to as',
    'terms.termsParagraph3.6': '"Your License"',
    'terms.termsParagraph3.7':
      '. Moreover, ' +
      'unless otherwise restricted by applicable law, you hereby waive and, to the ' +
      'extent not waiveable, agree not to exercise any',
    'terms.termsParagraph3.8': '"moral rights"',
    'terms.termsParagraph3.9':
      'or ' +
      'corresponding rights in other jurisdictions in having Input edited, removed, ' +
      'modified, published, transmitted or displayed in a manner not agreeable to ' +
      'you or having Input attributed to you.',

    'terms.termsParagraph4':
      '4. No Financial Compensation or Obligation to Offer Employment Or Other ' +
      'Business Relationship. Notwithstanding anything else in this or any other ' +
      'agreement or document, you will have no obligation whatsoever to (a) provide ' +
      'any compensation to us (other than Your License and your agreement to this ' +
      'Agreement) relating to Our License or your use of WorldQuant BRAIN or any Output, (b) ' +
      'share with us any revenue, gain or profit from your use of WorldQuant BRAIN or use or ' +
      'exploitation of any Input or Output, or (c) accept any offer of employment ' +
      'or any other relationship with us under any circumstances except if you ' +
      'agree to a written employment or business relationship agreement and then ' +
      'only as expressly stated in such agreement; and the fact that you do not ' +
      'provide any monetary compensation to us or agree to any employment or ' +
      'business relationship agreement with us will not affect any of your rights ' +
      'hereunder. Notwithstanding anything else in this or any other agreement or ' +
      'document, we will have no obligation whatsoever to (x) provide any ' +
      'compensation to you (other than Our License) relating to Your License or any ' +
      'Input or Output or (y) share with you any revenue, gain or profit from our ' +
      'use or exploitation of Your License or any Input or Output; or (z) offer any ' +
      'employment to you or any other relationship with you under any circumstances ' +
      'except if we elect in our sole discretion to provide you with a written ' +
      'employment or business relationship offer letter and then only as expressly ' +
      'stated in such letter; and the fact that we do not provide any monetary ' +
      'compensation to you or offer employment or any other relationship to you ' +
      'will not affect any of our rights hereunder.',

    'terms.termsParagraph5.1':
      '5. Ownership. Notwithstanding anything else in this Agreement or any other ' +
      'agreement, we (or in some cases, our licensors) have and will continue to ' +
      'have exclusive ownership of (a) WorldQuant BRAIN, (b) all the content (including ' +
      'audio, photographs, illustrations, graphics, other visuals and recordings, ' +
      'text, video, copy, software, trademarks, logos, etc.), code, data and ' +
      'materials thereon or therein (other than Input), the look and feel, design ' +
      'and organization of WorldQuant BRAIN, the compilation of the content, code and data ' +
      'thereon or therein, and the processes, inventions, materials and data used ' +
      'by WorldQuant BRAIN other than Input (the items in this clause (b) collectively, ',
    'terms.termsParagraph5.2': '"WorldQuant BRAIN Elements"',
    'terms.termsParagraph5.3':
      ', (c) all Output, and (d) all worldwide copyrights, ' +
      'patent rights, trademarks, rights in designs, rights in confidential ' +
      'information, trade secret rights and other intellectual property rights and ' +
      'registrations and applications for registrations (collectively,',
    'terms.termsParagraph5.4': '"IP"',
    'terms.termsParagraph5.5':
      ') ' +
      'in, to or related to any of WorldQuant BRAIN, Output or WorldQuant BRAIN Elements, and to the ' +
      'extent that you have or obtain any of such IP, you hereby transfer and ' +
      'assign and agree to transfer and assign (or shall procure the transfer and ' +
      'assignment of) such IP to us fully and unconditionally on a royalty-free and ' +
      'worldwide basis in perpetuity and agree to execute such documents as we may ' +
      'request to memorialize or perfect any of the foregoing. Moreover, to the ' +
      'extent permissible under applicable law, you hereby waive or, to the extent ' +
      'not waiveable, agree not to exercise any',
    'terms.termsParagraph5.6': '"moral rights"',
    'terms.termsParagraph5.7':
      'or ' +
      'corresponding or equivalent rights in other jurisdictions in having Output ' +
      'edited, removed, modified, published, transmitted or displayed in a manner ' +
      'not agreeable to you.',

    'registrationGetMetadada.1': "At the moment isn't possible to sign up.",
    'registrationGetMetadada.edit': "At the moment isn't possible to edit your account.",
    'registrationGetMetadada.2': ' Try again later',
    'registrationGetMetadada.3': 'Thank you.',
    'app.thank.you': 'Thank you.',

    'registrationMain.1': 'Sign Up',
    'registrationMain.2': 'Create Account',
    'registrationMain.3': 'Already signed up?',
    'registrationMain.4': 'Sign in here.',
    'registrationMain.5': 'WorldQuant BRAIN User Agreement',
    'registrationMain.6': ' WorldQuant BRAIN User Agreement',
    'registrationMain.7': 'Back',
    'registrationMain.8': 'Recertify Account',
    'registrationMain.recertification': 'Recertification',
    'registrationMain.continue': 'Continue',

    'resending.email.error.message': 'Something went wrong resending email verification link, try again later',
    'reset.password.error.message': 'The password reset link is not valid. Please contact support for further assistance.',
    'captcha.error.message': 'Captcha required to sign in.',
    'authentication.captcha.field.error': 'Captcha required',
    'captcha.incorrect.message': 'Incorrect captcha, please try again.',
    'captcha.challenge.fetch.error': 'Failed to fetch captcha challenge. Try refreshing the page.',

    'edit.properties.simulate.to.save': 'Simulate to save',
    'edit.properties.saving.progress': 'Saving...',
    'edit.properties.last.saved': 'Last saved {date}',
    'editorMain.edit.properties.title': 'Edit Properties',
    'edit.properties.name': 'Name',
    'edit.properties.alphaId': 'Alpha ID',
    'edit.properties.title': 'Properties',
    'edit.properties.category': 'Category',
    'edit.properties.tags': 'Tags',
    'edit.properties.color': 'Color',
    'edit.properties.osmosisPoints': 'Osmosis Points',
    'edit.properties.description': 'Description',
    'edit.properties.description.selection': 'Description of Selection Expression*',
    'edit.properties.description.combo': 'Description of Combo Expression*',
    'edit.properties.description.label':
      'Short descriptions of your Selection Expression and Combo Expression are required to submit this SuperAlpha.',
    'edit.properties.description.character.minimum': '{charactersLength} / 100 character minimum',
    'edit.properties.osmosisPoints.range': 'The value must be between 1 and 100,000.',
    'edit.properties.osmosisPoints.failed': 'Failed to update Osmosis Points.',
    'edit.properties.osmosisPoints.success': 'Successfully updated!',
    'edit.properties.osmosisPoints.tooltip': 'Click to edit Osmosis Points ({min}-{max})',
    'edit.properties.template.PowerPool.title': 'Power Pool Alpha',
    'edit.properties.template.PowerPool.description':
      'In order to submit this alpha, you have to add an alpha description following the given template.',
    'edit.properties.template.PowerPool.use': 'Use the template',
    'error.boundary.1': 'An Application Error Has Occurred',
    'error.boundary.2':
      'The application encountered an error which has been reported to the WorldQuant BRAIN Team. ' +
      'Please try refreshing the page or returning to the ',
    'error.boundary.4': 'Dashboard.',
    'error.boundary.5': 'Please contact ',
    'error.boundary.6': 'support',
    'error.boundary.7': ' if this problem persists.',
    'registrationSubmitted.1': 'Verify Your Email Address',
    'registrationSubmitted.2': 'A verification email has been sent to you.',
    'registrationSubmitted.3': 'You can explore BRAIN for 24 hours and verify your email later.',
    'registrationSubmitted.4': 'After 24 hours, you must confirm your email before sign in.',
    'registrationSubmitted.5.1': `If you don't see the email, please check your spam/junk folder or `,
    'registrationSubmitted.5.2': 'resend the verification email.',
    'registrationSubmittedUnapproved.body': 'Please verify it and then sign in to BRAIN to get started.',
    'registration.lets.get.started': 'Explore BRAIN now',
    'registration.sign.in': 'Sign In',
    'registrationSubmittedLocked.1': 'Account Pending Approval',
    'registrationSubmittedLocked.2': 'Your account is pending approval. Please check your email for further instructions.',
    'registrationSubmittedLocked.3':
      "Please allow up to 24 hours to receive the email. If you don't find it in your inbox, please check your " +
      'junk/spam folder. If you are still unable to find it, your mail ' +
      "server's filters may be blocking incoming messages sent from us. " +
      'In that case, kindly register with WorldQuant BRAIN again using a ' +
      'well-known web-based mail client such as Gmail, Yahoo, Hotmail, ' +
      'etc.',
    'registrationSubmittedLocked.4': 'Thank you.',
    'registration.HIGHSCHOOL': 'High School',
    'registration.ASSOCIATE': 'Associate',
    'registration.BACHELORS': 'Bachelors',
    'registration.MASTERS': 'Masters',
    'registration.DOCTORAL': 'Doctoral',
    'account.employerInfo.3': '3. What is your job title?',
    'account.employerInfo.2': '2. What is your employer’s primary business?',
    'account.email.verified.title': 'Email Address Verified',
    'account.email.verified.text': 'Thank you for verifying your email! Please ',
    'account.email.verified.link': 'sign in',
    'account.email.verified.text2': ' to WorldQuant BRAIN!',
    'account.email.verified.sign.in.text': "Thank you for verifying your email! Let's ",
    'account.email.verified.sign.in.link': 'get started',
    'account.change.email.verified.title': 'Email Change Verified',
    'account.change.email.verified.text': 'Thank you for verifying your email! ',
    'account.change.email.verified.text2': 'Return to ',
    'account.change.email.verified.link': 'profile',
    'account.change.email.locked.text1': 'Thank you for verifying your email! Your account is locked. ',
    'account.change.email.locked.text2': 'Please check your email for further information. ',
    'account.change.email.locked.text3': 'You will be notified when your account is ready to use.',

    'registrationVerified.6': 'Invalid Verification Link',
    'registrationVerified.7': 'The email verification link is not valid, has expired or you might have already verified your email.',
    'registrationVerified.8': 'Please ',
    'registrationVerified.9': 'sign in',
    'registrationVerified.10': ' to WorldQuant BRAIN or you can',
    'registrationVerified.11': 'resend',
    'registrationVerified.12': ' the verification email.',
    'registration.basic.details': '{extra} Basic Details',
    'registration.location': '{extra} Location',
    'registration.education': '{extra} Education',
    'registration.employment': '{extra} Employment',
    'registration.recertify.account': '{extra} Recertify Account',

    'registration.invalid.fields': ' Some fields are invalid',

    'recertification.invalid': "Something went wrong, It wasn't possible to do the recertification. Try again",

    'resetPasswordMain.1': 'Reset Password',
    'resetPasswordMain.2': 'Your password has been reset.',
    'resetPasswordMain.3': 'Please',
    'resetPasswordMain.4': 'sign in',
    'resetPasswordMain.5': 'to WorldQuant BRAIN.',
    'resetPasswordMain.6': 'Password',
    'resetPasswordMain.7': 'Password Confirmation',
    'resetPasswordMain.type.new.password': 'Type a new password.',
    'setPasswordMain.emailLabel': 'Email',

    'setPasswordMain.1': 'Set Password',
    'setPasswordMain.2': 'Your password has been set.',
    'setPasswordMain.3': 'Please',
    'setPasswordMain.4': 'sign in',
    'setPasswordMain.5': 'to WorldQuant BRAIN.',
    'setPasswordMain.6': 'Password',
    'setPasswordMain.7': 'Password Confirmation',
    'setPasswordMain.type.new.password': 'Type a password.',

    'selectColumns.1': 'Select Columns',
    'selectColumns.2': 'Reset',
    'selectColumns.3': 'Apply',
    'app.reset': 'Reset',
    'app.apply': 'Apply',

    'selectColumns.wihtoutCategories.1': 'Columns',

    'simulationVisualization.takesTime': ' Simulations usually take a few minutes or more. ',
    'simulationVisualization.1': ' Click ',
    'simulationVisualization.2': 'here ',
    'simulationVisualization.3': 'to cancel the simulation.',
    'simulationVisualization.4': ' Simulate an alpha to view the results here. ',

    'simulationVisualization.simulationLearn.1': 'Learn',
    'simulationVisualization.simulationLearn.2': 'Browse More',
    'table.filter.status.UNSUBMITTED': 'Unsubmitted',
    'table.filter.status.SUBMITTED': 'Submitted',
    'table.filter.status.OSTEST-PENDING': 'Ostest Pending',
    'table.filter.status.OSTEST-PASS': 'Ostest Pass',
    'table.filter.status.OSTEST-FAIL': 'Ostest Fail',
    'table.filter.status.OSTEST-DECM': 'Ostest Decm',
    'table.filter.status.OSTEST-CORR-PASS': 'Ostest Corr-pass',
    'table.filter.status.OSTEST2-PENDING': 'Ostest2 Pending',
    'table.filter.status.PROD-PENDING': 'Prod Pending',
    'table.filter.status.PROD': 'Prod',
    'table.filter.status.PROD-DECM': 'Prod Decm',
    'table.filter.status.PROD-HOLD': 'Prod Hold',
    'table.getInput.1': 'Multi',
    'table.listPopup.1': 'Simulation Settings',
    'table.tableFiler.1': 'Search',

    'tablePagination.show': 'Page size',
    'tablePagination.showing': 'Showing',
    'tablePagination.outOf': 'out of',
    'tablePagination.3': 'Compare Alphas',
    'tablePagination.4': 'Prev',
    'tablePagination.5': 'Next',

    'pagination.show.results': 'Showing {pageSize} of {numOfResults} ',
    'pagination.show.results.related': ' related {value}',

    'teamCreateActions.1': 'Team Agreement',
    'teamCreateActions.2': 'Cancel',
    'teamCreateActions.3': 'Create New Team',

    'teamCreateActionsEdit.1': 'Terminate Team',
    'teamCreateActionsEdit.2': 'Cancel',
    'teamCreateActionsEdit.3': 'Save Edit',

    'teamCreateMain.1': 'Team Name',
    'teamCreateMain.2': 'University',

    'teamDateFields.1': 'Start Date',
    'teamDateFields.2': 'End Date (optional)',

    'teamMembers.teamMember.1': 'Alias',
    'teamMembers.teamMember.2': 'Email',

    'teamMembersContent.1': 'Team Members',
    'teamMembersContent.2': '(3 members are required to create a team)',
    'teamMembersContent.3': 'Status',
    'teamMembersContent.4': 'Team Creator',

    'teamMenu.1': 'Create a New Team',

    'team.pending.waiting': 'This team is pending until all members accept the team invite.',
    'team.terminated.message': 'Your previous team was terminated because {userId} declined to join.',

    'team.consultant.two.teams':
      'You are already on a pending or active team. You must terminate your existing team before accepting a new team invitation.',

    'active.team.name': 'Team Name',
    'active.team.date.created': 'Created',
    'active.team.country': 'Country / Region',
    'active.team.university': 'University',
    'active.team.email': 'Email',
    'active.team.weight': 'Weight',

    'alpha.code.cannot.view.code.noUser': 'You cannot view this code because it was authored by another user.',
    'alpha.code.cannot.view.code.withOrigin': 'You cannot view this code because it was authored in {origin}.',

    'alpha.properties.cannot.view.noUser': 'You cannot view alpha properties because it was authored by another user.',
    'alpha.properties.cannot.view.withOrigin': 'You cannot view alpha properties because it was authored in {origin}.',

    'active.team.ACCEPTED': 'Active',
    'active.team.PENDING': 'Pending',
    'active.team.REJECTED': 'Declined',

    'team.save.changes': 'Save Changes',
    'team.create.team': 'Create Team',
    'team.cancel': 'Cancel',

    'active.team.remove': 'remove',
    'active.team.leave': 'leave',
    'active.team.terminate': 'terminate',

    'active.team.team.name.invalid':
      "Please enter a new, valid Team name. It should be between 1 and {maxLengthTeamName} characters (alphanumeric, spaces and '-' allowed).",
    'active.team.team.name.invalid.default': 'Please enter a new, valid Team name',
    'active.team.team.email.invalid': 'Please enter a valid email address.',
    'active.team.empty.weight': 'Please enter a valid weight.',
    'active.team.team.email.invalid.same': 'Email already exists please type a different one',
    'active.team.max.weight': 'The sum of all team member weights cannot exceed 100%',
    'active.team.team.repeated.email': 'Please save changes before re-adding a team member',
    'active.team.duplicate.team.name': 'Team name already exists, please try other',

    'leave.team.content':
      'You will forfeit using any alphas that you have created while on this team for the {competitionName}. ' +
      'The alphas created in the current team will be left in the team for scoring purposes.',
    'leave.team.button.leave': 'Leave Team',
    'leave.team.button.cancel': 'Cancel',
    'leave.team.button.title': 'Are you sure you want to leave this team?',

    'terminate.team.content': 'Terminating a team cannot be undone.',
    'leave.team.button.terminate': 'Terminate Team',
    'terminate.team.button.title': 'Are you sure you want to terminate this team for all members?',

    'members.label': 'Members',
    'members.status': 'Status',
    'members.action': ' ',
    'members.errors': ' ',
    'members.user': 'User',
    'members.weight': 'Weight %',
    'min.max.required.members': '(Min: {minRequiredMembers} members / Max: {maxRequiredMembers} members)',

    'teams.non.consultant.terms': 'I confirm that I have discussed forming this team with all members.',
    'teams.consultant.terms':
      'I confirm that I have discussed forming this team with all members,' +
      ' including the shared weight distribution and the roles and responsibilities of each member.',

    'team.active.members': 'Active Members',
    'team.active.past.members': 'Past Members',
    'team.active.summary': 'Summary',
    'team.active.total.alphas.submitted': 'Total alphas submitted',
    'team.active.total.alphas.simulated': 'Total alphas simulated',
    'team.active.score': 'Team Score',
    'team.active.rank': 'Team Rank',

    'team.active.table.user': 'User',
    'team.active.table.simulated': 'Simulated',
    'team.active.table.submitted': 'Submitted',

    // This is inside Team(Folder)/Terms(Folder)/Terms
    // Ends with teams.terms.termsParagraph.12
    'team.terms.1':
      'I, the team lead, have discussed team formation with all ' +
      'group members listed the details of sharing weight as specified ' +
      'above and our respective team roles/responsibilities. I confirm ' +
      'that I have discussed the team setup and weight distribution with all members.',

    'team.terms.2': 'I Agree',

    'default.title.no.team': 'No Active Team',
    'default.title.enroll.competition': 'Enroll in a Team Competition',
    'default.title.enroll.consultant.competition': 'Create a Consultant Team',

    'no.enroll.team.message':
      'You are not enrolled in any team-based competitions.' +
      ' Select a team-based competition currently running or upcoming to enroll in.',
    'no.team.message':
      'You are enrolled in the {competitionName} but currently not on an active team.' +
      ' Create a new team or accept a team invitation in the “Team Invitations” tab.',

    'no.team.message.consultant':
      'You are currently not participating in a Consultant team.' +
      ' Create a new team or accept a team invitation in the “Team Invitations” tab.',

    'team.create.new.team.button': 'Create a Team',
    'team.create.enroll.button': 'Enroll',

    'team.create.error.message': 'Some Went Wrong To Create a Team',
    'team.accept.error.message': 'Some Went Wrong To Accept a Team',
    'team.reject.error.message': 'Some Went Wrong To Reject a Team',
    'team.user.weight': 'Weight {weight}%',
    'team.member.max.min.members':
      '(Min: {minRequiredMembers, plural, one {# member} other {# members}}  ' +
      '/ Max: {maxMembers, plural, one {# member} other {# members}})',
    'team.edit.error.message': 'Some Went Wrong Editing a team, try again later',
    'team.me': '(Me)',
    'team.empty.slot': 'Empty Slot',
    'non.brain-user': 'Non-BRAIN User',
    'team.change.title': 'You are currently on an active team.{br}Do you want to join this new team?',
    'team.change.text1':
      'If you choose to join this team, you will leave your current active team, {teamName} ' +
      'and you may forfeit using any alphas in {competition} which you have created before now.',
    'team.change.text2':
      'If all members of your current active team are invited and accept their invitations  ' +
      'to join {invitingTeam}, then those teams will be merged.',
    'team.change.text3':
      'Please allow 24 hours for this merge process to complete. When two ' +
      'teams are merged, note that the alphas from the invited team must pass all submission checks, including ' +
      'self-correlation, with respect to all submitted alphas of the inviting team. This means that some alphas ' +
      'may fail submission tests during the merge process.',
    'agreements.agree.join.team': 'Agree and Join Team',

    'team.merge.title': 'Do you want to merge your team?',
    'team.merge.text1': "Your previous team's alphas are being merged with your new team.",
    'team.merge.text2':
      'Please allow 24 hours for this merge process to complete. When two ' +
      'teams are merged, note that all alphas from both teams must pass all submission checks, including ' +
      'self-correlation, with respect to all submitted alphas from both teams. This means that some alphas ' +
      'may fail submission tests during the merge process. When alphas fail a self-correlation test, the alpha' +
      ' with the highest fitness will be kept.',

    'teams.terms.termsParagraph.1':
      '1. 	All alphas submitted by any member during the period identified above – inclusive of the ' +
      'start date and end date – will have split authorship as per the weight % and team members ' +
      'specified above. No member will receive 100% of the weight with respect to any alphas ' +
      'submitted by him/her during this period. No side agreement among team members regarding ' +
      'the sharing percentages will be honored. If at any point the weight distribution is not ' +
      'acceptable to a team member, he/she can leave the team resulting in the termination of ' +
      'the team.',
    'teams.terms.termsParagraph.2':
      '2.  The start date mentioned on the form must be a date in the future. The default will ' +
      'be today+1 but the actual effective start date of the team will be date on which all ' +
      'participants have agreed to team formation or the elected team start date, whichever is ' +
      'later. The company can change the start and end dates at its discretion if the procedures ' +
      'set forth herein are not followed.',
    'teams.terms.termsParagraph.3':
      '3.  The start date mentioned on the form must be a date in the future. The default will ' +
      'be today+1 but the actual effective start date of the team will be date on which all ' +
      'participants have agreed to team formation or the elected team start date, whichever is ' +
      'later. The company can change the start and end dates at its discretion if the ' +
      'procedures set forth herein are not followed. ',
    'teams.terms.termsParagraph.4':
      '4.  Once the team is formed and effective, i.e. the above listed criteria are met, new ' +
      'alphas submitted will be marked for weight distribution. Any alphas submitted before the ' +
      '“effective start date” or after the “effective end date” will NOT be tagged as per the ' +
      'allocation specified above.',
    'teams.terms.termsParagraph.5':
      '5. Alphas that are shared will be marked as such on the primary author’s “Alpha” pages ' +
      'on WorldQuant BRAIN. The primary author is considered the one simulating and submitting the alpha.',
    'teams.terms.termsParagraph.6':
      '6.  SimWt and ActualWt for shared alphas will reflect as the per weight % specified above ' +
      'even though the alpha can be viewed only by the primary author.',
    'teams.terms.termsParagraph.7':
      '7. 	The system will keep track of weight and PNL allocation for shared alphas based on the above table.',
    'teams.terms.termsParagraph.8':
      '8.  The team can be terminated before the end date by any member or by the company. Any ' +
      'alpha submitted after the team has been terminated will not be tagged as a team alpha ' +
      'and instead will be treated as an alpha submitted by the individual (unless the author ' +
      'is a member of a new team that was formed before the alpha was submitted).',
    'teams.terms.termsParagraph.9':
      '9.  The team will also be automatically terminated if one or more members leave the ' +
      'research consultant position before the team end date.',
    'teams.terms.termsParagraph.10':
      '10. Teams should be formed after discussion about roles, responsibilities, expectations, ' +
      'etc., among all team members. Once formed, there will be no change in weight allocation ' +
      'among team members until the team end date or until the time at which the team is earlier ' +
      'terminated.',
    'teams.terms.termsParagraph.11':
      '11. If a consultant has prior simulated alphas that are not submitted but submits them ' +
      'after the formation of the team, the alpha will be counted as a team alpha. Every member ' +
      'should make sure that they submit any alphas pending submission prior to team formation ' +
      'if they want full credit and don’t want to share weight with team members.',
    'teams.terms.termsParagraph.12':
      '12. 	We anticipate providing each team member with the ability to see and access all ' +
      'team alphas in a future WorldQuant BRAIN release. This functionality would enable all team members ' +
      'to see anyalpha simulated or submitted by any team member during the team’s existence. ' +
      'Access to such shared alphas will remain even when a team is terminated. It is possible ' +
      'for a member to later on submit “improved” alphas based on the team alphas. The alpha ' +
      'will be considered a new alpha individually authored by the person who submits it so ' +
      'long as it meets the criteria for being considered an “improvement” over the original ' +
      'alpha according to applicable thresholds. Please take this into account when creating ' +
      'your teams.',
    'userReferrals.alias': 'User',
    'userReferrals.country': 'Country',
    'userReferrals.lastSignIn': 'Last Sign-in',
    'userReferrals.status': 'Status',
    'userReferrals.consultantStartDate': 'Consultant Start Date',
    'userReferrals.bonus': 'Referral bonus',
    'userReferrals.referrals': 'Referred by your Referee',
    'userReferrals.status.user': 'User',
    'userReferrals.status.conditionalConsultant': 'Conditional Consultant',
    'userReferrals.status.consultant': 'Consultant',
    'userReferrals.status.referralCriteriaComplete': 'Referral criteria complete',
    'userReferrals.signInDate.lastDay': 'A day ago',
    'userReferrals.signInDate.lastWeek': 'Last week',
    'userReferrals.signInDate.moreThanOneWeek': 'More than a week ago',
    'userReferrals.signInDate.moreThanTwoWeeks': 'More than two weeks ago',
    'userReferrals.signInDate.lastMonth': 'Last month',
    'userReferrals.signInDate.moreThanOneMonth': 'More than a month ago',
    'userReferrals.signInDate.moreThanTwoMonths': 'More than two months ago',
    'userReferrals.signInDate.moreThanThreeMonths': 'More than three months ago',
    'userReferrals.signInDate.never': 'Never',
    'userReferrals.error': 'There was a problem loading referral stats.',
    'userReferrals.noReferrals': 'There are no referrals yet.',
    'userReferrals.startLink': 'Start referring.',
    'userReferrals.programLink': 'Referral program and your referral link.',

    'teamMain.teamButtons.1': 'Edit Team',
    'teamMain.teamButtons.2': 'Terminate',
    'teamMain.teamButtons.3': 'Reject',
    'teamMain.teamButtons.4': 'Accept',

    'active-filters-country': 'Country / Region',
    'active-filters-type': 'Category',
    'active-filters-language': 'Language',
    'active-filters-city': 'City',

    'events.filter.placeholder.country': 'Country / Region',
    'events.filter.placeholder.type': 'Category',
    'events.filter.placeholder.language': 'Language',
    'events.filter.placeholder.city': 'City',

    'event.date.time': 'Date & Time',
    'event.duration': 'Duration',
    'event.venue': 'At Venue',
    'event.online': 'Online',
    'event.language': 'Language',
    'event.venue.location': 'Venue Location',
    'events.filter': 'Filter',
    'events.no.results': 'Filter',
    'events.reset': 'Reset',
    'events.apply': 'Apply',
    'events.atvenue': 'At Venue',
    'events.webinar': 'Webinar',
    'events.get.directions': 'Get Directions',
    'events.events': 'Events',
    'events.online': 'Online',
    'events.noResults.dashboard': "At the moment there aren't any events",
    'messages.noResults': 'No Messages Found',
    'messages.title': 'Messages',
    'messages.all.read': 'Mark all as read',

    'teamMain.wrappedTeamMain.1': 'Team Agreement',
    'teamMain.wrappedTeamMain.2': '(Me)',
    'profile.agreements.list.title': 'Select an agreement to view the terms and conditions.',
    'profile.invalidUser': 'Invalid User',
    'profile.teamButton': 'Invite to Active Team',
    'profile.webSimMember': 'WorldQuant BRAIN member ',
    'profile.geniusLevel': 'Current Genius level: <b>{level}</b>',
    'profile.userIDLabel': 'User ID: ',
    'profile.consultant': 'Consultant ',
    'profile.researcher': 'Researcher ',
    'profile.university': 'University',
    'profile.agreements.modal.title': 'Agreements',
    'profile.agreements.team': 'Team: {name}',
    'profile.agreements.competition': 'Competition: {name}',
    'reverify.title': 'Resend Verification Email',
    'reverify.email.label': 'Email Address',
    'reverify.submit.button': 'Resend',
    'reverify.success':
      'A verification email has been sent. Please check your email for further instructions. ' +
      "If you don't find it in your inbox, please check your junk/spam folder.",

    'intro.Dashboard.1.title': 'Welcome aboard!',
    'intro.Dashboard.2.title': 'Profile',
    'intro.Dashboard.2.content.1': `Modify your <linkInNewTabProfileAccountBasicDetails>Account</linkInNewTabProfileAccountBasicDetails> details.`,
    'intro.Dashboard.2.content.2': `Check out your <linkInNewTabProfileAchievements>Achievements</linkInNewTabProfileAchievements>.`,
    'intro.Dashboard.3.title': 'Learn how to succeed on WorldQuant BRAIN',
    'intro.Dashboard.3.content':
      'Check out the video <linkInNewTabLearnCourses>Courses</linkInNewTabLearnCourses>, ' +
      '<linkInNewTabLearnDocumentation>Documentation</linkInNewTabLearnDocumentation> ' +
      'and the list of <linkInNewTabLearnDataAndOperators>datasets & operators</linkInNewTabLearnDataAndOperators>.',
    'intro.Dashboard.4.title': 'Need more help?',
    'intro.Dashboard.4.content':
      'In the <linkInNewTabSupport>Support</linkInNewTabSupport>' +
      ' section - search for <linkInNewTabHelpCenterFAQs>FAQs</linkInNewTabHelpCenterFAQs>' +
      ' or <linkInNewtabHelpCenterNewRequest>submit a request</linkInNewtabHelpCenterNewRequest>.',
    'intro.Dashboard.5.title': 'Catch up with us through Events',
    'intro.Dashboard.5.content': 'Keep track of upcoming webinars and on-location training sessions.',
    'intro.Dashboard.6.title': 'Get the latest updates',
    'intro.Dashboard.6.content.1':
      'Keep track of the latest ' +
      '<linkInNewTabMessagesAnnoucementsAll>Announcements</linkInNewTabMessagesAnnoucementsAll> from the WorldQuant BRAIN Team.',
    'intro.Dashboard.6.content.2': `Checkout the <linkInNewTabMessagesNotificationsAll>Notifications</linkInNewTabMessagesNotificationsAll> to view your latest achievements.`,
    'intro.Dashboard.7.title': 'Participate and compete',
    'intro.Dashboard.7.content': 'Enroll in upcoming and ongoing competitions.',
    'intro.Dashboard.8.title': "Let's get started!",

    'intro.Dashboard-consultant.1.title': 'Congratulations and Welcome!',
    'intro.Dashboard-consultant.1.content': 'We are very excited to have you on-board as a Consultant.',
    'intro.Dashboard-consultant.2.title': 'Compensation',
    'intro.Dashboard-consultant.2.content':
      `Check out your <linkInNewTabProfilePerformance>Performance</linkInNewTabProfilePerformance> ` +
      'and view your base payment and quarterly payment.',
    'intro.Dashboard-consultant.3.title': 'Learn about consultant only features',
    'intro.Dashboard-consultant.3.content':
      'Check out the <linkInNewTabLearnConsultantDatasets>Consultant Datasets</linkInNewTabLearnConsultantDatasets>, ' +
      '<linkInNewTabLearnConsultantDosAndDonts>Dos and Donts</linkInNewTabLearnConsultantDosAndDonts>, ' +
      '<linkInNewTabLearnConsultantVisualizationTool>Visualization tool</linkInNewTabLearnConsultantVisualizationTool>, ' +
      '<linkInNewTabLearnMultiAlphaSimulation>Multi-Simulation</linkInNewTabLearnMultiAlphaSimulation>, ' +
      'and detailed information about <linkInNewTabLearnConsultantFAQs>alpha testing</linkInNewTabLearnConsultantFAQs>.',
    'intro.Dashboard-consultant.4.title': 'Learn about BRAIN Genius',
    'intro.Dashboard-consultant.4.content':
      'Learn more about our <linkInNewTabGeniusDashboard>Genius program</linkInNewTabGeniusDashboard> and check out your Genius level and other metrics here.',
    'intro.Dashboard-consultant.5.title': 'Need more help?',
    'intro.Dashboard-consultant.5.content':
      'In the <linkInNewTabSupport>Support</linkInNewTabSupport>' +
      ' section - search for <linkInNewTabHelpCenterFAQs>FAQs</linkInNewTabHelpCenterFAQs>' +
      ', interact with the <linkInNewTabHelpCenterCommunityTopics>community</linkInNewTabHelpCenterCommunityTopics>' +
      ' on consultant threads or <linkInNewtabHelpCenterNewRequest>submit a request</linkInNewtabHelpCenterNewRequest>.',
    'intro.Dashboard-consultant.6.title': 'Consultant Leaderboard',
    'intro.Dashboard-consultant.6.content': 'Track your performance on the <b>Consultant Leaderboard</b>.',

    'intro.simulation.1.title': 'Welcome to the Simulate Screen',
    'intro.simulation.1.content': "Let's help you get started with building your first alpha",
    'intro.simulation.2.title': 'Simulation Settings',
    'intro.simulation.2.content.1': "You can change your alpha's simulation settings by opening the <b>Simulation settings</b> menu.",
    'intro.simulation.2.content.2': 'Click on the blue tooltip above each simulation setting to learn more.',
    'intro.simulation.3.title': 'Build your Alpha here',
    'intro.simulation.3.content': 'An Alpha expression has data fields, operators and numerical parameters. More on that later.',
    'intro.simulation.4.title': 'Simulate your Alpha',
    'intro.simulation.4.content': 'Please click <strong>Example</strong> button to load a sample Alpha.',
    'intro.simulation.5.title': 'Simulate your Alpha',
    'intro.simulation.5.content': 'Please click <strong>Simulate</strong> button to see the output for the in-sample period.',
    'intro.simulation.6.title': 'Congratulations! You have done your first simulation!',
    'intro.simulation.6.content':
      'You can check out the <linkInNewTabLearnAlphaExamples>Alpha examples</linkInNewTabLearnAlphaExamples> page for more inspiration.',
    'intro.simulation.7.title': `<linkInNewTabLearnSimulationResults>IS Summary</linkInNewTabLearnSimulationResults>`,
    'intro.simulation.7.content.1':
      'Cyan line depicts <b>PnL</b> (Profit and Loss) with respect to time.\n' +
      '<b>Test period</b> is shown as orange line in the PnL graph.',
    'intro.simulation.7.content.2': 'Click the dropdown menu to display 3 performance metrics: PnL, Sharpe and Turnover.',
    'intro.simulation.7.1.title': `<linkInNewTabLearnTestPeriod>Test Period performance</linkInNewTabLearnTestPeriod>`,
    'intro.simulation.7.1.content.1': 'Click on the "Show test period" button to reveal your test period performance.',
    'intro.simulation.7.1.content.2':
      'You can change your test period in the settings tab. To read more, <linkInNewTabLearnTestPeriod>click here</linkInNewTabLearnTestPeriod>',
    'intro.simulation.8.title': 'Submitting your Alpha',
    'intro.simulation.8.content':
      'Once <linkInNewTabLearnAlphaSubmission>the criteria</linkInNewTabLearnAlphaSubmission> is satisfied, ' +
      'submit your alpha for <linkInNewTabLearnSemiOsOs>out of sample</linkInNewTabLearnSemiOsOs> testing.',
    'intro.alphas.1.title': 'Alpha Stages',
    'intro.alphas.1.content.1': '<b>Unsubmitted</b> (UNSUB) shows your simulated alphas.',
    'intro.alphas.1.content.2': '<b>Submitted</b> (SUBM) shows your submitted alphas.',
    'intro.alphas.2.title': 'Filters',
    'intro.alphas.2.content.1':
      'You can filter your alphas based on their settings or performance statistics like Sharpe, fitness and turnover.',
    'intro.alphas.3.title': 'Alpha Actions',
    'intro.alphas.3.content.1.title': 'Clone Alpha',
    'intro.alphas.3.content.1': 'View your alpha code with simulation settings and clone the alpha.',
    'intro.alphas.3.content.2.title': 'Add to Alpha List',
    'intro.alphas.3.content.2': 'Compare performance of your alphas by adding them to alpha lists.',
    'intro.alphas.3.content.3.title': 'Favorites',
    'intro.alphas.3.content.3': 'Favorite your alphas.',
    'intro.alphas.4.title': 'Alpha Lists',
    'intro.alphas.4.content.1': 'This shows your lists and lets you compare the performance of your alphas.',

    'statusMessageIS.HT_TURNOVER.PASS': 'High Turnover: Turnover of <strong>{value}</strong> is above cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.HT_TURNOVER.WARNING':
      'High Turnover: Turnover of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.HT_PNL_REALIZATION_HORIZON.PASS':
      'High Turnover: Pnl realization of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.HT_PNL_REALIZATION_HORIZON.WARNING':
      'High Turnover: Pnl realization of <strong>{value}</strong> is above cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.HT_HIGH_TURNOVER_RETURNS_RATIO.PASS':
      'High Turnover: High Turnover returns ratio of <strong>{value}</strong> is above cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.HT_HIGH_TURNOVER_RETURNS_RATIO.WARNING':
      'High Turnover: High Turnover returns ratio of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.HT_INVESTABLE_MAX_TRADE_SHARPE.PASS':
      'Investable High Turnover: Max Trade Sharpe of <strong>{value}</strong> is above cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.HT_INVESTABLE_MAX_TRADE_SHARPE.WARNING':
      'Investable High Turnover: Max Trade Sharpe of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.HT_INVESTABLE_MAX_TRADE_TURNOVER.PASS':
      'Investable High Turnover: Max Trade turnover of <strong>{value}</strong> is above cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.HT_INVESTABLE_MAX_TRADE_TURNOVER.WARNING':
      'Investable High Turnover: Max Trade turnover of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.HT_INVESTABLE_MAX_POSITION_SHARPE.PASS':
      'Investable High Turnover: Max Position Sharpe of <strong>{value}</strong> is above cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.HT_INVESTABLE_MAX_POSITION_SHARPE.WARNING':
      'Investable High Turnover: Max Position Sharpe of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.HT_INVESTABLE_MAX_POSITION_TURNOVER.PASS':
      'Investable High Turnover: Max Position turnover of <strong>{value}</strong> is above cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.HT_INVESTABLE_MAX_POSITION_TURNOVER.WARNING':
      'Investable High Turnover: Max Position turnover of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.HT_LIQUID_TOP200_SHARPE.PASS':
      'Liquid High Turnover: TOP200 Sharpe of <strong>{value}</strong> is above cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.HT_LIQUID_TOP200_SHARPE.WARNING':
      'Liquid High Turnover: TOP200 Sharpe of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.HT_LIQUID_TOPDIV3000_SHARPE.PASS':
      'Liquid High Turnover: TOPDIV3000 Sharpe of <strong>{value}</strong> is above cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.HT_LIQUID_TOPDIV3000_SHARPE.WARNING':
      'Liquid High Turnover: TOPDIV3000 Sharpe of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.HT_LIQUID_TOP500_TOP200_SHARPE_RATIO.PASS':
      'Liquid High Turnover: TOP500 and TOP200 Sharpe ratio of <strong>{value}</strong> is above cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.HT_LIQUID_TOP500_TOP200_SHARPE_RATIO.WARNING':
      'Liquid High Turnover: TOP500 and TOP200 Sharpe ratio of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.HT_LIQUID_MINVOL10M_TOPDIV3000_SHARPE_RATIO.PASS':
      'Liquid High Turnover: MINVOL10M and TOPDIV3000 Sharpe ratio of <strong>{value}</strong> is above cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.HT_LIQUID_MINVOL10M_TOPDIV3000_SHARPE_RATIO.WARNING':
      'Liquid High Turnover: MINVOL10M and TOPTOPDIV3000200 Sharpe ratio of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.HT_AFTER_COST_SHARPE.PASS':
      'After Cost High Turnover: After cost Sharpe of <strong>{value}</strong> is above cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.HT_AFTER_COST_SHARPE.WARNING':
      'After Cost High Turnover: After cost Sharpe of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.HT_ORTHOGONAL_RAM_NEUTRALIZATION.PASS':
      'Orthogonal High Turnover: Neutralization of <strong>{value}</strong> matches Orthogonal High Turnover neutralization of <strong>{limit}</strong>.',
    'statusMessageIS.HT_ORTHOGONAL_RAM_NEUTRALIZATION.WARNING':
      'Orthogonal High Turnover: Neutralization of <strong>{value}</strong> does not match Orthogonal High Turnover neutralization of <strong>{limit}</strong>.',
    'statusMessageIS.USER_DEFINED_FIELDS.FAIL': "Alphas containing user defined fields and can't be submitted.",
    'statusMessageIS.OSMOSIS_ALLOCATION.WARNING': '<linkToDailyOsmosisRank>Daily Osmosis Rank</linkToDailyOsmosisRank> not generated.',
    'statusMessageIS.AVAILABLE_SETTING.FAIL': 'Alpha settings are unsubmittable.',
    'statusMessageIS.LOW_DURATION.FAIL':
      'Simulation length of <strong>{value}</strong> days is below cutoff of <strong>{limit}</strong> days.',
    'statusMessageIS.LOW_DURATION.ERROR': 'Simulation length check error.',
    'statusMessageIS.LOW_COVERAGE.FAIL':
      'Zero coverage length of <strong>{value}</strong> days is above cutoff of <strong>{limit}</strong> days.',
    'statusMessageIS.LOW_COVERAGE.ERROR': 'Zero coverage length check error.',
    'statusMessageIS.LOW_FITNESS.FAIL':
      '<linkToBetterFitness>Fitness</linkToBetterFitness> of <strong>{value}</strong> is below cutoff of <b>{limit}</b>.',
    'statusMessageIS.LOW_FITNESS.PASS': 'Fitness of <strong>{value}</strong> is above cutoff of <b>{limit}</b>.',
    'statusMessageIS.LOW_FITNESS.WARNING': 'Fitness of <strong>{value}</strong> is below cutoff of <b>{limit}</b>.',
    'statusMessageIS.LOW_FITNESS.ERROR': 'Fitness check error.',
    'statusMessageIS.LOW_SHARPE.FAIL':
      '<linkToBetterSharpe>Sharpe</linkToBetterSharpe> of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.LOW_SHARPE.WARNING':
      '<linkToBetterSharpe>Sharpe</linkToBetterSharpe> of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.LOW_SHARPE.PASS': 'Sharpe of <strong>{value}</strong> is above cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.LOW_SHARPE.ERROR': 'Sharpe check error.',
    'statusMessageIS.LOW_RETURNS.WARNING':
      '<linkToBetterReturn>Returns</linkToBetterReturn> of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.LOW_RETURNS.FAIL':
      '<linkToBetterReturn>Returns</linkToBetterReturn> of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.LOW_RETURNS.PASS': 'Returns of <strong>{value}</strong> is above cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.LOW_RETURNS.ERROR': 'Returns check error.',
    'statusMessageIS.LOW_TURNOVER.FAIL':
      '<linkToBetterTurnover>Turnover</linkToBetterTurnover> of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.LOW_TURNOVER.PASS': 'Turnover of <strong>{value}</strong> is above cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.LOW_TURNOVER.ERROR': 'Turnover check error.',
    'statusMessageIS.HIGH_TURNOVER.FAIL':
      '<linkToBetterTurnover>Turnover</linkToBetterTurnover> of <strong>{value}</strong> is above cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.HIGH_TURNOVER.PASS': 'Turnover of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.HIGH_TURNOVER.ERROR': 'Turnover check error.',
    'statusMessageIS.CONCENTRATED_WEIGHT.FAIL': 'Weight is too strongly concentrated or too few instruments are assigned weight.',
    'statusMessageIS.CONCENTRATED_WEIGHT.WITH_VALUES.FAIL':
      '<linkToBetterWeight>Weight concentration</linkToBetterWeight> <strong>{value}</strong> is above cutoff of <strong>{limit}</strong> on <strong>{date, date}</strong>.',
    'statusMessageIS.CONCENTRATED_WEIGHT.WARNING': 'Weight is too strongly concentrated or too few instruments are assigned weight.',
    'statusMessageIS.CONCENTRATED_WEIGHT.WITH_VALUES.WARNING':
      '<linkToBetterWeight>Weight concentration</linkToBetterWeight> <strong>{value}</strong> is above cutoff of <strong>{limit}</strong> on <strong>{date, date}</strong>.',
    'statusMessageIS.CONCENTRATED_WEIGHT.PASS': 'Weight is well distributed over instruments.',
    'statusMessageIS.CONCENTRATED_WEIGHT.WITH_VALUES.PASS':
      'Weight is well distributed over instruments. <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>',
    'statusMessageIS.CONCENTRATED_WEIGHT.ERROR': 'Weight check error.',
    'statusMessageIS.CONCENTRATED_WEIGHT.PENDING': 'Weight concentration test pending.',
    'statusMessageIS.IMBALANCE.FAIL':
      'Imbalance of <strong>{value}</strong> is above cutoff of <strong>{limit}</strong> on <strong>{date, date}</strong>. ' +
      'Check neutralization setting.',
    'statusMessageIS.IMBALANCE.PASS': 'Imbalance of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.IMBALANCE.ERROR': 'Imbalance check error.',
    'statusMessageIS.IMBALANCE.PENDING': 'Imbalance check pending.',
    'statusMessageIS.SUB_UNIVERSE_SHARPE.PASS':
      'Sub-universe Sharpe of <strong>{value}</strong> is above cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.SUB_UNIVERSE_SHARPE.FAIL':
      '<linkToBetterSubUniverseSharpe>Sub-universe Sharpe</linkToBetterSubUniverseSharpe> of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.SUB_UNIVERSE_SHARPE.WARNING': 'There is a high likelihood of failing the sub-universe check after submission.',
    'statusMessageIS.SUB_UNIVERSE_SHARPE.ERROR': 'Sub-universe Sharpe check error.',
    'statusMessageIS.LOW_SUB_UNIVERSE_SHARPE.PASS':
      'Sub-universe Sharpe of <strong>{value}</strong> is above cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.LOW_SUB_UNIVERSE_SHARPE.FAIL':
      '<linkToBetterSubUniverseSharpe>Sub-universe Sharpe</linkToBetterSubUniverseSharpe> of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.LOW_SUB_UNIVERSE_SHARPE.WARNING': 'There is a high likelihood of failing the sub-universe check after submission.',
    'statusMessageIS.LOW_SUB_UNIVERSE_SHARPE.ERROR': 'Sub-universe universe Sharpe check error.',
    'statusMessageIS.LOW_ROBUST_UNIVERSE_SHARPE.WITH_RATIO.PASS':
      'Robust universe Sharpe of <strong>{value}</strong> is above cutoff of <strong>{limit}</strong> ({ratio} of Alpha).',
    'statusMessageIS.LOW_ROBUST_UNIVERSE_SHARPE.WITH_RATIO.WARNING':
      'Robust universe Sharpe of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong> ({ratio} of Alpha).',
    'statusMessageIS.LOW_ROBUST_UNIVERSE_SHARPE.WITH_RATIO.FAIL':
      'Robust universe Sharpe of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong> ({ratio} of Alpha).',
    'statusMessageIS.LOW_ROBUST_UNIVERSE_SHARPE.WITH_RATIO.ERROR': 'Robust universe Sharpe check error.',
    'statusMessageIS.LOW_ROBUST_UNIVERSE_SHARPE.PASS':
      'Robust universe Sharpe of <strong>{value}</strong> is above cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.LOW_ROBUST_UNIVERSE_SHARPE.WARNING':
      'Robust universe Sharpe of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.LOW_ROBUST_UNIVERSE_SHARPE.FAIL':
      'Robust universe Sharpe of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.LOW_ROBUST_UNIVERSE_SHARPE.ERROR': 'Robust universe Sharpe check error.',
    'statusMessageIS.LOW_ROBUST_UNIVERSE_RETURNS.PASS':
      'Robust universe returns of <strong>{value}</strong> is above cutoff of <strong>{limit}</strong> ({ratio} of Alpha).',
    'statusMessageIS.LOW_ROBUST_UNIVERSE_RETURNS.WARNING':
      'Robust universe returns of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong> ({ratio} of Alpha).',
    'statusMessageIS.LOW_ROBUST_UNIVERSE_RETURNS.FAIL':
      'Robust universe returns of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong> ({ratio} of Alpha).',
    'statusMessageIS.LOW_ROBUST_UNIVERSE_RETURNS.ERROR': 'Robust universe returns check error.',
    'statusMessageIS.LOW_AFTER_COST_ILLIQUID_UNIVERSE_SHARPE.PASS':
      'Most illiquid 50% instruments <linkToAfterCostSharpe>after cost Sharpe</linkToAfterCostSharpe> of <strong>{value}</strong> is above cutoff of <strong>{limit}</strong> ({afterCostSharpe} original universe after cost Sharpe).',
    'statusMessageIS.LOW_AFTER_COST_ILLIQUID_UNIVERSE_SHARPE.WARNING':
      'Most illiquid 50% instruments <linkToAfterCostSharpe>after cost Sharpe</linkToAfterCostSharpe> of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong> ({afterCostSharpe} original universe after cost Sharpe).',
    'statusMessageIS.LOW_AFTER_COST_ILLIQUID_UNIVERSE_SHARPE.FAIL':
      'Most illiquid 50% instruments <linkToAfterCostSharpe>after cost Sharpe</linkToAfterCostSharpe> of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong> ({afterCostSharpe} original universe after cost Sharpe).',
    'statusMessageIS.LOW_AFTER_COST_ILLIQUID_UNIVERSE_SHARPE.ERROR': 'Most illiquid 50% instruments after cost Sharpe check error.',
    'statusMessageIS.linkToBetterSubUniverseSharpe': 'How do I resolve this error: “Sub-universe Sharpe NaN is not above cutoff…”?',
    'statusMessageIS.linkToBetterFitness': 'How to increase fitness of alphas',
    'statusMessageIS.linkToBetterSharpe': 'How to improve Sharpe?',
    'statusMessageIS.linkToBetterReturn': 'How to improve returns?',
    'statusMessageIS.linkToBetterTurnover': 'How to improve Turnover?',
    'statusMessageIS.linkToBetterWeight': 'Weight Coverage common issues and advice',
    'statusMessageIS.linkToBetterCorrelation': 'How do you reduce correlation of a good Alpha?',
    'statusMessageIS.linkToBetterLadder': 'Ideas to clear the submission test - IS ladder Sharpe is below cutoff for ladder year',

    'statusMessageIS.RISK_PRECISE.PASS': 'Risk neutralization is "Precise".',
    'statusMessageIS.RISK_PRECISE.FAIL': 'Risk neutralization is not "Precise".',
    'statusMessageIS.D0_SUBMISSION.PASS': 'D0 submissions <strong>{value}</strong> below quota of <strong>{limit}</strong>.',
    'statusMessageIS.D0_SUBMISSION.FAIL': 'D0 submissions <strong>{value}</strong> reached quota of <strong>{limit}</strong>.',
    'statusMessageIS.D0_SUBMISSION.WARNING': 'D0 submissions <strong>{value}</strong> approaching quota of <strong>{limit}</strong>.',
    'statusMessageIS.D0_SUBMISSION.PENDING': 'D0 submissions quota check pending.',
    'statusMessageIS.REGULAR_SUBMISSION.PASS': 'Alpha submissions <strong>{value}</strong> below quota of <strong>{limit}</strong>.',
    'statusMessageIS.REGULAR_SUBMISSION.FAIL': 'Alpha submissions <strong>{value}</strong> reached quota of <strong>{limit}</strong>.',
    'statusMessageIS.REGULAR_SUBMISSION.WARNING':
      'Alpha submissions <strong>{value}</strong> approaching quota of <strong>{limit}</strong>.',
    'statusMessageIS.REGULAR_SUBMISSION_REACHED.WARNING':
      'Alpha submissions <strong>{value}</strong> reached quota of <strong>{limit}</strong>.',
    'statusMessageIS.REGULAR_SUBMISSION.PENDING': 'Alpha submissions quota check pending.',
    'statusMessageIS.SUPER_SUBMISSION.PASS': 'SuperAlpha submissions <strong>{value}</strong> below quota of <strong>{limit}</strong>.',
    'statusMessageIS.SUPER_SUBMISSION.FAIL': 'SuperAlpha submissions <strong>{value}</strong> reached quota of <strong>{limit}</strong>.',
    'statusMessageIS.SUPER_SUBMISSION.WARNING':
      'SuperAlpha submissions <strong>{value}</strong> approaching quota of <strong>{limit}</strong>.',
    'statusMessageIS.SUPER_SUBMISSION.PENDING': 'SuperAlpha submissions quota check pending.',
    'statusMessageIS.POWER_POOL_SUBMISSION.PASS':
      'Power Pool submissions <strong>{value}</strong> below quota of <strong>{limit}</strong>.',
    'statusMessageIS.POWER_POOL_SUBMISSION.FAIL':
      'Power Pool submissions <strong>{value}</strong> reached quota of <strong>{limit}</strong>.',
    'statusMessageIS.POWER_POOL_SUBMISSION.WARNING':
      'Power Pool submissions <strong>{value}</strong> approaching quota of <strong>{limit}</strong>.',
    'statusMessageIS.POWER_POOL_SUBMISSION_REACHED.WARNING':
      'Power Pool submissions <strong>{value}</strong> reached quota of <strong>{limit}</strong>.',
    'statusMessageIS.POWER_POOL_MONTHLY_SUBMISSION.PASS':
      'Power Pool {scope} monthly submissions <strong>{value}</strong> below quota of <strong>{limit}</strong>.',
    'statusMessageIS.POWER_POOL_MONTHLY_SUBMISSION.FAIL':
      'Power Pool {scope} monthly submissions <strong>{value}</strong> reached quota of <strong>{limit}</strong>.',
    'statusMessageIS.POWER_POOL_MONTHLY_SUBMISSION.WARNING':
      'Power Pool {scope} monthly submissions <strong>{value}</strong> approaching quota of <strong>{limit}</strong>.',
    'statusMessageIS.POWER_POOL_MONTHLY_SUBMISSION_REACHED.WARNING':
      'Power Pool {scope} monthly submissions <strong>{value}</strong> reached quota of <strong>{limit}</strong>.',
    'statusMessageIS.PURE_POWER_POOL_THEME.FAIL':
      'Pure Power Pool submission does not match any <linkPowerPoolTheme>Power Pool Theme</linkPowerPoolTheme>.',
    'statusMessageIS.RESEARCHER_REGULAR_SUBMISSION.PASS':
      'Researcher Alpha submissions <strong>{value}</strong> below quota of <strong>{limit}</strong>.',
    'statusMessageIS.RESEARCHER_REGULAR_SUBMISSION.FAIL':
      'Researcher Alpha submissions <strong>{value}</strong> reached quota of <strong>{limit}</strong>.',
    'statusMessageIS.RESEARCHER_REGULAR_SUBMISSION.WARNING':
      'Researcher Alpha submissions <strong>{value}</strong> approaching quota of <strong>{limit}</strong>.',
    'statusMessageIS.RESEARCHER_REGULAR_SUBMISSION.PENDING': 'Researcher Alpha submissions quota check pending.',
    'statusMessageIS.IQC2026S3_NON_THEME_SUBMISSION.PASS':
      'Non-theme submissions <strong>{value}</strong> below quota of <strong>{limit}</strong>.',
    'statusMessageIS.IQC2026S3_NON_THEME_SUBMISSION.FAIL':
      'Non-theme submissions <strong>{value}</strong> reached quota of <strong>{limit}</strong>.',
    'statusMessageIS.IQC2026S3_NON_THEME_SUBMISSION.WARNING':
      'Non-theme submissions <strong>{value}</strong> approaching quota of <strong>{limit}</strong>.',
    'statusMessageIS.REGULAR_SUBMISSION_COMPENSATION.WARNING':
      'Alpha submissions <strong>{value}</strong> reached compensation quota of <strong>{limit}</strong>; ' +
      'Submission quota is unlimited.',
    'statusMessageIS.SUPER_SUBMISSION_COMPENSATION.WARNING':
      'SuperAlpha submissions <strong>{value}</strong> reached compensation quota of <strong>{limit}</strong>; ' +
      'Submission quota is unlimited.',
    'statusMessageIS.GLOBAL_SUMMIT_SUBMISSION.FAIL': 'Submissions disabled till 23:59 PM EST, 8 Dec 2023',
    'statusMessageIS.USA_D1_FUNDAMENTAL.FAIL': 'USA D1 fundamental data Alphas are not permitted for Inter-IIT Tech Meet participants.',
    'statusMessageIS.ALREADY_SUBMITTED.FAIL': 'Alpha already submitted.',
    'statusMessageIS.IS_LADDER_SHARPE.FAIL':
      '<linkToBetterLadder>IS ladder Sharpe</linkToBetterLadder> of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong> ' +
      'for ladder year <strong>{year}</strong>: <strong>{startDate, date}</strong>…<strong>{endDate, date}</strong>.',
    'statusMessageIS.IS_LADDER_SHARPE.WARNING':
      'IS ladder Sharpe of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong> ' +
      'for ladder year <strong>{year}</strong>: <strong>{startDate, date}</strong>…<strong>{endDate, date}</strong>.',
    'statusMessageIS.IS_LADDER_SHARPE.PENDING': 'IS ladder Sharpe check pending.',
    'statusMessageIS.IS_LADDER_SHARPE.PASS':
      'IS ladder Sharpe of <strong>{value}</strong> is above cutoff of <strong>{limit}</strong> ' +
      'for ladder year <strong>{year}</strong>: <strong>{startDate, date}</strong>…<strong>{endDate, date}</strong>.',
    'statusMessageIS.IS_LADDER_SHARPE.ERROR': 'IS ladder Sharpe check error.',
    'statusMessageIS.LOW_2Y_SHARPE.FAIL':
      '<linkToBetterSharpe>2 year Sharpe</linkToBetterSharpe> of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.LOW_2Y_SHARPE.WARNING':
      '<linkToBetterSharpe>2 year Sharpe</linkToBetterSharpe> of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.LOW_2Y_SHARPE.PASS': `{value, select, 
        null {2 year Sharpe is above cutoff of <strong>{limit}</strong>.} 
        other {2 year Sharpe of <strong>{value}</strong> is above cutoff of <strong>{limit}</strong>.}
      }`,
    'statusMessageIS.LOW_2Y_SHARPE.ERROR': '2 year Sharpe check error.',
    'statusMessageIS.NEUTRALIZATION.FAIL':
      'Universe <strong>{universe}</strong> does not allow neutralization <strong>{neutralization}</strong>.',
    'statusMessageIS.OLD_SIMULATION.FAIL': "The simulation doesn't match the current IS period. Please clone this alpha and re-simulate.",
    'statusMessageIS.LONG_DURATION.FAIL': 'The simulation duration is too short please clone this alpha and re-simulate.',
    'statusMessageIS.SUBMISSION_DENIED.FAIL': 'You are not permitted to submit alphas.',
    'statusMessageIS.SELF_SUPER_ALPHA.PASS': 'This alpha is self SuperAlpha.',
    'statusMessageIS.NON_SELF_SUPER_ALPHA.PENDING': 'Non-self SuperAlpha check pending.',
    'statusMessageIS.NON_SELF_SUPER_ALPHA.PASS':
      'Non-self SuperAlpha submissions <strong>{value}</strong> below quota of <strong>{limit}</strong>.',
    'statusMessageIS.NON_SELF_SUPER_ALPHA.WARNING':
      'Non-self SuperAlpha submissions <strong>{value}</strong> reached quota of <strong>{limit}</strong>.',
    'statusMessageIS.NON_SELF_SUPER_ALPHA.FAIL':
      'Non-self SuperAlpha submissions <strong>{value}</strong> reached quota of <strong>{limit}</strong>.',
    'statusMessageIS.COMPONENT_ALPHA_AUTHORIZATION.FAIL':
      'Your SuperAlpha contains unauthorized component alphas, please clone this alpha and re-simulate.',
    'statusMessageIS.COMPONENT_ALPHA_AUTHORIZATION.ERROR': 'Unauthorized component alphas check error.',
    'statusMessageIS.SELF_CORRELATION.FAIL':
      '<linkToBetterCorrelation>Self-correlation</linkToBetterCorrelation> <strong>{value}</strong> is above cutoff of <strong>{limit}</strong> and Sharpe not better by 10.0% or more.',
    'statusMessageIS.SELF_CORRELATION.WARNING':
      '<linkToBetterCorrelation>Self-correlation</linkToBetterCorrelation> <strong>{value}</strong> is above cutoff of <strong>{limit}</strong> and Sharpe not better by 10.0% or more.',
    'statusMessageIS.SELF_CORRELATION.PENDING': 'Self-correlation check pending.',
    'statusMessageIS.SELF_CORRELATION.PASS':
      'Self-correlation is <strong>{value}</strong>, which is above cutoff of <strong>{limit}</strong>, or Sharpe is better by 10.0% or more.',
    'statusMessageIS.SELF_CORRELATION.ERROR': 'Self-correlation check error.',
    'statusMessageIS.PROD_CORRELATION.FAIL':
      '<linkToBetterCorrelation>Prod correlation</linkToBetterCorrelation> <strong>{value}</strong> is above cutoff of ' +
      '<strong>{limit}</strong> ' +
      'and Sharpe not better by 10.0% or more.',
    'statusMessageIS.PROD_CORRELATION.WARNING':
      '<linkToBetterCorrelation>Prod correlation</linkToBetterCorrelation> <strong>{value}</strong> is above cutoff of ' +
      '<strong>{limit}</strong> ' +
      'and Sharpe not better by 10.0% or more.',
    'statusMessageIS.PROD_CORRELATION.PENDING': 'Production correlation check pending.',
    'statusMessageIS.PROD_CORRELATION.PASS':
      'Prod correlation <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>, or Sharpe is better by 10.0% or more.',
    'statusMessageIS.PROD_CORRELATION.ERROR': 'Prod correlation check error.',
    'statusMessageIS.POWER_POOL_CORRELATION.WARNING':
      '<linkToBetterCorrelation>Power Pool correlation</linkToBetterCorrelation> <strong>{value}</strong> is above cutoff of ' +
      '<strong>{limit}</strong> ' +
      'and Sharpe not better by 10.0% or more.',
    'statusMessageIS.POWER_POOL_CORRELATION.PENDING': 'Power Pool correlation check pending.',
    'statusMessageIS.POWER_POOL_CORRELATION.PASS':
      'Power Pool correlation <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>, or Sharpe is better by 10.0% or more.',
    'statusMessageIS.POWER_POOL_CORRELATION.ERROR': 'Power Pool correlation check error.',
    'statusMessageIS.CLUSTER_TEST.PASS':
      'Cluster Test Sharpe <strong>{value}</strong> is above cutoff of <strong>{limit}</strong>. Alpha qualifies as Cluster Alpha.',
    'statusMessageIS.CLUSTER_TEST.WARNING':
      'Cluster Test Sharpe <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>. Alpha does not qualify as Cluster Alpha.',
    'statusMessageIS.CLUSTER_TEST.ERROR': 'Cluster Test check error.',
    'statusMessageIS.UNITS.WARNING': '{message}',
    'statusMessageIS.SELECTION.WARNING': '{message}',
    'statusMessageIS.COMBO_DESCRIPTION_LENGTH.FAIL':
      'Combo description length <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.SELECTION_DESCRIPTION_LENGTH.FAIL':
      'Selection description length <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.POWER_POOL_DESCRIPTION_LENGTH.WARNING':
      'Description length <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.POWER_POOL_DESCRIPTION_FORMAT.WARNING':
      'Description is not in the correct format for the Power Pool Competition 2025.',
    'statusMessageIS.NON_PRODUCTIONIZABLE.WARNING': 'This alpha is non-productionizable.',
    'statusMessageIS.MATCHES_THEMES.ERROR': 'Theme check error.',
    'statusMessageIS.MATCHES_THEMES.PASS.single': 'Theme <strong>{name}</strong> matches with multiplier of <strong>{multiplier}</strong>.',
    'statusMessageIS.MATCHES_CLASSIFICATION.PASS.single': 'Classification <strong>{value}</strong> matches',
    'statusMessageIS.MATCHES_CLASSIFICATION.PASS.multiple': 'Classifications <strong>{value}</strong> match',
    'statusMessageIS.MATCHES_PYRAMID.PASS.single':
      'Pyramid theme <strong>{name}</strong> matches with multiplier of <strong>{multiplier}</strong>. Effective pyramid count for Genius is <strong>{effective}</strong>.',
    'statusMessageIS.MATCHES_THEMES.PASS.multiple':
      'These themes match with the following multipliers: <strong>{matches}</strong>. The final theme multiplier is <strong>{finalMultiplier}</strong>.',
    'statusMessageIS.MATCHES_PYRAMID.PASS.multiple':
      'These pyramid themes match with the following multipliers: <strong>{matches}</strong>. ' +
      'The final pyramid theme multiplier is <strong>{finalMultiplier}</strong>. ' +
      'Effective pyramid count for Genius is <strong>{effective}</strong>.',
    'statusMessageIS.LOW_GLB_AMER_SHARPE.FAIL':
      'AMER <linkToBetterSharpe>Sharpe</linkToBetterSharpe> of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.LOW_GLB_APAC_SHARPE.FAIL':
      'APAC <linkToBetterSharpe>Sharpe</linkToBetterSharpe> of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.LOW_GLB_EMEA_SHARPE.FAIL':
      'EMEA <linkToBetterSharpe>Sharpe</linkToBetterSharpe> of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.LOW_GLB_AMER_SHARPE.PASS': 'AMER Sharpe of <strong>{value}</strong> is above cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.LOW_GLB_APAC_SHARPE.PASS': 'APAC Sharpe of <strong>{value}</strong> is above cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.LOW_GLB_EMEA_SHARPE.PASS': 'EMEA Sharpe of <strong>{value}</strong> is above cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.LOW_GLB_AMER_SHARPE.WARNING':
      'AMER <linkToBetterSharpe>Sharpe</linkToBetterSharpe> of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.LOW_GLB_APAC_SHARPE.WARNING':
      'APAC <linkToBetterSharpe>Sharpe</linkToBetterSharpe> of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.LOW_GLB_EMEA_SHARPE.WARNING':
      'EMEA <linkToBetterSharpe>Sharpe</linkToBetterSharpe> of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.LOW_GLB_AMER_SHARPE.ERROR': 'AMER Sharpe check error.',
    'statusMessageIS.LOW_GLB_APAC_SHARPE.ERROR': 'APAC Sharpe check error.',
    'statusMessageIS.LOW_GLB_EMEA_SHARPE.ERROR': 'EMEA Sharpe check error.',
    'statusMessageIS.LOW_ASI_JPN_SHARPE.FAIL':
      'Japan Robustness Sharpe of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.LOW_ASI_JPN_SHARPE.PASS':
      'Japan Robustness Sharpe of <strong>{value}</strong> is above cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.LOW_ASI_JPN_SHARPE.WARNING':
      'Japan Robustness Sharpe of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.LOW_ASI_JPN_SHARPE.ERROR': 'Japan Robustness Sharpe check error.',
    'statusMessageIS.LOW_INVESTABILITY_CONSTRAINED_SHARPE.FAIL':
      'Investability Constrained Sharpe of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.LOW_INVESTABILITY_CONSTRAINED_SHARPE.PASS':
      'Investability Constrained Sharpe of <strong>{value}</strong> is above cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.LOW_INVESTABILITY_CONSTRAINED_SHARPE.WARNING':
      'Investability Constrained Sharpe of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageIS.LOW_INVESTABILITY_CONSTRAINED_SHARPE.ERROR': 'Investability Constrained Sharpe check error.',
    'statusMessageIS.MATCHES_THEMES.WARNING.single':
      'Theme <strong>{name}</strong> does not match with multiplier of <strong>{multiplier}</strong>.',
    'statusMessageIS.MATCHES_THEMES.WARNING.multiple':
      'These themes do not match with the following multipliers: <strong>{matches}</strong>.',
    'statusMessageIS.MATCHES_THEMES.PENDING': 'Theme check pending.',
    'statusMessageIS.MATCHES_THEMES.PENDING.single':
      'Theme <strong>{name}</strong> with multiplier of <strong>{multiplier}</strong> will be processed when checking submission.',
    'statusMessageIS.MATCHES_THEMES.PENDING.multiple':
      'These themes with the following multipliers will be processed when checking submission: <strong>{matches}</strong>.',
    'statusMessageIS.MATCHES_COMPETITION.ERROR': 'Competition check error.',
    'statusMessageIS.MATCHES_COMPETITION.PASS.single': 'Competition <strong>{name}</strong> matches.',
    'statusMessageIS.MATCHES_COMPETITION.PASS.single.beginning': 'Competition ',
    'statusMessageIS.MATCHES_COMPETITION.PASS.single.end': ' matches.',
    'statusMessageIS.MATCHES_COMPETITION.PASS.multiple': 'These competitions match: <strong>{matches}</strong>.',
    'statusMessageIS.MATCHES_COMPETITION.PASS.multiple.beginning': 'These competitions match: ',
    'statusMessageIS.MATCHES_COMPETITION.PASS.multiple.end': '.',
    'statusMessageIS.MATCHES_COMPETITION.WARNING.single.beginning': 'Competition ',
    'statusMessageIS.MATCHES_COMPETITION.WARNING.single.end': ' does not match.',
    'statusMessageIS.MATCHES_COMPETITION.WARNING.single': 'Competition <strong>{name}</strong> does not match.',
    'statusMessageIS.MATCHES_COMPETITION.WARNING.multiple': 'These competitions do not match: <strong>{matches}</strong>.',
    'statusMessageIS.MATCHES_COMPETITION.WARNING.multiple.beginning': 'These competitions do not match: ',
    'statusMessageIS.MATCHES_COMPETITION.WARNING.multiple.end': '.',
    'statusMessageIS.MATCHES_COMPETITION.PENDING': 'Competition check pending.',
    'statusMessageIS.MATCHES_COMPETITION.PENDING.single.beginning': 'Competition check pending: ',
    'statusMessageIS.MATCHES_COMPETITION.PENDING.single.end': '.',
    'statusMessageIS.MATCHES_COMPETITION.PENDING.single': 'Competition check pending: <strong>{name}</strong>.',
    'statusMessageIS.MATCHES_COMPETITION.PENDING.multiple': 'Competition check pending: <strong>{matches}</strong>.',
    'statusMessageIS.MATCHES_COMPETITION.PENDING.multiple.beginning': 'Competition check pending: ',
    'statusMessageIS.MATCHES_COMPETITION.PENDING.multiple.end': '.',
    'statusMessageIS.ALPHA_AIAC_INELIGIBILITY_TAGS.WARNING': 'Alpha description/tag is not matching requirements of AIACv2.',
    'statusMessageIS.REVERSION_COMPONENT.WARNING':
      'Alpha expression includes a reversion component, and we may not accept these alphas in the future. ' +
      'Try working on different ideas for the alpha.',
    'statusMessageIS.DATA_DIVERSITY.PENDING': 'Data overuse check pending.',
    'statusMessageIS.DATA_DIVERSITY.PASS': 'Data overuse check passed.',
    'statusMessageIS.DATA_DIVERSITY.NOT_PASSED': 'Overused data <strong>{field}</strong> field(s) in <strong>{dataCategoryName}</strong>.',
    'statusMessageIS.COMPILE_ERROR.FAIL': '{message}',
    'statusMessageIS.DATA_SET_AUTHORIZATION.FAIL': 'Invalid datasets: {datasets}',
    'statusMessageIS.REGION_AUTHORIZATION.FAIL': 'Invalid region: {region}',
    'statusMessageIS.OPERATOR_AUTHORIZATION.FAIL': 'Invalid operators: {operators}',
    'statusMessageIS.ALPHA_DECOMMISSIONED.FAIL': 'Alpha is decommissioned',
    'statusMessageIS.TECHNICAL_TEST.PENDING': 'Technical test is pending.',
    'statusMessageIS.TECHNICAL_TEST.FAIL': 'Technical test failed.',
    'statusMessageIS.TECHNICAL_TEST.PASS': 'Technical test passed.',
    'statusMessageOS.OTHERS.FAIL': 'Other check failed.',
    'statusMessageOS.OTHERS.PASS': 'Other check passed.',
    'statusMessageOS.OTHERS.PENDING': 'Other check pending',
    'statusMessageOS.IS_SHARPE.FAIL': 'IS Sharpe check failed.',
    'statusMessageOS.IS_SHARPE.PASS': 'IS sharpe check passed.',
    'statusMessageOS.IS_SHARPE.PENDING': 'IS sharpe check pending.',
    'statusMessageOS.SHARPE.FAIL': 'Sharpe check failed.',
    'statusMessageOS.SHARPE.PASS': 'Sharpe check passed.',
    'statusMessageOS.SHARPE.PENDING': 'Sharpe check pending.',
    'statusMessageOS.SELF_CORRELATION.FAIL': 'Self-correlation check failed.',
    'statusMessageOS.SELF_CORRELATION.PASS': 'Self-correlation check passed.',
    'statusMessageOS.SELF_CORRELATION.PENDING': 'Self-correlation check pending.',
    'statusMessageOS.PROD_CORRELATION.FAIL': 'Prod correlation check failed.',
    'statusMessageOS.PROD_CORRELATION.PASS': 'Prod correlation check passed.',
    'statusMessageOS.PROD_CORRELATION.PENDING': 'Production correlation check pending.',
    'statusMessageOS.SUB_UNIVERSE_SHARPE.FAIL': 'Sub-universe Sharpe check failed.',
    'statusMessageOS.SUB_UNIVERSE_SHARPE.PASS': 'Sub-universe Sharpe check passed.',
    'statusMessageOS.SUB_UNIVERSE_SHARPE.PENDING': 'Sub-universe Sharpe check pending.',
    'statusMessageOS.DRAWDOWN.FAIL': 'Drawdown check failed.',
    'statusMessageOS.DRAWDOWN.PASS': 'Drawdown check passed.',
    'statusMessageOS.DRAWDOWN.PENDING': 'Drawdown check pending.',
    'statusMessageOS.WEIGHT.FAIL': 'Weight check failed.',
    'statusMessageOS.WEIGHT.PASS': 'Weight check passed.',
    'statusMessageOS.WEIGHT.PENDING': 'Weight check pending.',
    'statusMessageOS.MEMORY_USAGE.FAIL': 'Memory usage check failed.',
    'statusMessageOS.MEMORY_USAGE.PASS': 'Memory usage check passed.',
    'statusMessageOS.MEMORY_USAGE.PENDING': 'Memory usage check pending.',
    'statusMessageOS.NEW_HIGH.FAIL': 'New high check failed.',
    'statusMessageOS.NEW_HIGH.PASS': 'New high check passed.',
    'statusMessageOS.NEW_HIGH.PENDING': 'New high check pending.',
    'statusMessageOS.SUPER_UNIVERSE_SHARPE.FAIL': 'Super-universe Sharpe check failed.',
    'statusMessageOS.SUPER_UNIVERSE_SHARPE.PASS': 'Super-universe Sharpe check passed.',
    'statusMessageOS.SUPER_UNIVERSE_SHARPE.PENDING': 'Super-universe Sharpe check pending.',
    'statusMessageOS.RANK_SHARPE.FAIL': 'Rank Sharpe check failed.',
    'statusMessageOS.RANK_SHARPE.PASS': 'Rank sharpe check passed.',
    'statusMessageOS.RANK_SHARPE.PENDING': 'Rank sharpe check pending.',
    'statusMessageOS.INVALID_CODE.FAIL': 'Invalid Alpha code.',
    'statusMessageOS.INVALID_CODE.PASS': 'Invalid Alpha code.',
    'statusMessageOS.INVALID_CODE.PENDING': 'Invalid Alpha code.',
    'statusMessageOS.INVALID_UNIVERSE.FAIL': 'Invalid Universe.',
    'statusMessageOS.INVALID_UNIVERSE.PASS': 'Invalid Universe.',
    'statusMessageOS.INVALID_UNIVERSE.PENDING': 'Invalid Universe.',
    'statusMessageOS.DUPLICATE_ALPHA.FAIL': 'Duplicate Alpha.',
    'statusMessageOS.DUPLICATE_ALPHA.PASS': 'Duplicate Alpha.',
    'statusMessageOS.DUPLICATE_ALPHA.PENDING': 'Duplicate Alpha.',
    'statusMessageOS.BIAS.FAIL': 'Bias check failed.',
    'statusMessageOS.BIAS.PASS': 'Bias check passed.',
    'statusMessageOS.BIAS.PENDING': 'Bias check pending.',
    'statusMessageOS.CHECKPOINT.FAIL': 'Checkpoint check failed.',
    'statusMessageOS.CHECKPOINT.PASS': 'Checkpoint check passed.',
    'statusMessageOS.CHECKPOINT.PENDING': 'Checkpoint check pending.',
    'statusMessageOS.PRE_CLOSE_SHARPE.FAIL': 'Pre-close Sharpe check failed.',
    'statusMessageOS.PRE_CLOSE_SHARPE.PASS': 'Pre-close sharpe check passed.',
    'statusMessageOS.PRE_CLOSE_SHARPE.PENDING': 'Pre-close sharpe check pending.',
    'statusMessageOS.CONCENTRATED_WEIGHT.FAIL': 'Weight is too strongly concentrated or too few instruments are assigned weight.',
    'statusMessageOS.CONCENTRATED_WEIGHT.WITH_VALUES.FAIL':
      'Weight concentration <strong>{value}</strong> is above cutoff of <strong>{limit}</strong> on <strong>{date, date}</strong>.',
    'statusMessageOS.CONCENTRATED_WEIGHT.PASS': 'Weight is well distributed over instruments.',
    'statusMessageOS.CONCENTRATED_WEIGHT.WITH_VALUES.PASS':
      'Weight is well distributed over instruments. <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>',
    'statusMessageOS.CONCENTRATED_WEIGHT.ERROR': 'Weight check error.',
    'statusMessageOS.CONCENTRATED_WEIGHT.PENDING': 'Weight concentration test pending.',
    'statusMessageOS.IMBALANCE.FAIL':
      'Imbalance of <strong>{value}</strong> is above cutoff of <strong>{limit}</strong> on <strong>{date, date}</strong>. ' +
      'Check neutralization setting.',
    'statusMessageOS.IMBALANCE.PASS': 'Imbalance of <strong>{value}</strong> is below cutoff of <strong>{limit}</strong>.',
    'statusMessageOS.IMBALANCE.ERROR': 'Imbalance check error.',
    'statusMessageOS.IMBALANCE.PENDING': 'Imbalance check pending.',
    'statusMessageOS.TECHNICAL_TEST.PENDING': 'Technical test is pending.',
    'statusMessageOS.TECHNICAL_TEST.FAIL': 'Technical test failed.',
    'statusMessageOS.TECHNICAL_TEST.PASS': 'Technical test passed.',
    'statusMessageOS.COMPENSATED_ALPHA.WARNING': 'This alpha is not compensated.',
    'themeLabel.match': 'Theme: <strong>{name}</strong> x{multiplier}',
    'themeLabel.short': '<strong>{name}</strong> x{multiplier}',
    'themeLabel.hintTitle': 'Matching theme',

    'classificationLabel.match': '<strong>{description}</strong>',
    'classificationLabel.hintTitle': 'Matching classification',

    'pyramidLabel.match': 'Pyramid theme: <strong>{name}</strong> x{multiplier}',
    'pyramidLabel.hintTitle': 'Matching pyramid themes',

    'dataAction.alphaSucess': 'Alpha submitted successfully',
    'dataAction.failedChecks': 'Cannot submit Alpha: {count, number} {count, plural, one {test failed} other {tests failed}}',
    'actions.generic.error': 'Some error occurred submitting the alpha try again later',
    'contactUs.dropdown.question': 'How can I help you?*',
    'contactUs.dropdown.topic': 'Topic*',
    'contactUs.input.subject': 'Subject*',
    'contactUs.file.title': 'Attach File',
    'contactUs.file.types': 'jpg, jpeg or png',
    'contactUs.file.button': 'Select File',
    'contactUs.text.message': 'Message*',
    'contactUs.submit.button': 'Submit',
    'contactUs.file.description': 'No file selected',
    'contactUs.message.sent': 'Message Sent!',
    'contactUs.message.sent.thank1': 'Thank you for sending us your message.',
    'contactUs.message.sent.thank2': 'We will try to get back to you within 1-2 buisiness days.',
    'contactUsMain.sendUsFeedback':
      'Send us your questions and suggestions by filling out the form below. We look forward to hearing feedback!',
    'alphaSummary.name': 'Name',
    'alphaSummary.pnl': 'PnL',
    'alphaSummary.universe': 'Universe',
    'alphaSummary.turnover': 'Turnover',
    'alphaSummary.sharpe': 'Sharpe',
    'alphaSummary.margin': 'Margin',
    'alphaSummary.fitness': 'Fitness',
    'alphaSummary.bookSize': 'Book Size',
    'alphaSummary.longCount': 'Long Count',
    'alphaSummary.year': 'Year',
    'alphaSummary.shortCount': 'Short Count',
    'alphaSummary.returns': 'Returns',
    'alphaSummary.drawdown': 'Drawdown',
    'alphaSummary.simulationDate': 'Simulation Date',
    'alphaSummary.sharpe60': 'Sharpe 60',
    'alphaSummary.sharpe125': 'Sharpe 125',
    'alphaSummary.sharpe250': 'Sharpe 250',
    'alphaSummary.sharpe500': 'Sharpe 500',
    'alphaSummary.osISSharpeRatio': 'OS/IS Ratio',
    'alphaSummary.preCloseSharpe': 'Pre-Close Sharpe',
    'alphaSummary.preCloseSharpeRatio': 'Pre-Close Ratio',
    'alphaSummary.selfCorrelation': 'Self-Correlation',
    'alphaSummary.birthDate': 'Birth Date',
    'alphaSummary.startDate': 'Start Date',
    'alphaSummary.aggregateData': 'Aggregate Data',
    'alphaSummary.prodCorrelation': 'Prod Correlation',
    'alphaSummary.correlation.prod': 'Prod Correlation',
    'alphaSummary.correlation.self': 'Self Correlation',
    'alphaSummary.correlation.powerPool': 'Power Pool Correlation',
    'alphasDetails.settings.riskSummary': 'Risk neutralized',
    'alphasDetails.settings.investabilitySummary': 'Investability constrained',
    'upload.files.not.accept': 'Selected file is not an accepted format',
    'upload.files.size.large': 'Selected file exceeds max size 5MB',
    'alphas.filters.errors': 'The filter {filter} is invalid. Try a different syntax',
    'alphas.properties.errors': 'You changed the alpha properties without saving them',

    'alphas.addToList.title': 'Add to Alpha List',
    'alphas.removeFromList.title': 'Remove from Alpha List',
    'alphas.addSelectedToList.title': 'Add Selected to List',
    'alphas.removeSelectedFromList.title': 'Remove Selected from List',
    'alphas.addToFavorites.title': 'Add to Favorites',
    'alphas.removeFromFavorites.title': 'Remove from Favorites',
    'alphas.addSelectedToFavorites.title': 'Add Selected to Favorites',
    'alphas.removeSelectedFromFavorites.title': 'Remove Selected from Favorites',
    'alphas.hideAlpha.title': 'Hide Alpha',
    'alphas.unhideAlpha.title': 'Unhide Alpha',
    'alphas.hideSelectedAlphas.title': 'Hide Selected Alphas',
    'alphas.unhideSelectedAlphas.title': 'Unhide Selected Alphas',
    'alphas.selectAlpha.title': 'Select Alpha',
    'alphas.unselectAlpha.title': 'Unselect Alpha',
    'alphas.selectAlphas.title': 'Select Alphas',
    'alphas.unselectAlphas.title': 'Unselect Alphas',
    'alphas.colorSelectedAlphas.title': 'Color Selected Alphas',

    'alphas.check.too.many.requests': 'You have reached the limit of concurrent Check Submission. Please wait for the previous to finish.',
    'alphas.submit.too.many.requests': 'You have reached the limit of concurrent Submit Alpha. Please wait for the previous to finish.',
    'alphas.submit.too.many.requests.link': 'limit of concurrent Submit Alpha',
    'alphas.correlation.too.many.requests': 'Correlation request limit reached. Please wait for a few minutes.',
    'alphas.selection.too.many.requests': 'You have reached the limit of concurrent Select Alphas. Please wait for a few minutes.',
    'alphas.list.too.many.requests': 'You have reached the limit of concurrent List Alphas. Please wait for a few minutes.',
    'alphas.correlation.not.available.resimulate': 'Correlation not available, please clone this alpha and re-simulate.',
    'alphas.correlation.unavailable': 'Correlations are currently unavailable. Please contact support if this problem persists.',

    'learn.videocourses.error': 'Something went wrong getting the Courses, please try again later',
    'learn.videocourse.error': 'Something went wrong getting the Course, please try again later',
    'learn.tableOfContents': 'Table of Contents',
    'events.month': 'Month',
    'events.week': 'Week',
    'events.day': 'Day',
    'events.prev': 'Prev',
    'events.next': 'Next',
    'events.today': 'Today',
    'events.registerHere': 'Register',
    'events.description': 'Description',
    'events.calendar': '+ Add to Calendar',

    'onboardingPopup.inviteApproved.title': 'Ready to unlock more features & potential compensation?',
    'onboardingPopup.inviteApproved.text':
      'Grandmaster level Consultants can potentially earn upwards of $8,000 or more in a quarterly payment amount. Start the application by simply submitting your details.',
    'onboardingPopup.inviteApproved.button': 'Apply to be a Research Consultant',

    'onboardingPopup.questionnaireApproved.title': 'Your questionnaire is approved!',
    'onboardingPopup.questionnaireApproved.text': 'You are one step away from accruing money for you alphas!',
    'onboardingPopup.questionnaireApproved.button': "Let's do this!",

    'onboardingPopup.backgroundCheckApproved.title': 'Ready to start earning as a Research Consultant?',
    'onboardingPopup.backgroundCheckApproved.text': 'Let us know your banking details.',
    'onboardingPopup.backgroundCheckApproved.button': 'Take me to Workday',

    'message.user.vbc':
      'and reserve your spot for <linkInNewTabGoToWebinarConsultantVBC1> 7:00 A.M. EDT</linkInNewTabGoToWebinarConsultantVBC1>' +
      ' or <linkInNewTabGoToWebinarConsultantVBC2>10:00 A.M. EDT</linkInNewTabGoToWebinarConsultantVBC2> session.',
    'message.consultant.vbc':
      "WorldQuant's Virtual Boot Camp available <strong>only to consultants</strong> will begin on August 13. " +
      'Reserve your spot for <linkInNewTabGoToWebinarVBC1>8:30 A.M. EDT</linkInNewTabGoToWebinarVBC1> or ' +
      '<linkInNewTabGoToWebinarVBC2>11:30 A.M. EDT</linkInNewTabGoToWebinarVBC2> session. ',

    'referralPage.title': 'Referral Program',
    'referralPage.subtitle': 'Refer & Earn - $100 with each{br} referred consultant*',
    'referralPage.firstFive': '(*for a limited time only)',
    'referralPage.referralLink': 'Referral link:',
    'referralPage.referralsTracker': 'Referrals Tracker',
    'referralPage.sharingHint': 'Please only use the following language when sharing your referral code over social media: ',
    'referralPage.sharingMessage':
      'Join WorldQuant BRAIN’s elite, global research community, using my referral code, to learn quant' +
      ' finance and start writing algorithms.',
    'referralPage.clickToCopy': 'Click to copy',
    'referralPage.copied': 'Copied',
    'referralPage.rightClickToCopyOrSaveTheQRCode': 'Right click to copy/save the QR code',
    'referralPage.useContent': 'You may use this content when you share your referral link with your friends:',
    'referralPage.copyPlaylistLink': 'Copy playlist and share in your channel',
    'referralPage.downloadLink': 'Download image pack',
    'referralPage.shareOnInstagram': 'Share Instagram reel',

    'referralPage.signInToStart': 'Sign in to start referring!',
    'referralPage.becomeConsultant': 'To be eligible for the referral program, you must become a consultant first.',
    'referralPage.becomeConsultant.learnHow': 'Learn how.',
    'referralPage.join': 'Sign In',
    'referralPage.rewardScheme': 'Reward scheme',
    'referralPage.upTo5': '$100 up to 5 referrals',
    'referralPage.from6': '$100 from 6th referral',
    'referralPage.howItWorks': 'How it works',
    'referralPage.becomeAConsultant': 'Become a research consultant or service provider',
    'referralPage.refer': 'Refer your first friend',
    'referralPage.friendMentions': 'Your friend includes your user ID when they sign up as a user on the WorldQuant BRAIN platform',
    'referralPage.friendBecomes': 'Your friend becomes a research consultant or service provider',
    'referralPage.friendMakesMoney': 'Your friend submits an alpha on 10 different days as a research consultant or service provider',
    'referralPage.friendRemainsConsultant':
      'Your friend remains as a research consultant or service provider for at least one (1) calendar month',
    'referralPage.youGetPaid':
      'You are eligible to receive $100 once the above criteria have been met and so long as you are also an active ' +
      'research consultant or service provider at such time',

    'referralPage.faqs': 'FAQs',
    'referralPage.faq0.question': 'Who is eligible to refer others through this program?',
    'referralPage.faq0.answer': 'Any BRAIN consultant.',
    'referralPage.faq1.question': 'How do I refer?',
    'referralPage.faq1.answer':
      'If you are a BRAIN research consultant/service provider, the Referee must include your exact WorldQuant ' +
      'BRAIN user ID in the corresponding field during the account creation process on the BRAIN platform, ' +
      'when he/she registers as a user on the BRAIN platform.',
    'referralPage.faq2.question': 'Is there a time limit for anyone I refer to create a BRAIN account so that I am eligible for a payment?',
    'referralPage.faq2.answer': 'No.',
    'referralPage.faq3.question': 'A friend has referred me, when will I get the referral payment?',
    'referralPage.faq3.answer':
      'For referring you, your friend may be eligible for a referral payment. You, too, can refer your friends ' +
      'and potentially earn a referral payment once you are fully approved as a research consultant or service provider.',
    'referralPage.faq4.question': 'My friend forgot to enter me as referrer. What do I do now?',
    'referralPage.faq4.answer':
      'Unfortunately, WorldQuant will not address any errors or mistakes, so you would be unable to earn a referral payment in this case.',
    'referralPage.faq5.question': 'I want to sign up on BRAIN platform. Are there any other benefits?',
    'referralPage.faq5.answer':
      'Visit <linkInNewTabWorldQuantBrain>worldquant.com/brain</linkInNewTabWorldQuantBrain> to learn more about WorldQuant BRAIN.',
    'referralPage.faq6.question': 'How can I redeem my referral payment?',
    'referralPage.faq6.answer':
      'Any referral payment that you successfully earn subject to all of the stated criteria, shall be paid out in connection ' +
      'with your periodic base payments to your verified bank account on file.',
    'referralPage.faq7.question': 'I have shared information about Websim/BRAIN platform in the past, can I refer retrospectively?',
    'referralPage.faq7.answer': 'The referral program is not applicable to referrals made prior to 13 July 2022.',
    'referralPage.faq8.question': 'Is your question not answered in this section?',
    'referralPage.faq8.answer': `You can write to us at <linkMailToSupport>${APP_EMAIL}</linkMailToSupport> and we will be happy to help you.`,
    'referralPage.faq9.question': 'What counts as a successful referral?',
    'referralPage.faq9.answer':
      'See all applicable details on <linkInNewTabReferralAgreement>platform.worldquantbrain.com/agreements/referral-agreement</linkInNewTabReferralAgreement>.',
    'referralPage.faq10.question': 'What can I expect to receive if I successfully refer more than 25 users?',
    'referralPage.faq10.answer':
      'There are no multipliers or additional amounts paid in connection with meeting certain referral thresholds or milestones. ' +
      'Any referral payment will equal USD$200 or USD$100 (as set forth on the official webpage) for each referral, subject to meeting all applicable criteria.',
    'referralPage.faq11.question': 'Can I earn referral fee if I refer my friend to a competition on BRAIN?',
    'referralPage.faq11.answer':
      'Yes, so long as your friend is a new user on the BRAIN platform and includes your exact BRAIN user ID upon registering ' +
      'for an account on the BRAIN platform, among other required criteria.  ',
    'referralPage.faq12.question':
      'I referred my friend for the consultant role but their application was rejected. Will I still receive a referral fee?',
    'referralPage.faq12.answer':
      'No, in a case where you refer a person who does not successfully become a BRAIN research consultant, the criteria necessary ' +
      'to become eligible for a referral payment have not been met and you would not receive any amount in such a case.  There are ' +
      'multiple reasons why someone does not become a research consultant, including without limitation, where that person may have ' +
      'violated the BRAIN platform’s terms and conditions or the user agreement. As a reminder, note that any sharing of actual ' +
      'code is not permitted under the BRAIN platform’s Terms and Conditions and User Agreement.',
    'referralPage.faq13.question':
      'As a BRAIN research consultant, will my earlier referrals allow me to earn a referral payment ' +
      'based on the old referral criteria or the new referral criteria?',
    'referralPage.faq13.answer':
      'For any referred individuals from and after January 28, 2026, ' +
      'you may be eligible to receive a Referral Payment of an amount equal to ' +
      'USD $100 with respect to each referred individual, as set forth below. \n\n' +
      'For any referred individuals who were referred prior to January 28, 2026 and who are fully approved as a ' +
      'research consultant or service provider on or before March 31, 2026, you may be eligible to receive a ' +
      'Referral Payment of an amount equal to USD $200 with respect to each such individual, as set forth below. ' +
      'For the avoidance of doubt, if any referred individual is fully approved from or after ' +
      'April 1, 2026, the Referral Payment shall be equal to USD $100.',
    'referralPage.agreement': 'Referral Agreement',
    'referralPage.share.emailSubject': 'Join me on WorldQuant BRAIN',
    'referralPage.share.emailBody':
      'Hey, I highly recommend checking out WorldQuant BRAIN — the platform that helps you Learn, Earn and ' +
      'Grow in the field of Quantitative Finance. Use my referral code to join:',
    'referralPage.share.facebookQuote': 'Join me on WorldQuant Brain',
    'referralPage.share.facebookHashtag': '#WorldQuantBrain',
    'referralPage.share.linkedinTitle': 'Join me on WorldQuant BRAIN',
    'referralPage.share.linkedinSummary':
      'WorldQuant BRAIN — the platform that helps you Learn, Earn and Grow in the field of Quantitative Finance.',
    'referralPage.share.linkedinSource': 'WorldQuant BRAIN',

    'dataExplorer.filters.search': 'Search',
    'dataExplorer.filters.searchPlaceholder': 'Name, description',
    'dataExplorer.filters.regionLabel': 'Region',
    'dataExplorer.filters.regionsLabel': 'Regions',
    'dataExplorer.filters.datasetsLabel': 'Datasets',
    'dataExplorer.filters.categoryLabel': 'Category',
    'dataExplorer.filters.fieldsLabel': 'Fields',
    'dataExplorer.filters.delayLabel': 'Delay',
    'dataExplorer.filters.universeLabel': 'Universe',
    'dataExplorer.filters.themeLabel': 'Theme',
    'dataExplorer.filters.coverageLabel': 'Coverage',
    'dataExplorer.filters.dateCoverageLabel': 'Date coverage',
    'dataExplorer.filters.turnoverLabel': 'Turnover',
    'dataExplorer.filters.valueScoreLabel': 'Value score',
    'dataExplorer.filters.alphasLabel': 'Alphas',
    'dataExplorer.filters.dateAddedLabel': 'Date added',
    'dataExplorer.filters.lastFieldAddedLabel': 'Last field added',
    'dataExplorer.filters.selectDatesPlaceholder': 'Select dates',
    'dataExplorer.filters.userCountLabel': 'Users',
    'dataExplorer.filters.typeLabel': 'Type',
    'dataExplorer.filters.showMore': 'Show all regions',
    'dataExplorer.filters.showLess': 'Show less regions',
    'dataExplorer.filters.clearAll': 'Clear',
    'dataExplorer.filters.categoryFieldAllLabel': 'All categories',
    'dataExplorer.filters.categoriesModalTitle': 'Categories browser',
    'dataExplorer.filters.categoriesLabel': 'Categories',

    'dataExplorer.dataset.description': 'Dataset description',
    'dataExplorer.dataset.id': 'Dataset ID',
    'dataExplorer.dataset.category': 'Category',
    'dataExplorer.dataset.resources': 'Resources',
    'dataExplorer.dataset.resources.discussion.emoji': '💬',
    'dataExplorer.dataset.resources.discussion.title': 'Forum Posts',
    'dataExplorer.dataset.resources.research.emoji': '📑',
    'dataExplorer.dataset.resources.research.title': 'Research Papers',
    'dataExplorer.dataset.stats': 'Stats',
    'dataExplorer.datasetField.description': 'Field description',
    'dataExplorer.datasetFields.description': 'Description',
    'dataExplorer.datasetFields.id': 'Field',
    'dataExplorer.datasetFields.delay': 'Delay',
    'dataExplorer.datasetFields.type': 'Type',
    'dataExplorer.datasetFields.coverage': 'Coverage',
    'dataExplorer.datasetFields.dateCoverage': 'Date Coverage',
    'dataExplorer.datasetFields.turnoverAndCoverage': 'Turnover (Coverage)',
    'dataExplorer.datasetFields.userCount': 'Users',
    'dataExplorer.datasetFields.valueScore': 'Value Score',
    'dataExplorer.datasetFields.valueRange': 'Value Range',
    'dataExplorer.datasetFields.valueDistribution': 'Value Distribution',
    'dataExplorer.datasetFields.turnover': 'Turnover',
    'dataExplorer.datasetFields.alphaCount': 'Alphas',
    'dataExplorer.datasetFields.dateAdded': 'Date added',
    'dataExplorer.datasetFields.lastFieldAdded': 'Last field added',
    'dataExplorer.datasetFields.name': 'Dataset',
    'dataExplorer.datasetFields.fieldCount': 'Fields',
    'dataExplorer.datasetFields.region': 'Region',
    'dataExplorer.datasetFields.universe': 'Universe',
    'dataExplorer.datasetFields.theme': 'Theme',
    'dataExplorer.datasetFields.resources': 'Resources',
    'dataExplorer.datasetFields.resources.link': '[{index}]',
    'dataExplorer.datasetFields.pyramidMultiplier': 'Pyramid Theme Multiplier',
    'dataExplorer.noFields': 'No fields were found for your query. Try clearing filters or changing region, delay or universe.',
    'dataExplorer.region.USA': 'USA',
    'dataExplorer.region.EUR': 'EUR',
    'dataExplorer.region.ASI': 'ASI',
    'dataExplorer.region.CHN': 'CHN',
    'dataExplorer.stats.datasets': 'datasets',
    'dataExplorer.stats.alphas': 'alphas',
    'dataExplorer.stats.fields': 'fields',
    'dataExplorer.stats.userCount': 'users',
    'dataExplorer.stats.total': 'Total',
    'dataExplorer.stats.new': 'New this month',
    'dataExplorer.breadcrumbs.main': 'Data explorer',
    'dataExplorer.breadcrumbs.browseDatasets': 'Datasets',
    'dataExplorer.breadcrumbs.browseDataFields': 'Fields',
    'dataExplorer.breadcrumbs.searchResult': 'Search result',
    'dataExplorer.tabs.datasets': 'Datasets',
    'dataExplorer.tabs.fields': 'Fields',
    'dataExplorer.tabs.description': 'Description',
    'breadcrumbs.loading': 'Loading',
    'dataExplorer.search.datasets': 'Datasets',
    'dataExplorer.search.fields': 'Fields',
    'dataExplorer.search.fieldValue': '{field} in {dataset}',
    'dataExplorer.search.placeholder': 'Search by dataset name, field name or description',
    'dataExplorer.search.mobilePlaceholder': 'Dataset name, field or description',
    'dataExplorer.search.emptySearch': 'Nothing was found',
    'dataExplorer.search.searchButton': 'Search',
    'dataExplorer.search.error': 'Something went wrong. Please, try again or contact support',
    'dataExplorer.search.allFields': 'Show all matching fields',
    'dataExplorer.search.allDatasets': 'Show all matching datasets',
    'dataExplorer.search.noFields': 'No fields found by quick search',
    'dataExplorer.search.noDatasets': 'No datasets found by quick search',
    'dataExplorer.allFields.seeAllFields': 'See all matching fields in this dataset',
    'dataExplorer.datasets.error': 'An error occurred while loading datasets',
    'dataExplorer.datafields.error': 'An error occurred while loading fields',
    'dataExplorer.datasetTableError': 'An error occurred while loading dataset',
    'dataExplorer.datasetTableError.notFound': 'The dataset was not found',
    'dataExplorer.dataFieldTableError': 'An error occurred while loading field',
    'dataExplorer.dataFieldTableError.notFound': 'The data field was not found',
    'dataExplorer.datasets.noDatasets':
      'No datasets were found for your query. Try clearing filters or changing region, delay or universe.',
    'dataExplorer.searchLimitWarning': 'Only the first 100 results are shown for text search.',
    'dataExplorer.searchLimitError': 'Only the first 100 results are shown for text search. Try using a more specific query.',
    'dataExplorer.field.simulate': 'Simulate Field',
    'dataExplorer.field.openBrainLabs': 'Visualize Field',
    'dataExplorer.field.closeModal': 'Close',

    'dataExplorer.field.labsModalTitle': 'Labs Visualization',
    'dataExplorer.field.labsModalText': 'Field <strong>{fieldId}</strong> visualization is opening in Brain Labs notebook.',
    'dataExplorer.field.labsModalHint': 'Hint',
    'dataExplorer.field.labsModalExplanation': `If you are <strong>not signed</strong> in to BRAIN Labs:
Click <strong>Sign in to BRAIN Labs</strong> and enter your password.
After signing in the field visualization notebook will automatically open in Labs.

If you are already <strong>signed in BRAIN Labs</strong> and have the Labs tab open:
The field visualization notebook will automatically open in existing Labs tab.
You can <strong>Close</strong> this dialog window.`,
    'dataExplorer.field.disabledLabsHint': 'This field is not available in Brain Labs.',
    'dataExplorer.field.labsLoading': 'Loading...',
    'dataExplorer.field.labsDescription':
      'Data field visualization includes: \n' +
      '• What is the range of values and their frequency? \n' +
      '• How do the values vary by sector? \n' +
      '• How does the distribution vary over time? \n' +
      '• How often do values update? \n' +
      '• What % of values are NaN or zero? \n' +
      'And more...',

    'consultant.leaderboard.title': 'Consultant Leaderboard',
    'consultant.leaderboard.title.researcher': 'Consultant (BRAIN Researcher) Leaderboard',
    'consultant.leaderboard.stats': 'Stats',
    'consultant.leaderboard.weightFactor': 'Weight Factor:',
    'consultant.leaderboard.valueFactor': 'Value Factor:',
    'consultant.leaderboard.usedFields': 'Used Data Fields:',
    'consultant.leaderboard.submittedAlphas': 'Alphas Submitted:',
    'consultant.leaderboard.signals': 'Signals:',
    'consultant.leaderboard.pyramids': 'Pyramids Completed:',
    'consultant.leaderboard.combinedAlphaPerformance': 'Combined Alpha Performance:',
    'consultant.leaderboard.combinedSelectedAlphaPerformance': 'Combined Selected Alpha Performance:',

    'geniusCard.title': 'Genius program',
    'geniusCard.stats': 'Stats for the current quarter',
    'geniusCard.level': 'Level: ',
    'geniusCard.all': 'See all',

    'genius.data.comingSoon': 'Pending computation, refreshed monthly.',
    'genius.data.notAvailable': 'N/A',
    'genius.osmosis.title': 'Osmosis Allocation',
    'genius.osmosis.subtitle': 'Min 3 qualifying scopes · 100,000 points + 10 Alphas per scope · More scopes and Alphas can improve score.',
    'genius.osmosis.learnRules': 'Learn Osmosis rules',
    'genius.osmosis.scope': 'Scope',
    'genius.osmosis.osmosisPoints': 'Points Allocated',
    'genius.osmosis.error': 'An error occurred while loading your osmosis allocation data.',

    'alphas.osmosisScale.button': 'Osmosis Scale',
    'alphas.osmosisScale.disabledTooltip':
      'Scale works when you have any scopes with at least 10 Alphas that do not have 100,000 points yet',
    'alphas.osmosisScale.modal.title': 'Scale All Eligible Scopes to 100,000',
    'alphas.osmosisScale.modal.description':
      'You have ≥10 Alphas with Osmosis points allocated in the following scopes. Click to auto-scale to 100,000 Osmosis points.',
    'alphas.osmosisScale.modal.alphasCount': '{count} Alphas',
    'alphas.osmosisScale.modal.cta': 'Scale All to 100,000',
    'alphas.osmosisScale.inProgressTooltip': 'Scaling in progress…',
    'alphas.osmosisScale.flash.started': "Scaling started. We'll notify you when it's done.",
    'alphas.osmosisScale.flash.success': '🎉 All set! Your scopes are now scaled to 100,000.',
    'alphas.osmosisScale.flash.failure': 'Could not scale scopes. Please try again.',
    'alphas.osmosisScale.flash.alreadyRunning': "A scaling job is already running. We'll notify you when it's done.",
    'genius.consultantPerformance.error': 'An error occurred while loading your consultant performance data.',

    'genius.menu.status': 'Status',
    'genius.menu.leaderboard': 'Leaderboard',
    'genius.menu.faq': 'FAQ',

    'genius.quarter.label': 'Displaying quarter:',
    'genius.quarter': '{name}, {startDate} – {endDate}',

    'genius.profile.currentLevel': 'Genius level: ',
    'genius.profile.bestLevel': 'Best level: ',
    'genius.profile.currentQuarterEnd': 'Current quarter end: ',

    'genius.tier.gold': 'Gold',
    'genius.tier.expert': 'Expert',
    'genius.tier.master': 'Master',
    'genius.tier.grandmaster': 'Grandmaster',

    'genius.eligibility.title': 'Eligibility Criteria',
    'genius.eligibility.section.signals': 'Signals',
    'genius.eligibility.section.pyramidsCompleted': 'Pyramids Completed',
    'genius.eligibility.section.combinedAlphaPerformance': 'Combined Alpha Performance',
    'genius.eligibility.section.combinedPowerPoolAlphaPerformance': 'Combined Power Pool Alpha Performance',
    'genius.eligibility.section.combinedSelectedAlphaPerformance': 'Combined Selected Alpha Performance',
    'genius.eligibility.section.combinedOsmosisPerformance': 'Combined Osmosis Performance',
    'genius.eligibility.section.combinedSelectedAlphaPerformance.hint': 'No matching Alphas, refreshed monthly',
    'genius.eligibility.section.combinedPowerPoolAlphaPerformance.hint': 'No matching Alphas, refreshed monthly',
    'genius.eligibility.section.combinedOsmosisPerformance.hint': 'No matching Alphas, refreshed monthly',
    'genius.eligibility.progress.reached': 'Reached {tier}',
    'genius.eligibility.progress.remaining': '{remaining} more to {tier}',

    'genius.tieBreaker.title': 'Tie breaker criteria',
    'genius.tieBreaker.operatorAvg': 'Operators per Alpha',
    'genius.tieBreaker.operatorCount': 'Operators used',
    'genius.tieBreaker.fieldAvg': 'Fields per Alpha',
    'genius.tieBreaker.fieldCount': 'Fields used',
    'genius.tieBreaker.communityActivity': 'Community activity',
    'genius.tieBreaker.completedReferrals': 'Completed referrals',
    'genius.tieBreaker.simulationActivity': 'Simulation activity',
    'genius.tieBreaker.submissionActivity': 'Submission activity',
    'genius.tieBreaker.maxSimulationStreak': 'Max simulation streak',

    'genius.activity.simulation': '{count} {count, plural, one {simulation} other {simulations}}',
    'genius.activity.submission': '{count} {count, plural, one {submission} other {submissions}}',
    'genius.activity.legend.noActivity': 'No activity',
    'genius.activity.legend.simulated': 'Simulated',
    'genius.activity.legend.protectedByFreeze': 'Protected by freeze',
    'genius.activity.freeze.protected': 'Protected by Streak Freeze',

    'genius.alphaPyramids.title': 'Pyramid alpha distribution',
    'genius.alphaPyramids.category': 'Category',
    'genius.alphaPyramids.error': 'An error occurred while loading pyramid data',
    'genius.alphaPyramids.tooltip.submissions': 'Submissions: {count}',
    'genius.alphaPyramids.tooltip.active': 'Active',
    'genius.alphaPyramids.tooltip.inactive': 'Not active',
    'genius.alphaPyramids.tooltip.hint': 'Click to view datasets',

    'genius.pyramidMultipliers.title': 'Pyramid theme multipliers',
    'genius.pyramidMultipliers.category': 'Category',
    'genius.pyramidMultipliers.error': 'An error occurred while loading pyramid data',
    'genius.pyramidMultipliers.tooltip.multiplier': 'Multiplier: <strong>x{multiplier}</strong>',
    'genius.pyramidMultipliers.tooltip.hint': 'Click to view datasets',

    'tutorialNotification.congratulations': '🪄Congratulations! Your alpha has passed all checks!',
    'tutorialNotification.modeLabel': 'Tutorial mode on',
    'tutorialNotification.infoExplanation': 'Your expressions are currently being checked against the Tutorial steps.',
    'tutorialNotification.header': 'Tutorial Checks: {tutorialName}',
    'tutorialNotification.nextTutorial': 'Next tutorial',
    'tutorialNotification.backToTutorial': 'Go back to tutorial',
    'tutorialNotification.exitTutorialMode': 'Exit tutorial mode',
    'tutorialNotification.checks.unmet': 'Tutorial task not met',
    'tutorialNotification.checks.showAll': 'Show all checks',
    'tutorialNotification.checks.showFailChecksOnly': 'Show failing checks only',
    'tutorialNotification.canProceed': 'You can proceed to Tutorial module “{nextTutorialName}” 😊',
    'tutorialNotification.canGoBack': 'You can go back to Tutorial to get some “hint” or “examples”.',
    'tutorialNotification.submitIfYouCan':
      'If you created a submittable alpha, then go ahead and "Submit" so you can move to the next step. If your alpha is not submittable, then revisit previous tutorial lessons to come up with a submittable alpha.',

    'exitTutorialConfirmation.title': 'Exit Tutorial Mode',
    'exitTutorialConfirmation.description.1': 'Are you sure you want to exit tutorial mode?',
    'exitTutorialConfirmation.description.2': 'You can re-enter tutorial mode anytime by navigating to the tutorial panel.',
    'exitTutorialConfirmation.cancel': 'Cancel',
    'exitTutorialConfirmation.exit': 'Exit',

    'navigatorTutorial.nextPage': 'Next',
    'navigatorTutorial.blockedNextHint': 'Complete the task (for example, simulate an Alpha) to proceed.',
    'navigatorTutorial.previousPage': 'Previous',
    'navigatorTutorial.finish': 'Finish',
    'navigatorTutorial.daysHint': 'It is day {daysElapsed} since the start of the tutorial.',
    'navigatorTutorial.daysLeftHint': 'You have {daysLeft} days left to complete it.',
    'navigatorTutorial.challengeHint': `Your score in the 'Challenge' competition. Click to open it in a new window.`,
    'navigatorTutorial.scoreHint': `Required number of Alphas to submit: {minAlphasToSubmit}–{maxAlphasToSubmit} Alphas, depending on individual alpha performance.`,
    'navigatorTutorial.daysToSubmitHint': `Alphas should be submitted on at least {daysToSubmit} separate days.`,
    'navigatorTutorial.learningProgress': 'Chapter progress',
    'navigatorTutorial.reachingGold': 'Reaching gold',
    'navigatorTutorial.showAnswer': 'Show answer',
    'navigatorTutorial.showHint': 'Show hint',

    'navigatorTutorial.taskTitle': '🔥Task: ',
    'navigatorTutorial.completeTaskTitle': '✔️ Completed task: ',
    'navigatorTutorial.answer': 'Answer: ',
    'navigatorTutorial.hint': 'Hint: ',

    'navigatorTutorial.tutorialTitle': 'Welcome to the BRAIN Tutorial 🧑‍🏫🪄',
    'navigatorTutorial.startTutorial': 'Start tutorial ',
    'navigatorTutorial.startText':
      'The Tutorial is a <strong>step-by-step interactive guide</strong> that will lead you through the process of ' +
      '<strong>learning about quantitative finance</strong> and <strong>creating your first Alphas in BRAIN</strong>. There are total 27 modules, each listing the ' +
      'essential information and hands-on exercises that can help you learn and reach your milestones.',
    'navigatorTutorial.timeLimit':
      'You have <strong>30 days (D-30)</strong> to complete this tutorial series, and for those who ' +
      'successfully completes within the deadline would be granted the ' +
      '<strong>“Quantitative Finance Starter Level Certificate” issued by WorldQuant</strong>.',
    'navigatorTutorial.startYourJourney':
      'Start your journey now to earn your first Quant certificate and open the door to much more opportunities!',

    'navigatorTutorial.restartTutorial': 'Restart tutorial',
    'navigatorTutorial.tutorialExpired': 'Oops, your Tutorial deadline expired 😓',
    'navigatorTutorial.tutorialExpiredText': `Your tutorial deadline was on <strong>{expirationDate}</strong> EST.`,
    'navigatorTutorial.youCanRestart':
      'Don’t worry – you can always <strong>restart the Tutorial</strong> ' +
      'from the beginning at any time. Refresh your 30 days count ' +
      'and try again to earn your ' +
      '<strong>“Quantitative Finance Starter Level Certificate” issued by WorldQuant!</strong> 😉',

    'consultantTutorial.startTitle': 'Hello, Consultants!',
    'consultantTutorial.startText1': 'Welcome onboard, and congratulations on becoming a Research Consultant in BRAIN!',
    'consultantTutorial.startText2':
      'This tutorial can help new consultants learn about the basics and the key changes in the platform that is ' +
      'different from when you were a user, as well as periodically updating existing consultants on ' +
      'current major updates in the platform.',
    'consultantTutorial.startText3':
      'There are 4 large chapters and some of the content includes tasks that you need to complete, and by ' +
      'doing so we can help you reach a more advanced level as an active performing consultant.',
    'consultantTutorial.startText4':
      'Once you successfully complete all the tasks, we issue a certificate of accomplishment to your ' +
      'registered email. You can take your time on learning this content, and periodically check your ' +
      'status through the index and the progress bar.',
    'consultantTutorial.startText5':
      'Please note that you do not need to follow the order of the content, and may jump back and forth ' +
      'any content you would like to learn about first. If the tutorial does not interest you, you may ' +
      'switch off the tutorial mode in the simulation notification. You can then resume anytime by clicking ' +
      'the "Tutorial" toggle button in the top-right corner.',

    'consultantTutorial.congratulations': '🎉Congratulations!',
    'consultantTutorial.youHaveCompleted':
      'You have successfully completed all the tasks in the Consultant Tutorial and earned your <strong>Certificate for completing the "Foundational Training for BRAIN Consultants"</strong>!',
    'consultantTutorial.certificateIssued':
      'We have issued your certificate to your registered email account. You can revisit the tutorial content anytime by opening the relevant tab. Thank you.',
    'consultantTutorial.closeTutorial': 'Close Tutorial',
    'consultantTutorial.progress': 'Tutorial progress',

    ...iqcLocaleData['en'],

    'alphathon.openCompetition': 'Enroll',
    'alphathon.emailLabel': 'Email',
    'alphathon.passwordLabel': 'Password',
    'alphathon.subtitle2': "Break into the world of quantitative finance and sign up for WorldQuant BRAIN's {competitionName}.",
    'alphathon.timeline': 'The competition starts on <u>{startDate}</u> and ends on <u>{endDate}</u>.',
    'alphathon.enrollment.ended': 'Enrollment has ended on {signUpEndDate}.',
    'alphathon.enrollment.not.started': 'Enrollment will start on {signUpStartDate}.',
    'alphathon.competition.ended': 'Competition ended on {endDate}.',
    'alphathon.already.have.account': 'Already have an account? Please <alphathonLinkToSignIn>sign in here.</alphathonLinkToSignIn>',
    'simulationTip.title': 'TIP',
    'simulationTipText-0': 'Try submitting Alphas with lower Turnover.',
    'simulationTip-0-Link-0': 'Turnover',
    'simulationTipText-1':
      'Try creating Alphas using Datasets with high Dataset Value Score, to reduce the Prod Correlation (for ex Earnings Datasets, Macro Datasets, Insider Datasets).',
    'simulationTip-1-Link-0': 'Datasets',
    'simulationTip-1-Link-1': 'Earnings Datasets',
    'simulationTip-1-Link-2': 'Macro Datasets',
    'simulationTip-1-Link-3': 'Insider Datasets',
    'simulationTipText-2': 'Explore various Transformational Operators and Cross Sectional Operators.',
    'simulationTip-2-Link-0': 'Transformational Operators',
    'simulationTip-2-Link-1': 'Sectional Operators',
    'simulationTipText-3': 'Experiment with Neutralization Settings. Check out this Forum post.',
    'simulationTip-3-Link-0': 'Forum post',
    'simulationTipText-4': 'Check out these Tips to improve the simulated Returns of the Alphas.',
    'simulationTip-4-Link-0': 'Tips',
    'simulationTipText-5':
      'Truncation helps in controlling the stock weight in the Alpha simulation. Read this Forum post to understand why.',
    'simulationTip-5-Link-0': 'Forum post',
    'simulationTipText-6': 'Try working on Delay 0 Alphas. This Forum post may help you.',
    'simulationTip-6-Link-0': 'Forum post',
    'simulationTipText-7':
      'Check out the Learn section on SuperAlpha and helpful Tips to construct SuperAlphas and potentially increase your compensation!',
    'simulationTip-7-Link-0': 'SuperAlpha',
    'simulationTip-7-Link-1': 'helpful Tips',
    'simulationTipText-8': 'Automate your research, check out Brain API.',
    'simulationTip-8-Link-0': 'Brain API',
    'simulationTipText-9': 'Check out Getting Started page and Courses to boost your knowledge for Alpha research!',
    'simulationTip-9-Link-0': 'Getting Started',
    'simulationTip-9-Link-1': 'Courses',
    'simulationTipText-10': 'Explore Vector Datafields, for example Social Media, for more info check page on Vector Datafields.',
    'simulationTip-10-Link-0': 'Social Media',
    'simulationTip-10-Link-1': 'page on Vector Datafields',
    'simulationTipText-11':
      'Explore Group Datafields - create your own groups for Alpha Neutralization, for more info check Documentation.',
    'simulationTip-11-Link-0': 'Documentation',
    'simulationTipText-12':
      'Try ensuring coverage by backfilling Datafields and the final Alpha using Operators such as ts_backfill, group_backfill, group_extra.',
    'simulationTip-12-Link-0': 'backfilling',
    'simulationTip-12-Link-1': 'ts_backfill',
    'simulationTip-12-Link-2': 'group_backfill',
    'simulationTip-12-Link-3': 'group_extra',
    'simulationTipText-13': 'Try using exit triggers (e.g. stop-loss) to close position while using trade_when Operator.',
    'simulationTip-13-Link-0': 'trade_when Operator',
    'simulationTipText-14':
      'Try out Model Datasets. You should start by looking for fields with the words “rate” or “rank” in their names - maybe it is already an Alpha?',
    'simulationTip-14-Link-0': 'Model Datasets',
    'simulationTipText-15':
      'PE ratio can be a good measurement to generate Alphas. Calculate estimated PE ratio using EPS estimates of either EPS Estimate Model Dataset or Scorings Dataset and price fields of basedata (Price Volume Data for Equity) ',
    'simulationTip-15-Link-0': 'EPS Estimate Model Dataset',
    'simulationTip-15-Link-1': 'Scorings Dataset',
    'simulationTip-15-Link-2': 'Price Volume Data for Equity',
    'simulationTipText-16': 'You may utilize the seasonality Datafields in Research Indicators to improve details in your ideas/signals.',
    'simulationTip-16-Link-0': 'Research Indicators',
    'simulationTipText-17':
      'Country and Sector Neutralizations generally both work well, though we recommend you to try other groups as well.',
    'simulationTipText-18':
      'Along with close or returns, it turns out that using vwap (Volume Weighted Average Price) with your Alpha also tends to give good results.',
    'simulationTipText-19':
      'To achieve reasonable Margin rates, you are advised to use the following Operators: hump_decay, ts_decay_linear, and ts_decay_exp_window.',
    'simulationTipText-20':
      'Social Sentiment indicators help investors identify information in social media that could cause a stock’s price to increase or decrease in the near future - take a look at Social Media Datasets and experiment with them in your Alphas!',
    'simulationTip-20-Link-0': 'Social Media Datasets',
    'simulationTipText-21':
      'Use Ravenpack News Data to develop a wide variety of Alphas - momentum, event based or D0 Alphas with high Sharpe and Turnover.',
    'simulationTip-21-Link-0': 'Ravenpack News Data',
    'simulationTipText-22':
      "Check out Model Datasets - try to compare model's predictions with returns using ts_corr and ts_regression Operators!",
    'simulationTip-22-Link-0': 'Model Datasets',
    'simulationTipText-23':
      'Check out Analyst Datasets - try to capture direct and indirect signals to predict returns: how does the Datafield changes affects returns? which fields directly correlate with returns?',
    'simulationTip-23-Link-0': 'Analyst Datasets',
    'simulationTipText-24':
      'You have an option to use Option Dataset! OptionBreakeven, CallBreakeven, and PutBreakeven can be used to measure the pricing tension between the buyer and seller.',
    'simulationTip-24-Link-0': 'Option Dataset',
    'simulationTipText-25': 'Submit 4 Alphas and, if available, 1 SuperAlpha, each day, to improve the Quantity Factor of your score.',
    'simulationTipText-26': 'Submit Alphas with low Correlation to your other Alphas.',
    'simulationTipText-27': 'Diversify your Alphas, use larger Universes, different Regions (esp. non-US) and delays',
    'simulationTipText-28': 'Try less explored Datasets or old Datasets but using new ideas.',
    'simulationTipText-29':
      'Try reading new research papers, blogs and apply these ideas in the Alpha expression, check out Research Papers for Consultants.',
    'simulationTip-29-Link-0': 'Research Papers for Consultants',
    'simulationTipText-30': 'Check out the alpha examples here. Can you improve these alphas and submit?',
    'simulationTip-30-Link-0': 'here',
    'simulationTipText-31': 'Submit Alphas that retain at least 70% of their Sharpe in the Sub-Universe or Super-Universe.',
    'simulationTipText-32':
      'Focus on improving Alphas by refining your ideas, not by adding or fitting parameters, factors or reversion elements.',
    'simulationTipText-33':
      'Restrict your parameter search to simple & reasonable ones. For example 5, 20, 60, 120, 252 in case of days, instead of 37, 14 etc.',
    'simulationTipText-34':
      'Novelty of ideas will help you reduce correlation with others work. Try Operators & Settings you haven’t used before. Detailed documentation on Operators is available here : Detailed Operator Descriptions.',
    'simulationTip-34-Link-0': 'Detailed Operator Descriptions',
    'simulationTipText-35': 'Try using x = ts_step(1) Operator as a parameter in ts_regression, then x will be time variable.',
    'simulationTipText-36': 'Use trade_when or hump Operators to reduce Turnover of your Alphas.',
    'simulationTipText-37': 'Use days_from_last_change() Operator to catch fast decaying signals.',
    'simulationTipText-38':
      'Try to reduce Turnover of illiquid part of the Universe by using Operator rank(). As a proxy for liquidity you can use cap or average volume.',
    'simulationTipText-39': 'Try to use bucket() Operator to neutralize your Alpha using custom groups.\n',
    'simulationTip-39-Link-0': 'bucket()',
    'simulationTipText-40': 'Try to use vector_neut Operator to neutralize your signal to market factors.',
    'simulationTip-40-Link-0': 'vector_neut',
    'simulationTipText-41': 'Try to compare Broker Estimates with company fundamentals to create an Alpha!',
    'simulationTip-41-Link-0': 'Broker Estimates',
    'simulationTipText-42':
      'Company Fundamental Data For Equity have well structured Datafields which are mostly scores, you can use common Time Series Operators like ts_rank, ts_zscore or measuring the ts_delta of the fields.',
    'simulationTip-42-Link-0': 'Fundamental Data For Equity',
    'simulationTipText-43':
      "Try using Employee Data to evaluate company well-being (how does company's care for employees impact it's performance?)",
    'simulationTip-43-Link-0': 'Employee Data',

    'alphaDistribution.title': 'Distribution of Active Alphas',
    'alphaDistribution.alphas': 'Alphas',
    'alphaDistribution.errorLoading':
      'An error occurred while loading the Alpha distribution. Please check your connection or try again later.',
    'alphaDistribution.selectClassification': 'Select at least one classification to display Alpha distribution.',
    'alphaDistribution.emptyResponse': 'No active Alphas.',
    'alphaDistribution.dataCategory': 'Data category',
    'alphaDistribution.addClassification': 'Add classification',
    'alphaDistribution.ofAllAlphas': 'of all Alphas',
    'alphaDistribution.of': 'of',
    'alphaDistribution.theLimitOf': 'the limit of {value}.',
    'alphaDistribution.over': 'Over',
    'alphaDistribution.under': 'Under',
    'alphaDistribution.overLowerLimit': 'This pyramid will be enabled when under {value}%.',

    'alphaActivity.title': 'Alpha Simulation Activity',

    ...consultantLandingLocaleData['en'],

    'signUpWizard.videoTitle': 'Everything you need to start {br} Your quant journey on BRAIN for free',
    'signUpWizard.navigationBlock': 'Are you sure you want to leave this page? Unsaved data may be lost.',
    'signUpWizard.alreadyHaveAccount': 'Already have an account?',
    'signUpWizard.signIn': 'Sign In',
    'signUpWizard.signUp': 'Sign Up',
    'signUpWizard.next': 'Next',
    'signUpWizard.back': 'Back',
    'userAgreement.pleaseReadAgreement': 'Please read the following agreements carefully and scroll down to the end.',
    'userAgreement.readAgreementError': 'Read the agreement carefully and scroll down to the end',
    'userAgreement.next': 'Next',
    'userAgreement.title': 'WorldQuant BRAIN Agreements',
    'navigationBlock.message': 'You have unsaved changes, are you sure you want to leave?',

    'goldTier.modal.title': 'Congratulations!',
    'goldTier.modal.subtitle': "You've reached Gold and have now moved into the country-level Challenge leaderboard.",
    'goldTier.modal.body.dimensions': 'You are now scored across three new dimensions — IS Score, Uniqueness, and Days of Submission.',
    'goldTier.modal.body.consultant': 'Top performers are eligible to receive an invitation to become a Research Consultant.',
    'goldTier.modal.close': 'Close',
    'goldTier.modal.cta': 'Challenge Leaderboard',

    'streak.modal.streakDays': 'day streak on ',
    'streak.modal.wqBrain': 'WorldQuant BRAIN!',
    'streak.modal.freeze.available': '1 streak freeze available this quarter',
    'streak.modal.freeze.used': 'Streak freeze used this quarter',
    'streakFreezeUnlock.modal.title': "You've unlocked a Streak Freeze",
    'streakFreezeUnlock.modal.body':
      "As a Consultant, you get one streak freeze each quarter. If you miss a day, we'll automatically cover it — no action needed. Unused freezes don't carry over; you'll get a new one next quarter.",
    'streakFreezeUnlock.modal.geniusLink':
      '<linkInNewTabLearnBrainGenius>Learn how your simulation streak impacts your Genius tier</linkInNewTabLearnBrainGenius>',
    'streakFreezeUnlock.modal.gotIt': 'Got it',
    'streakProtected.modal.title': 'Your streak was <highlight>protected</highlight>!',
    'streakProtected.modal.body':
      'You missed a day, but your streak freeze covered it automatically. This was your only freeze for the quarter. The freeze renews next quarter.',
    'streakProtected.modal.gotIt': 'Got it',
    'streaks.statusMessage.current.start': 'Streak: ',
    'streaks.statusMessage.current.end': ' day',
    'streaks.statusMessage.max.start': ' Longest Streak: ',
    'streaks.statusMessage.max.end': '.',
    'streaks.statusMessage.simulate': ' Simulate today to extend!',
    'streaks.statusMessage.tooltip': 'Consecutive days of running simulations',

    'streak.modal.close': 'Cool!',

    'streak.modal.congratulations.1': "Well done on starting your simulation streak! Let's keep this momentum going!",
    'streak.modal.congratulations.2': "Good job, you're building momentum. Keep it up!",
    'streak.modal.congratulations.3': "Three-day streak! You're establishing a routine. Keep going!",
    'streak.modal.congratulations.consultant.3': "Three-day streak! You're establishing a routine. Keep going!",
    'streak.modal.congratulations.user.3': 'Congratulations, you are among the top one-third of BRAIN users in streaks. Keep going!',
    'streak.modal.congratulations.4': 'Four days in a row! Your commitment is starting to show.',
    'streak.modal.congratulations.5': "Five-day streak! You're making impressive progress.",
    'streak.modal.congratulations.user.5': "You're on fire with your consecutive simulations. Keep the streak alive.",
    'streak.modal.congratulations.consultant.5': "You're on fire with your consecutive simulations. Keep the streak alive.",
    'streak.modal.congratulations.6': 'Six days strong! Your diligence is paying off.',
    'streak.modal.congratulations.7': "A whole week! Fantastic effort. Let's aim for two!",
    'streak.modal.congratulations.consultant.7': '7-day streak! Your consistency is exactly what top consultants are made of!',
    'streak.modal.congratulations.8': 'Day 8! Persistence is the key to success. Keep going.',
    'streak.modal.congratulations.9': 'Nine days and counting. Your consistency is admirable.',
    'streak.modal.congratulations.user.10': "With a 10-day simulation streak, you're among the top 10%. Well done!",
    'streak.modal.congratulations.consultant.10': 'Only 1 in 5 consultants make it to 10 day simulation streak. Well done!',
    'streak.modal.congratulations.11': "Day 11! You're moving forward with impressive speed.",
    'streak.modal.congratulations.12': '12-day streak! Your dedication is shining through.',
    'streak.modal.congratulations.13': 'Lucky 13! Each day brings you closer to your goals.',
    'streak.modal.congratulations.14': 'Two full weeks! Your streak is a testament to your hard work.',
    'streak.modal.congratulations.consultant.14':
      "Two full weeks! You're well on your way to maximizing your simulation streak score in Genius.",
    'streak.modal.congratulations.15': "Half a month! You're setting a high bar. Let's keep it up!",
    'streak.modal.congratulations.16': 'Sixteen days and going strong. Amazing job!',
    'streak.modal.congratulations.17': 'Day 17! Each day is a new achievement. Keep going.',
    'streak.modal.congratulations.18': "Eighteen-day streak! Let's keep this momentum up.",
    'streak.modal.congratulations.19': 'Nineteen days in a row! Your commitment is inspiring.',
    'streak.modal.congratulations.20': 'Impressive! You’re on a roll and your simulation streak is a testament to your persistence!',
    'streak.modal.congratulations.21': 'Three full weeks! Incredible consistency. Keep it up!',
    'streak.modal.congratulations.22': 'Day 22! Your daily contributions are making a difference.',
    'streak.modal.congratulations.23': '23-day streak! Your dedication is leading to great results.',
    'streak.modal.congratulations.24': '24 days and counting. Your streak is impressive.',
    'streak.modal.congratulations.25': 'A quarter of the way to 100! Your determination is commendable.',
    'streak.modal.congratulations.26': '26 days strong! Keep pushing forward.',
    'streak.modal.congratulations.27': 'Day 27! Every day is a step towards success.',
    'streak.modal.congratulations.28': '4 full weeks! Your consistency is key to your progress.',
    'streak.modal.congratulations.29': "29-day streak! You're just one day away from a month-long streak.",
    'streak.modal.congratulations.user.30': 'A whole month! This is a fantastic achievement. Keep up the excellent work!',
    'streak.modal.congratulations.consultant.30': 'Simulating like a pro! Your commitment is truly commendable!',

    'streak.modal.congratulations.long.0': 'Stellar! Your ongoing streak is a grand achievement. Keep it up!',
    'streak.modal.congratulations.long.1': 'Incredible! Your dedication keeps pushing this streak further. Keep up the amazing work!',
    'streak.modal.congratulations.long.2': 'Fantastic achievement! Your streak is a testament to your perseverance and consistency.',
    'streak.modal.congratulations.long.3': 'Amazing job! Your ever-growing streak is a true reflection of your hard work and resilience.',
    'streak.modal.congratulations.long.4': 'Impressive! Seeing your streak extend is a wonderful testament to your commitment.',
    'streak.modal.congratulations.long.5': "Bravo! You're in a league of your own with such a long streak. Keep going!",
    'streak.modal.congratulations.long.6': 'Exceptional! Your consistent streak is truly inspiring. Keep up the excellent effort!',
    'streak.modal.congratulations.long.7': 'Superb work! Your continued dedication is pushing your streak to greater heights.',
    'streak.modal.congratulations.long.8': "You're making a difference with your long streak! Your dedication shines through.",
    'streak.modal.congratulations.long.9': 'Unstoppable! Your streak continues to grow. Your consistency is commendable.',

    'operatorExplorer.errorFetching': 'An error occurred while loading operators',
    'operatorExplorer.operator': 'Operator',
    'operatorExplorer.scope': 'Scope',
    'operatorExplorer.scopeLabel': 'Scope:',
    'operatorExplorer.definition': 'Definition',
    'operatorExplorer.description': 'Description',
    'operatorExplorer.showMore': 'Show more',
    'operatorExplorer.showLess': 'Show less',
    'operatorExplorer.searchOperators': 'Search operators',
    'operatorExplorer.selectScope': 'Selected scope',
    'operatorExplorer.header': 'Unlock more complex operators at Expert, Master and Grandmaster Genius levels.',

    'operatorExplorer.level.all': 'base',
    'operatorExplorer.levelHint.all': 'Available to all users',
    'operatorExplorer.level.genius': 'genius',
    'operatorExplorer.levelHint.genius': 'Only available to a certain level of Genius consultants',
  },
};

export const datesForHighCharts: any = {
  fr: {
    months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
    weekdays: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    shortMonths: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Jui', 'Juil', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'],
  },
  en: {
    weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  },
  pt: {
    weekdays: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
    months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    shortMonths: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dec'],
  },
};
